// @ts-nocheck
import { GraphQLClient, RequestOptions } from 'graphql-request';
import { gql } from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AccountPortalDynamicPageAfterDynamicZoneInput: { input: any; output: any; }
  AccountPortalDynamicPageBeforeDynamicZoneInput: { input: any; output: any; }
  AccountPortalDynamicPageBodyDynamicZoneInput: { input: any; output: any; }
  BlogPostDynamicBodyDynamicZoneInput: { input: any; output: any; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  DynamicPageBodyDynamicZoneInput: { input: any; output: any; }
  HomepageBodyDynamicZoneInput: { input: any; output: any; }
  I18NLocaleCode: { input: any; output: any; }
  JSON: { input: {}; output: {}; }
  Upload: { input: any; output: any; }
};

export type AccountPortalDynamicPage = {
  __typename?: 'AccountPortalDynamicPage';
  after?: Maybe<Array<Maybe<AccountPortalDynamicPageAfterDynamicZone>>>;
  before?: Maybe<Array<Maybe<AccountPortalDynamicPageBeforeDynamicZone>>>;
  body?: Maybe<Array<Maybe<AccountPortalDynamicPageBodyDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<AccountPortalDynamicPageRelationResponseCollection>;
  path: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type AccountPortalDynamicPageLocalizationsArgs = {
  filters?: InputMaybe<AccountPortalDynamicPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AccountPortalDynamicPageAfterDynamicZone = ComponentSharedButton | ComponentSharedContent | ComponentSharedFaq | ComponentSharedHeader | ComponentSharedHeaderVideo | ComponentSharedImage | ComponentSharedParagraph | ComponentSharedSideTextAndImage | ComponentSharedTasksRulesWidget | ComponentSharedTextBlock | ComponentSharedTextWidget | ComponentSharedVideo | ComponentSharedYouTubeVideo | Error;

export type AccountPortalDynamicPageBeforeDynamicZone = ComponentSharedButton | ComponentSharedContent | ComponentSharedFaq | ComponentSharedHeader | ComponentSharedImage | ComponentSharedParagraph | ComponentSharedSideTextAndImage | ComponentSharedTasksRulesWidget | ComponentSharedTextBlock | ComponentSharedTextWidget | ComponentSharedVideo | ComponentSharedYouTubeVideo | Error;

export type AccountPortalDynamicPageBodyDynamicZone = ComponentSharedButton | ComponentSharedContent | ComponentSharedFaq | ComponentSharedHeader | ComponentSharedImage | ComponentSharedLink | ComponentSharedMedia | ComponentSharedNavbar | ComponentSharedPageNavigation | ComponentSharedParagraph | ComponentSharedSideTextAndImage | ComponentSharedTasksRulesWidget | ComponentSharedTextBlock | ComponentSharedTextWidget | ComponentSharedVideo | ComponentSharedYouTubeVideo | Error;

export type AccountPortalDynamicPageEntity = {
  __typename?: 'AccountPortalDynamicPageEntity';
  attributes?: Maybe<AccountPortalDynamicPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AccountPortalDynamicPageEntityResponse = {
  __typename?: 'AccountPortalDynamicPageEntityResponse';
  data?: Maybe<AccountPortalDynamicPageEntity>;
};

export type AccountPortalDynamicPageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AccountPortalDynamicPageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<AccountPortalDynamicPageFiltersInput>;
  not?: InputMaybe<AccountPortalDynamicPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AccountPortalDynamicPageFiltersInput>>>;
  path?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type AccountPortalDynamicPageInput = {
  after?: InputMaybe<Array<Scalars['AccountPortalDynamicPageAfterDynamicZoneInput']['input']>>;
  before?: InputMaybe<Array<Scalars['AccountPortalDynamicPageBeforeDynamicZoneInput']['input']>>;
  body?: InputMaybe<Array<Scalars['AccountPortalDynamicPageBodyDynamicZoneInput']['input']>>;
  path?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AccountPortalDynamicPageRelationResponseCollection = {
  __typename?: 'AccountPortalDynamicPageRelationResponseCollection';
  data: Array<AccountPortalDynamicPageEntity>;
};

export enum AccountPrivacy {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Activity = {
  __typename?: 'Activity';
  aggregates: Array<Aggregate>;
  coins: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  difficulty: Scalars['Int']['output'];
  distance?: Maybe<Scalars['Int']['output']>;
  duration: Scalars['Float']['output'];
  experience: Scalars['Int']['output'];
  ftp?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use workout field */
  interval?: Maybe<UserInterval>;
  mode?: Maybe<ActivityMode>;
  originalActivityId?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Route>;
  sourceType?: Maybe<ActivitySourceType>;
  startUTC: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
  timezoneOffset: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  workout?: Maybe<WorkoutDetail>;
};

export type ActivityAggregate = {
  __typename?: 'ActivityAggregate';
  avg?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type ActivityAggregates = {
  __typename?: 'ActivityAggregates';
  altM?: Maybe<ActivityAggregate>;
  cadRPM?: Maybe<ActivityAggregate>;
  hr?: Maybe<ActivityAggregate>;
  pwrW?: Maybe<ActivityAggregate>;
  spdMs?: Maybe<ActivityAggregate>;
};

export type ActivityDetail = {
  __typename?: 'ActivityDetail';
  aggregates: Array<Aggregate>;
  bike?: Maybe<Scalars['String']['output']>;
  checkStatus?: Maybe<Scalars['String']['output']>;
  coins: Scalars['Int']['output'];
  drafting?: Maybe<Scalars['Boolean']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  eventSessionId?: Maybe<Scalars['String']['output']>;
  experience?: Maybe<Scalars['Int']['output']>;
  failedValidators?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hourOffset?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imported?: Maybe<Scalars['Boolean']['output']>;
  indoor?: Maybe<Scalars['Boolean']['output']>;
  instantRideId?: Maybe<Scalars['String']['output']>;
  invalidStravaSegments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  laps?: Maybe<Array<Maybe<ActivityLap>>>;
  legacyRoute?: Maybe<Route>;
  media: Array<Scalars['String']['output']>;
  nearbyRiders: Array<NearbyRider>;
  pacedRideId?: Maybe<Scalars['String']['output']>;
  pauses?: Maybe<Array<Maybe<ActivityPause>>>;
  phase?: Maybe<Scalars['String']['output']>;
  pinTeleportUsed?: Maybe<Scalars['Boolean']['output']>;
  powerSavingPercentage?: Maybe<Scalars['Float']['output']>;
  realityLevelModified?: Maybe<Scalars['Boolean']['output']>;
  routeCompletionPercentage?: Maybe<Scalars['Float']['output']>;
  routeEstimatedTimeSec?: Maybe<Scalars['Float']['output']>;
  routeId?: Maybe<Scalars['String']['output']>;
  sensors?: Maybe<ActivitySensors>;
  sport?: Maybe<SportType>;
  startUTC?: Maybe<Scalars['Date']['output']>;
  timeseries?: Maybe<Array<Maybe<ActivityTimeSeries>>>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<ActivityTotal>;
  training?: Maybe<ActivityTraining>;
  user?: Maybe<ActivityUser>;
  workout?: Maybe<WorkoutDetail>;
  workoutCompletion?: Maybe<Scalars['String']['output']>;
  workoutId?: Maybe<Scalars['String']['output']>;
};

export type ActivityDetailsResponse = {
  __typename?: 'ActivityDetailsResponse';
  /** @deprecated will be removed in future */
  count: Scalars['Int']['output'];
  items: Array<ActivityDetail>;
};

export type ActivityLap = {
  __typename?: 'ActivityLap';
  aggrs?: Maybe<ActivityAggregates>;
  distM?: Maybe<Scalars['Float']['output']>;
  elapsedTimeSec?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startOffsetM?: Maybe<Scalars['Float']['output']>;
  startOffsetSec?: Maybe<Scalars['Float']['output']>;
};

export enum ActivityMode {
  Normal = 'normal',
  Timetrial = 'timetrial'
}

export enum ActivityOrderBy {
  StartUtc = 'startUTC'
}

export enum ActivityOrderDir {
  Asc = 'asc',
  Desc = 'desc'
}

export type ActivityPause = {
  __typename?: 'ActivityPause';
  elapsedTimeSec?: Maybe<Scalars['Float']['output']>;
  startOffsetSec?: Maybe<Scalars['Float']['output']>;
};

export type ActivitySensor = {
  __typename?: 'ActivitySensor';
  attrs: Array<Scalars['Int']['output']>;
  battery?: Maybe<Scalars['Int']['output']>;
  hwRec?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  protocol?: Maybe<Scalars['String']['output']>;
  serial?: Maybe<Scalars['String']['output']>;
  swRev?: Maybe<Scalars['String']['output']>;
  trainer?: Maybe<Scalars['Boolean']['output']>;
};

export type ActivitySensors = {
  __typename?: 'ActivitySensors';
  sensors?: Maybe<Array<Maybe<ActivitySensor>>>;
  sources?: Maybe<ActivitySources>;
  spd2pwr?: Maybe<Scalars['String']['output']>;
};

export enum ActivitySourceType {
  Groupride = 'groupride',
  Outdoor = 'outdoor',
  Pacedride = 'pacedride',
  Race = 'race',
  Ride = 'ride',
  Route = 'route',
  Workout = 'workout'
}

export type ActivitySources = {
  __typename?: 'ActivitySources';
  cad?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hr?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pwr?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  res?: Maybe<Scalars['String']['output']>;
  spd?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ActivityStravaSegment = {
  __typename?: 'ActivityStravaSegment';
  averageGrade?: Maybe<Scalars['Float']['output']>;
  averageWatts?: Maybe<Scalars['Float']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  elapsedTime?: Maybe<Scalars['Int']['output']>;
  endLatLng?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  hasAchievedKOM?: Maybe<Scalars['Boolean']['output']>;
  hasAchievedPR?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  segmentId: Scalars['ID']['output'];
  startLatLng?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type ActivityTimeSeries = {
  __typename?: 'ActivityTimeSeries';
  key?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type ActivityTotal = {
  __typename?: 'ActivityTotal';
  IF?: Maybe<Scalars['Float']['output']>;
  NP?: Maybe<Scalars['Float']['output']>;
  PP?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  TSS?: Maybe<Scalars['Float']['output']>;
  aggrs?: Maybe<ActivityAggregates>;
  distM?: Maybe<Scalars['Float']['output']>;
  elapsedTimeSec?: Maybe<Scalars['Float']['output']>;
  elevM?: Maybe<Scalars['Float']['output']>;
  hists?: Maybe<ActivityZones>;
  kCal?: Maybe<Scalars['Float']['output']>;
  kJ?: Maybe<Scalars['Float']['output']>;
  movingTimeSec?: Maybe<Scalars['Float']['output']>;
  surgesCnt?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  zeroWTimeSec?: Maybe<Scalars['Int']['output']>;
};

export enum ActivityTraining {
  DistanceWorkout = 'distanceWorkout',
  FreeWorkout = 'freeWorkout',
  Freeride = 'freeride',
  GroupRide = 'groupRide',
  PacedRide = 'pacedRide',
  Race = 'race',
  Route = 'route',
  RouteTimetrial = 'routeTimetrial',
  Workout = 'workout',
  WorkoutFtpTest = 'workoutFtpTest'
}

export type ActivityUser = {
  __typename?: 'ActivityUser';
  FTP?: Maybe<Scalars['Float']['output']>;
  appType?: Maybe<Scalars['String']['output']>;
  appVer?: Maybe<Scalars['String']['output']>;
  ar?: Maybe<Scalars['Boolean']['output']>;
  careerFTP?: Maybe<Scalars['Float']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  firebaseUID?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Coordinates>;
  userInfo: UserInfo;
  weightKg?: Maybe<Scalars['Float']['output']>;
  zones?: Maybe<ActivityZones>;
};

export type ActivityZones = {
  __typename?: 'ActivityZones';
  hr?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  pwr?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type Aggregate = {
  __typename?: 'Aggregate';
  avg: Scalars['Float']['output'];
  type: AggregateType;
};

export enum AggregateType {
  Power = 'POWER',
  Speed = 'SPEED'
}

export type Ambassador = {
  __typename?: 'Ambassador';
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  routes: Array<Route>;
};

export type AmbassadorByIdInput = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type Author = {
  __typename?: 'Author';
  SEO?: Maybe<ComponentSharedSeo>;
  blog_posts?: Maybe<BlogPostRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<AuthorRelationResponseCollection>;
  name: Scalars['String']['output'];
  perex?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<UploadFileRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  socialPlatform?: Maybe<Array<Maybe<ComponentSharedSocialPlatform>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type AuthorBlog_PostsArgs = {
  filters?: InputMaybe<BlogPostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AuthorLocalizationsArgs = {
  filters?: InputMaybe<AuthorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AuthorProfilePhotoArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AuthorSocialPlatformArgs = {
  filters?: InputMaybe<ComponentSharedSocialPlatformFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AuthorEntity = {
  __typename?: 'AuthorEntity';
  attributes?: Maybe<Author>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AuthorEntityResponse = {
  __typename?: 'AuthorEntityResponse';
  data?: Maybe<AuthorEntity>;
};

export type AuthorFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<AuthorFiltersInput>>>;
  blog_posts?: InputMaybe<BlogPostFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  jobTitle?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<AuthorFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<AuthorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AuthorFiltersInput>>>;
  perex?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  socialPlatform?: InputMaybe<ComponentSharedSocialPlatformFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type AuthorInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  blog_posts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  perex?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  socialPlatform?: InputMaybe<Array<InputMaybe<ComponentSharedSocialPlatformInput>>>;
};

export type AuthorRelationResponseCollection = {
  __typename?: 'AuthorRelationResponseCollection';
  data: Array<AuthorEntity>;
};

export type AvatarPart = {
  __typename?: 'AvatarPart';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<AvatarPartRelationResponseCollection>;
  originalDescription?: Maybe<Scalars['String']['output']>;
  originalImage?: Maybe<Scalars['String']['output']>;
  originalTitle?: Maybe<Scalars['String']['output']>;
  partId: Scalars['ID']['output'];
  preview?: Maybe<Scalars['Boolean']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type AvatarPartLocalizationsArgs = {
  filters?: InputMaybe<AvatarPartFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AvatarPartEntity = {
  __typename?: 'AvatarPartEntity';
  attributes?: Maybe<AvatarPart>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AvatarPartEntityResponse = {
  __typename?: 'AvatarPartEntityResponse';
  data?: Maybe<AvatarPartEntity>;
};

export type AvatarPartFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AvatarPartFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<AvatarPartFiltersInput>;
  not?: InputMaybe<AvatarPartFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AvatarPartFiltersInput>>>;
  partId?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type AvatarPartInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  partId?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AvatarPartRelationResponseCollection = {
  __typename?: 'AvatarPartRelationResponseCollection';
  data: Array<AvatarPartEntity>;
};

export type BlogCategory = {
  __typename?: 'BlogCategory';
  SEO: ComponentSharedSeo;
  blog_posts?: Maybe<BlogPostRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<BlogCategoryRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type BlogCategoryBlog_PostsArgs = {
  filters?: InputMaybe<BlogPostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BlogCategoryLocalizationsArgs = {
  filters?: InputMaybe<BlogCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogCategoryEntity = {
  __typename?: 'BlogCategoryEntity';
  attributes?: Maybe<BlogCategory>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type BlogCategoryEntityResponse = {
  __typename?: 'BlogCategoryEntityResponse';
  data?: Maybe<BlogCategoryEntity>;
};

export type BlogCategoryFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<BlogCategoryFiltersInput>>>;
  blog_posts?: InputMaybe<BlogPostFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<BlogCategoryFiltersInput>;
  not?: InputMaybe<BlogCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BlogCategoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BlogCategoryInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  blog_posts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BlogCategoryRelationResponseCollection = {
  __typename?: 'BlogCategoryRelationResponseCollection';
  data: Array<BlogCategoryEntity>;
};

export type BlogPost = {
  __typename?: 'BlogPost';
  SEO: ComponentSharedSeo;
  author?: Maybe<AuthorEntityResponse>;
  blog_category?: Maybe<BlogCategoryEntityResponse>;
  blog_tags?: Maybe<BlogTagRelationResponseCollection>;
  body?: Maybe<Scalars['String']['output']>;
  contentLayers?: Maybe<ComponentSharedContentLayers>;
  cover: UploadFileEntityResponse;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dynamicBody?: Maybe<Array<Maybe<BlogPostDynamicBodyDynamicZone>>>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<BlogPostRelationResponseCollection>;
  perex: Scalars['String']['output'];
  publishDate: Scalars['DateTime']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  structuredDataHeadline?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type BlogPostBlog_TagsArgs = {
  filters?: InputMaybe<BlogTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BlogPostLocalizationsArgs = {
  filters?: InputMaybe<BlogPostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogPostDynamicBodyDynamicZone = ComponentSharedBlogPosts | ComponentSharedChallenges | ComponentSharedChecklist | ComponentSharedCompanionAppCta | ComponentSharedEvents | ComponentSharedFaq | ComponentSharedFeaturedLogo | ComponentSharedHighlights | ComponentSharedLinksCarousel | ComponentSharedLogoClouds | ComponentSharedNavbar | ComponentSharedNewsletterCta | ComponentSharedPageNavigation | ComponentSharedPlansSelector | ComponentSharedPricing | ComponentSharedPrizes | ComponentSharedProductsComparison | ComponentSharedRegisterCta | ComponentSharedRoutesSection | ComponentSharedSimpleCta | ComponentSharedSpotlights | ComponentSharedSpotlightsList | ComponentSharedSteps | ComponentSharedStripe | ComponentSharedTestimonialsSection | ComponentSharedTextBlock | ComponentSharedTwoColumnsContent | ComponentSharedWorkoutsSection | ComponentSharedYouTubeVideo | Error;

export type BlogPostEntity = {
  __typename?: 'BlogPostEntity';
  attributes?: Maybe<BlogPost>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type BlogPostEntityResponse = {
  __typename?: 'BlogPostEntityResponse';
  data?: Maybe<BlogPostEntity>;
};

export type BlogPostFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<BlogPostFiltersInput>>>;
  author?: InputMaybe<AuthorFiltersInput>;
  blog_category?: InputMaybe<BlogCategoryFiltersInput>;
  blog_tags?: InputMaybe<BlogTagFiltersInput>;
  body?: InputMaybe<StringFilterInput>;
  contentLayers?: InputMaybe<ComponentSharedContentLayersFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<BlogPostFiltersInput>;
  not?: InputMaybe<BlogPostFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BlogPostFiltersInput>>>;
  perex?: InputMaybe<StringFilterInput>;
  publishDate?: InputMaybe<DateTimeFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  structuredDataHeadline?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BlogPostInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  author?: InputMaybe<Scalars['ID']['input']>;
  blog_category?: InputMaybe<Scalars['ID']['input']>;
  blog_tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  body?: InputMaybe<Scalars['String']['input']>;
  contentLayers?: InputMaybe<ComponentSharedContentLayersInput>;
  cover?: InputMaybe<Scalars['ID']['input']>;
  dynamicBody?: InputMaybe<Array<Scalars['BlogPostDynamicBodyDynamicZoneInput']['input']>>;
  perex?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  structuredDataHeadline?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BlogPostRelationResponseCollection = {
  __typename?: 'BlogPostRelationResponseCollection';
  data: Array<BlogPostEntity>;
};

export type BlogTag = {
  __typename?: 'BlogTag';
  SEO: ComponentSharedSeo;
  blog_posts?: Maybe<BlogPostRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<BlogTagRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type BlogTagBlog_PostsArgs = {
  filters?: InputMaybe<BlogPostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BlogTagLocalizationsArgs = {
  filters?: InputMaybe<BlogTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BlogTagEntity = {
  __typename?: 'BlogTagEntity';
  attributes?: Maybe<BlogTag>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type BlogTagEntityResponse = {
  __typename?: 'BlogTagEntityResponse';
  data?: Maybe<BlogTagEntity>;
};

export type BlogTagFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<BlogTagFiltersInput>>>;
  blog_posts?: InputMaybe<BlogPostFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<BlogTagFiltersInput>;
  not?: InputMaybe<BlogTagFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BlogTagFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BlogTagInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  blog_posts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BlogTagRelationResponseCollection = {
  __typename?: 'BlogTagRelationResponseCollection';
  data: Array<BlogTagEntity>;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nei?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Branding = {
  __typename?: 'Branding';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  logo: UploadFileEntityResponse;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BrandingEntity = {
  __typename?: 'BrandingEntity';
  attributes?: Maybe<Branding>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type BrandingEntityResponse = {
  __typename?: 'BrandingEntityResponse';
  data?: Maybe<BrandingEntity>;
};

export type BrandingEntityResponseCollection = {
  __typename?: 'BrandingEntityResponseCollection';
  data: Array<BrandingEntity>;
  meta: ResponseCollectionMeta;
};

export type BrandingFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BrandingFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<BrandingFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BrandingFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type BrandingInput = {
  logo?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type CareerLevel = {
  __typename?: 'CareerLevel';
  color: Scalars['String']['output'];
  description: Scalars['String']['output'];
  levelId: Scalars['Int']['output'];
  levelsCount: Scalars['Int']['output'];
  logoHorizontal: Scalars['String']['output'];
  logoVertical: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type Challenge = {
  __typename?: 'Challenge';
  SEO?: Maybe<ComponentSharedSeo>;
  /** @deprecated No longer supported */
  branded: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  careerPoints?: Maybe<Scalars['Int']['output']>;
  carousels?: Maybe<Array<Maybe<ComponentSharedSimpleCardsWidget>>>;
  challengeId: Scalars['ID']['output'];
  coins: Scalars['Int']['output'];
  contents?: Maybe<Array<Maybe<ComponentSharedTextWidget>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  detailDescription?: Maybe<Scalars['String']['output']>;
  endDateTime: Scalars['Date']['output'];
  expandTitle?: Maybe<Scalars['String']['output']>;
  experience: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated No longer supported */
  links: Links;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<ChallengeRelationResponseCollection>;
  logo?: Maybe<Scalars['String']['output']>;
  logoOriginal?: Maybe<Scalars['String']['output']>;
  longDescription?: Maybe<Scalars['String']['output']>;
  originalTitle: Scalars['String']['output'];
  /** @deprecated No longer supported */
  prize?: Maybe<Scalars['String']['output']>;
  prizes?: Maybe<Array<Maybe<ComponentWinnablePrize>>>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  registeredCount: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  startDateTime: Scalars['Date']['output'];
  state: ChallengeState;
  tasks: Array<ChallengeTask>;
  tasksAndRules?: Maybe<Array<Maybe<ComponentSharedTasksRulesWidget>>>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  winners?: Maybe<Array<Maybe<ComponentWinnableWinner>>>;
  youTubeVideoId?: Maybe<Scalars['String']['output']>;
};


export type ChallengeCarouselsArgs = {
  filters?: InputMaybe<ComponentSharedSimpleCardsWidgetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ChallengeContentsArgs = {
  filters?: InputMaybe<ComponentSharedTextWidgetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ChallengeLocalizationsArgs = {
  filters?: InputMaybe<ChallengeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ChallengePrizesArgs = {
  filters?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ChallengeTasksAndRulesArgs = {
  filters?: InputMaybe<ComponentSharedTasksRulesWidgetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ChallengeWinnersArgs = {
  filters?: InputMaybe<ComponentWinnableWinnerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ChallengeByIdInput = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ChallengeEntity = {
  __typename?: 'ChallengeEntity';
  attributes?: Maybe<Challenge>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ChallengeEntityResponse = {
  __typename?: 'ChallengeEntityResponse';
  data?: Maybe<ChallengeEntity>;
};

export type ChallengeFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ChallengeFiltersInput>>>;
  carousels?: InputMaybe<ComponentSharedSimpleCardsWidgetFiltersInput>;
  challengeId?: InputMaybe<StringFilterInput>;
  contents?: InputMaybe<ComponentSharedTextWidgetFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  detailDescription?: InputMaybe<StringFilterInput>;
  endDateTime?: InputMaybe<DateTimeFilterInput>;
  expandTitle?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ChallengeFiltersInput>;
  longDescription?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ChallengeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ChallengeFiltersInput>>>;
  prizes?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  tasksAndRules?: InputMaybe<ComponentSharedTasksRulesWidgetFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  winners?: InputMaybe<ComponentWinnableWinnerFiltersInput>;
  youTubeVideoId?: InputMaybe<StringFilterInput>;
};

export type ChallengeInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  carousels?: InputMaybe<Array<InputMaybe<ComponentSharedSimpleCardsWidgetInput>>>;
  challengeId?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<Array<InputMaybe<ComponentSharedTextWidgetInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  detailDescription?: InputMaybe<Scalars['String']['input']>;
  endDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  expandTitle?: InputMaybe<Scalars['String']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  prizes?: InputMaybe<Array<InputMaybe<ComponentWinnablePrizeInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tasksAndRules?: InputMaybe<Array<InputMaybe<ComponentSharedTasksRulesWidgetInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  winners?: InputMaybe<Array<InputMaybe<ComponentWinnableWinnerInput>>>;
  youTubeVideoId?: InputMaybe<Scalars['String']['input']>;
};

export enum ChallengeOrderBy {
  Datefrom = 'datefrom',
  Dateto = 'dateto',
  Status = 'status'
}

export enum ChallengeOrderDir {
  Asc = 'asc',
  Desc = 'desc'
}

export type ChallengeRelationResponseCollection = {
  __typename?: 'ChallengeRelationResponseCollection';
  data: Array<ChallengeEntity>;
};

export type ChallengeResult = {
  __typename?: 'ChallengeResult';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  segments: Array<ChallengeResultSegment>;
  totalTime: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export enum ChallengeResultCategory {
  All = 'all',
  Friends = 'friends',
  Men = 'men',
  Women = 'women'
}

export type ChallengeResultSegment = {
  __typename?: 'ChallengeResultSegment';
  distance: Scalars['Float']['output'];
  segmentId: Scalars['Int']['output'];
  time: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
};

export enum ChallengeState {
  Active = 'active',
  History = 'history',
  Planned = 'planned',
  Running = 'running'
}

export type ChallengeTask = {
  __typename?: 'ChallengeTask';
  amount: Scalars['Int']['output'];
  attributeType?: Maybe<Scalars['Int']['output']>;
  routes: Array<Route>;
  type: ChallengeTaskType;
  workoutDetails: Array<WorkoutDetail>;
  workouts: Array<Interval>;
};

export enum ChallengeTaskType {
  Attribute = 'attribute',
  Distance = 'distance',
  Route = 'route',
  SingleDistance = 'single_distance',
  Time = 'time',
  Workout = 'workout'
}

export type ComponentShareWorkoutIdsInput = {
  workoutIds: Array<Scalars['Int']['input']>;
};

export type ComponentSharedBlogPosts = {
  __typename?: 'ComponentSharedBlogPosts';
  anchorId?: Maybe<Scalars['String']['output']>;
  blogPosts?: Maybe<BlogPostRelationResponseCollection>;
  expand?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedBlogPostsBlogPostsArgs = {
  filters?: InputMaybe<BlogPostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedButton = {
  __typename?: 'ComponentSharedButton';
  buttonStyle?: Maybe<Enum_Componentsharedbutton_Buttonstyle>;
  buttonType?: Maybe<Enum_Componentsharedbutton_Buttontype>;
  ctaEvent?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type ComponentSharedButtonFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedButtonFiltersInput>>>;
  buttonStyle?: InputMaybe<StringFilterInput>;
  buttonType?: InputMaybe<StringFilterInput>;
  ctaEvent?: InputMaybe<StringFilterInput>;
  link?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedButtonFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedButtonFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedButtonInput = {
  buttonStyle?: InputMaybe<Enum_Componentsharedbutton_Buttonstyle>;
  buttonType?: InputMaybe<Enum_Componentsharedbutton_Buttontype>;
  ctaEvent?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedCancelPageSlide = {
  __typename?: 'ComponentSharedCancelPageSlide';
  backgroundMedia?: Maybe<ComponentSharedMedia>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: Enum_Componentsharedcancelpageslide_Type;
};

export type ComponentSharedCancelPageSlideFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedCancelPageSlideFiltersInput>>>;
  backgroundMedia?: InputMaybe<ComponentSharedMediaFiltersInput>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedCancelPageSlideFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedCancelPageSlideFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedCancelPageSlideInput = {
  backgroundMedia?: InputMaybe<ComponentSharedMediaInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Enum_Componentsharedcancelpageslide_Type>;
};

export type ComponentSharedCard = {
  __typename?: 'ComponentSharedCard';
  button?: Maybe<ComponentSharedButton>;
  buttonAlt?: Maybe<ComponentSharedButton>;
  contentImage?: Maybe<UploadFileEntityResponse>;
  contentText?: Maybe<Scalars['String']['output']>;
  contentTitle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentSharedCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedCardFiltersInput>>>;
  button?: InputMaybe<ComponentSharedButtonFiltersInput>;
  buttonAlt?: InputMaybe<ComponentSharedButtonFiltersInput>;
  contentText?: InputMaybe<StringFilterInput>;
  contentTitle?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedCardFiltersInput>>>;
};

export type ComponentSharedChallenges = {
  __typename?: 'ComponentSharedChallenges';
  anchorId?: Maybe<Scalars['String']['output']>;
  button?: Maybe<ComponentSharedButton>;
  challenges?: Maybe<ChallengeRelationResponseCollection>;
  expand?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedChallengesChallengesArgs = {
  filters?: InputMaybe<ChallengeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedChecklist = {
  __typename?: 'ComponentSharedChecklist';
  anchorId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items: Scalars['String']['output'];
  title: Scalars['String']['output'];
  vertical?: Maybe<Scalars['Boolean']['output']>;
};

export type ComponentSharedCompanionAppCta = {
  __typename?: 'ComponentSharedCompanionAppCta';
  anchorId?: Maybe<Scalars['String']['output']>;
  buttons?: Maybe<Array<Maybe<ComponentSharedButton>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
  title: Scalars['String']['output'];
};


export type ComponentSharedCompanionAppCtaButtonsArgs = {
  filters?: InputMaybe<ComponentSharedButtonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedContent = {
  __typename?: 'ComponentSharedContent';
  card?: Maybe<Array<Maybe<ComponentSharedCard>>>;
  id: Scalars['ID']['output'];
};


export type ComponentSharedContentCardArgs = {
  filters?: InputMaybe<ComponentSharedCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedContentLayers = {
  __typename?: 'ComponentSharedContentLayers';
  aim: Enum_Componentsharedcontentlayers_Aim;
  contentType: Enum_Componentsharedcontentlayers_Contenttype;
  id: Scalars['ID']['output'];
  perspective: Enum_Componentsharedcontentlayers_Perspective;
  segment: Scalars['JSON']['output'];
};

export type ComponentSharedContentLayersFiltersInput = {
  aim?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSharedContentLayersFiltersInput>>>;
  contentType?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedContentLayersFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedContentLayersFiltersInput>>>;
  perspective?: InputMaybe<StringFilterInput>;
  segment?: InputMaybe<JsonFilterInput>;
};

export type ComponentSharedContentLayersInput = {
  aim?: InputMaybe<Enum_Componentsharedcontentlayers_Aim>;
  contentType?: InputMaybe<Enum_Componentsharedcontentlayers_Contenttype>;
  id?: InputMaybe<Scalars['ID']['input']>;
  perspective?: InputMaybe<Enum_Componentsharedcontentlayers_Perspective>;
  segment?: InputMaybe<Scalars['JSON']['input']>;
};

export type ComponentSharedContentTeaser = {
  __typename?: 'ComponentSharedContentTeaser';
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<UploadFileEntityResponse>;
  backgroundImageResponsive?: Maybe<UploadFileEntityResponse>;
  cards?: Maybe<Array<Maybe<ComponentSharedSimpleCard>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<UploadFileEntityResponse>;
  logoResponsive?: Maybe<UploadFileEntityResponse>;
  size: Enum_Componentsharedcontentteaser_Size;
  title: Scalars['String']['output'];
};


export type ComponentSharedContentTeaserCardsArgs = {
  filters?: InputMaybe<ComponentSharedSimpleCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedEvents = {
  __typename?: 'ComponentSharedEvents';
  anchorId?: Maybe<Scalars['String']['output']>;
  button?: Maybe<ComponentSharedButton>;
  category?: Maybe<Scalars['String']['output']>;
  eventInfos?: Maybe<EventInfoRelationResponseCollection>;
  expand?: Maybe<Scalars['Boolean']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  featuredEventInfos: Array<Maybe<EventInfo>>;
  filterEventInfos: Array<Maybe<EventInfo>>;
  id: Scalars['ID']['output'];
  inverted?: Maybe<Scalars['Boolean']['output']>;
  logosStrip?: Maybe<UploadFileRelationResponseCollection>;
  subcategory?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedEventsEventInfosArgs = {
  filters?: InputMaybe<EventInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSharedEventsLogosStripArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedFaq = {
  __typename?: 'ComponentSharedFaq';
  anchorId?: Maybe<Scalars['String']['output']>;
  button?: Maybe<ComponentSharedButton>;
  id: Scalars['ID']['output'];
  question?: Maybe<Array<Maybe<ComponentSharedQuestion>>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedFaqQuestionArgs = {
  filters?: InputMaybe<ComponentSharedQuestionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedFeaturedLogo = {
  __typename?: 'ComponentSharedFeaturedLogo';
  id: Scalars['ID']['output'];
  logo: ComponentSharedLogo;
  title: Scalars['String']['output'];
};

export type ComponentSharedHeader = {
  __typename?: 'ComponentSharedHeader';
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<UploadFileEntityResponse>;
  button?: Maybe<ComponentSharedButton>;
  buttonAlt?: Maybe<ComponentSharedButton>;
  campaignId?: Maybe<Scalars['String']['output']>;
  cdnBackgroundImageUrl?: Maybe<Scalars['String']['output']>;
  cdnVideoUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  linkAfterEmailSubmit?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<UploadFileEntityResponse>;
  logosStrip?: Maybe<UploadFileRelationResponseCollection>;
  responsiveImage?: Maybe<UploadFileEntityResponse>;
  subheading?: Maybe<Scalars['String']['output']>;
  textLogo?: Maybe<Scalars['String']['output']>;
  video?: Maybe<UploadFileEntityResponse>;
};


export type ComponentSharedHeaderLogosStripArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedHeaderAcceptInvite = {
  __typename?: 'ComponentSharedHeaderAcceptInvite';
  backgroundImage: UploadFileEntityResponse;
  button: ComponentSharedButton;
  buttonFallback?: Maybe<ComponentSharedButton>;
  heading: Scalars['String']['output'];
  headingFallback?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  subheading: Scalars['String']['output'];
  subheadingFallback?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedHeaderVideo = {
  __typename?: 'ComponentSharedHeaderVideo';
  anchorId?: Maybe<Scalars['String']['output']>;
  buttons?: Maybe<Array<Maybe<ComponentSharedButton>>>;
  campaingId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  subheading?: Maybe<Scalars['String']['output']>;
  video: ComponentSharedVideo;
  videoResponsive?: Maybe<ComponentSharedVideo>;
};


export type ComponentSharedHeaderVideoButtonsArgs = {
  filters?: InputMaybe<ComponentSharedButtonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedHighlights = {
  __typename?: 'ComponentSharedHighlights';
  Highlight?: Maybe<Array<Maybe<ComponentSharedCard>>>;
  Layout?: Maybe<Enum_Componentsharedhighlights_Layout>;
  Title?: Maybe<Scalars['String']['output']>;
  anchorId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentSharedHighlightsHighlightArgs = {
  filters?: InputMaybe<ComponentSharedCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedImage = {
  __typename?: 'ComponentSharedImage';
  caption: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
};

export type ComponentSharedImageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedImageFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedImageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedImageFiltersInput>>>;
};

export type ComponentSharedImageInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedLink = {
  __typename?: 'ComponentSharedLink';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ComponentSharedLinkFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedLinkFiltersInput>>>;
  not?: InputMaybe<ComponentSharedLinkFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedLinkFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedLinkInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedLinksCarousel = {
  __typename?: 'ComponentSharedLinksCarousel';
  LinksCarouselItem?: Maybe<Array<Maybe<ComponentSharedLinksCarouselItem>>>;
  anchorId?: Maybe<Scalars['String']['output']>;
  background?: Maybe<Enum_Componentsharedlinkscarousel_Background>;
  buttonClickThrough?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedLinksCarouselLinksCarouselItemArgs = {
  filters?: InputMaybe<ComponentSharedLinksCarouselItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedLinksCarouselItem = {
  __typename?: 'ComponentSharedLinksCarouselItem';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
  label?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedLinksCarouselItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedLinksCarouselItemFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedLinksCarouselItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedLinksCarouselItemFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedLinksGroup = {
  __typename?: 'ComponentSharedLinksGroup';
  id: Scalars['ID']['output'];
  links: Array<Maybe<ComponentSharedLink>>;
  title: Scalars['String']['output'];
};


export type ComponentSharedLinksGroupLinksArgs = {
  filters?: InputMaybe<ComponentSharedLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedLinksGroupFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedLinksGroupFiltersInput>>>;
  links?: InputMaybe<ComponentSharedLinkFiltersInput>;
  not?: InputMaybe<ComponentSharedLinksGroupFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedLinksGroupFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedLinksGroupInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  links?: InputMaybe<Array<InputMaybe<ComponentSharedLinkInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedLogo = {
  __typename?: 'ComponentSharedLogo';
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
  link?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ComponentSharedLogoClouds = {
  __typename?: 'ComponentSharedLogoClouds';
  id: Scalars['ID']['output'];
  logos: Array<Maybe<ComponentSharedLogo>>;
  title: Scalars['String']['output'];
};


export type ComponentSharedLogoCloudsLogosArgs = {
  filters?: InputMaybe<ComponentSharedLogoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedLogoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedLogoFiltersInput>>>;
  link?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedLogoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedLogoFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedMedia = {
  __typename?: 'ComponentSharedMedia';
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  youtubeVideoId?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedMediaFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedMediaFiltersInput>>>;
  not?: InputMaybe<ComponentSharedMediaFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedMediaFiltersInput>>>;
  youtubeVideoId?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedMediaInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  youtubeVideoId?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedNavbar = {
  __typename?: 'ComponentSharedNavbar';
  anchorId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  navbarItems?: Maybe<Array<Maybe<ComponentSharedNavbarItem>>>;
};


export type ComponentSharedNavbarNavbarItemsArgs = {
  filters?: InputMaybe<ComponentSharedNavbarItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedNavbarItem = {
  __typename?: 'ComponentSharedNavbarItem';
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
  path: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ComponentSharedNavbarItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedNavbarItemFiltersInput>>>;
  not?: InputMaybe<ComponentSharedNavbarItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedNavbarItemFiltersInput>>>;
  path?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedNavbarSettings = {
  __typename?: 'ComponentSharedNavbarSettings';
  buttons?: Maybe<Array<Maybe<ComponentSharedButton>>>;
  fixed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  logoLink?: Maybe<ComponentSharedLink>;
  navLinks?: Maybe<Array<Maybe<ComponentSharedLink>>>;
  secondaryLogo?: Maybe<UploadFileEntityResponse>;
  secondaryLogoLink?: Maybe<Scalars['String']['output']>;
  transparent?: Maybe<Scalars['Boolean']['output']>;
};


export type ComponentSharedNavbarSettingsButtonsArgs = {
  filters?: InputMaybe<ComponentSharedButtonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSharedNavbarSettingsNavLinksArgs = {
  filters?: InputMaybe<ComponentSharedLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedNavbarSettingsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedNavbarSettingsFiltersInput>>>;
  buttons?: InputMaybe<ComponentSharedButtonFiltersInput>;
  fixed?: InputMaybe<BooleanFilterInput>;
  logoLink?: InputMaybe<ComponentSharedLinkFiltersInput>;
  navLinks?: InputMaybe<ComponentSharedLinkFiltersInput>;
  not?: InputMaybe<ComponentSharedNavbarSettingsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedNavbarSettingsFiltersInput>>>;
  secondaryLogoLink?: InputMaybe<StringFilterInput>;
  transparent?: InputMaybe<BooleanFilterInput>;
};

export type ComponentSharedNavbarSettingsInput = {
  buttons?: InputMaybe<Array<InputMaybe<ComponentSharedButtonInput>>>;
  fixed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logoLink?: InputMaybe<ComponentSharedLinkInput>;
  navLinks?: InputMaybe<Array<InputMaybe<ComponentSharedLinkInput>>>;
  secondaryLogo?: InputMaybe<Scalars['ID']['input']>;
  secondaryLogoLink?: InputMaybe<Scalars['String']['input']>;
  transparent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentSharedNewsletterCta = {
  __typename?: 'ComponentSharedNewsletterCta';
  anchorId?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  campaignId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  formType?: Maybe<Enum_Componentsharednewslettercta_Formtype>;
  hint: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  visual?: Maybe<UploadFileEntityResponse>;
};

export type ComponentSharedPageNavigation = {
  __typename?: 'ComponentSharedPageNavigation';
  anchorId?: Maybe<Scalars['String']['output']>;
  buttons?: Maybe<Array<Maybe<ComponentSharedButton>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedPageNavigationButtonsArgs = {
  filters?: InputMaybe<ComponentSharedButtonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedParagraph = {
  __typename?: 'ComponentSharedParagraph';
  asset?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  youtubeLink?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedParagraphFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedParagraphFiltersInput>>>;
  not?: InputMaybe<ComponentSharedParagraphFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedParagraphFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
  youtubeLink?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedParagraphInput = {
  asset?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  youtubeLink?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedPlansSelector = {
  __typename?: 'ComponentSharedPlansSelector';
  anchorId?: Maybe<Scalars['String']['output']>;
  button?: Maybe<ComponentSharedButton>;
  id: Scalars['ID']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  termsSection?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ComponentSharedPricing = {
  __typename?: 'ComponentSharedPricing';
  anchorId?: Maybe<Scalars['String']['output']>;
  button?: Maybe<ComponentSharedButton>;
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkAfterEmailSubmit?: Maybe<Scalars['String']['output']>;
  monthly: Scalars['Boolean']['output'];
  plan: Enum_Componentsharedpricing_Plan;
  termsSection?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  yearlyToMonths?: Maybe<Scalars['Boolean']['output']>;
};

export type ComponentSharedPrizes = {
  __typename?: 'ComponentSharedPrizes';
  Button?: Maybe<ComponentSharedButton>;
  Prizes?: Maybe<Array<Maybe<ComponentWinnablePrize>>>;
  Title?: Maybe<Scalars['String']['output']>;
  anchorId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentSharedPrizesPrizesArgs = {
  filters?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedProductsComparison = {
  __typename?: 'ComponentSharedProductsComparison';
  anchorId?: Maybe<Scalars['String']['output']>;
  button?: Maybe<ComponentSharedButton>;
  featuresTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  productsJson?: Maybe<Scalars['JSON']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ComponentSharedQuestion = {
  __typename?: 'ComponentSharedQuestion';
  answer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  questionText?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedQuestionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedQuestionFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedQuestionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedQuestionFiltersInput>>>;
  questionText?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedRegisterCta = {
  __typename?: 'ComponentSharedRegisterCta';
  anchorId?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  linkAfterEmailSubmit?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ComponentSharedRouteIdsInput = {
  routeIds: Array<Scalars['Int']['input']>;
};

export type ComponentSharedRoutes = {
  __typename?: 'ComponentSharedRoutes';
  id: Scalars['ID']['output'];
  ids?: Maybe<Scalars['String']['output']>;
  list: Array<Route>;
};

export type ComponentSharedRoutesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedRoutesFiltersInput>>>;
  ids?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedRoutesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedRoutesFiltersInput>>>;
};

export type ComponentSharedRoutesInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedRoutesSection = {
  __typename?: 'ComponentSharedRoutesSection';
  anchorId?: Maybe<Scalars['String']['output']>;
  categorySlug?: Maybe<Scalars['String']['output']>;
  expand?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  logosStrip?: Maybe<UploadFileRelationResponseCollection>;
  offset?: Maybe<Scalars['Int']['output']>;
  routeIds?: Maybe<ComponentSharedRoutes>;
  routes?: Maybe<Array<Route>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Enum_Componentsharedroutessection_Type>;
};


export type ComponentSharedRoutesSectionLogosStripArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedSeo = {
  __typename?: 'ComponentSharedSeo';
  id: Scalars['ID']['output'];
  metaDescription: Scalars['String']['output'];
  metaTitle: Scalars['String']['output'];
  noFollow?: Maybe<Scalars['Boolean']['output']>;
  noIndex?: Maybe<Scalars['Boolean']['output']>;
  ogTitle?: Maybe<Scalars['String']['output']>;
  shareImage?: Maybe<UploadFileEntityResponse>;
};

export type ComponentSharedSeoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedSeoFiltersInput>>>;
  metaDescription?: InputMaybe<StringFilterInput>;
  metaTitle?: InputMaybe<StringFilterInput>;
  noFollow?: InputMaybe<BooleanFilterInput>;
  noIndex?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ComponentSharedSeoFiltersInput>;
  ogTitle?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedSeoFiltersInput>>>;
};

export type ComponentSharedSeoInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  noFollow?: InputMaybe<Scalars['Boolean']['input']>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  ogTitle?: InputMaybe<Scalars['String']['input']>;
  shareImage?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedSideTextAndImage = {
  __typename?: 'ComponentSharedSideTextAndImage';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  imageOnRightSide?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedSimpleCard = {
  __typename?: 'ComponentSharedSimpleCard';
  cover: UploadFileEntityResponse;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedSimpleCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedSimpleCardFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedSimpleCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedSimpleCardFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedSimpleCardInput = {
  cover?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedSimpleCardsWidget = {
  __typename?: 'ComponentSharedSimpleCardsWidget';
  cards: Array<Maybe<ComponentSharedSimpleCard>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};


export type ComponentSharedSimpleCardsWidgetCardsArgs = {
  filters?: InputMaybe<ComponentSharedSimpleCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedSimpleCardsWidgetFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedSimpleCardsWidgetFiltersInput>>>;
  cards?: InputMaybe<ComponentSharedSimpleCardFiltersInput>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedSimpleCardsWidgetFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedSimpleCardsWidgetFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedSimpleCardsWidgetInput = {
  cards?: InputMaybe<Array<InputMaybe<ComponentSharedSimpleCardInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedSimpleCta = {
  __typename?: 'ComponentSharedSimpleCta';
  anchorId?: Maybe<Scalars['String']['output']>;
  button: ComponentSharedButton;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  title: Scalars['String']['output'];
};

export type ComponentSharedSocialPlatform = {
  __typename?: 'ComponentSharedSocialPlatform';
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  type: Enum_Componentsharedsocialplatform_Type;
};

export type ComponentSharedSocialPlatformFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedSocialPlatformFiltersInput>>>;
  link?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedSocialPlatformFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedSocialPlatformFiltersInput>>>;
  type?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedSocialPlatformInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Enum_Componentsharedsocialplatform_Type>;
};

export type ComponentSharedSpotlight = {
  __typename?: 'ComponentSharedSpotlight';
  card?: Maybe<ComponentSharedSimpleCard>;
  challenge?: Maybe<ChallengeEntityResponse>;
  eventInfo?: Maybe<EventInfoEntityResponse>;
  id: Scalars['ID']['output'];
  route?: Maybe<Route>;
  routeId?: Maybe<Scalars['Int']['output']>;
  trainingPlan?: Maybe<TrainingPlanOverview>;
  trainingPlanId?: Maybe<Scalars['Int']['output']>;
  workout?: Maybe<Interval>;
  workoutDetail?: Maybe<WorkoutDetail>;
  workoutId?: Maybe<Scalars['Int']['output']>;
};

export type ComponentSharedSpotlightFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedSpotlightFiltersInput>>>;
  card?: InputMaybe<ComponentSharedSimpleCardFiltersInput>;
  challenge?: InputMaybe<ChallengeFiltersInput>;
  eventInfo?: InputMaybe<EventInfoFiltersInput>;
  not?: InputMaybe<ComponentSharedSpotlightFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedSpotlightFiltersInput>>>;
  routeId?: InputMaybe<IntFilterInput>;
  trainingPlanId?: InputMaybe<IntFilterInput>;
  workoutId?: InputMaybe<IntFilterInput>;
};

export type ComponentSharedSpotlightInput = {
  card?: InputMaybe<ComponentSharedSimpleCardInput>;
  challenge?: InputMaybe<Scalars['ID']['input']>;
  eventInfo?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  routeId?: InputMaybe<Scalars['Int']['input']>;
  trainingPlanId?: InputMaybe<Scalars['Int']['input']>;
  workoutId?: InputMaybe<Scalars['Int']['input']>;
};

export type ComponentSharedSpotlights = {
  __typename?: 'ComponentSharedSpotlights';
  anchorId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  spotlight?: Maybe<SpotlightEntityResponse>;
};

export type ComponentSharedSpotlightsList = {
  __typename?: 'ComponentSharedSpotlightsList';
  anchorId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  spotlights?: Maybe<SpotlightRelationResponseCollection>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedSpotlightsListSpotlightsArgs = {
  filters?: InputMaybe<SpotlightFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedStepCard = {
  __typename?: 'ComponentSharedStepCard';
  alternativeImage?: Maybe<UploadFileEntityResponse>;
  buttons?: Maybe<Array<Maybe<ComponentSharedButton>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedStepCardButtonsArgs = {
  filters?: InputMaybe<ComponentSharedButtonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedStepCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedStepCardFiltersInput>>>;
  buttons?: InputMaybe<ComponentSharedButtonFiltersInput>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedStepCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedStepCardFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedSteps = {
  __typename?: 'ComponentSharedSteps';
  alternativeTitle?: Maybe<Scalars['String']['output']>;
  anchorId?: Maybe<Scalars['String']['output']>;
  button?: Maybe<ComponentSharedButton>;
  disableNumbering?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  step?: Maybe<Array<Maybe<ComponentSharedStepCard>>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentSharedStepsStepArgs = {
  filters?: InputMaybe<ComponentSharedStepCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedStripe = {
  __typename?: 'ComponentSharedStripe';
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Enum_Componentsharedstripe_Backgroundcolor>;
  id: Scalars['ID']['output'];
  lowerBackgroundColor?: Maybe<Enum_Componentsharedstripe_Lowerbackgroundcolor>;
  textColor?: Maybe<Enum_Componentsharedstripe_Textcolor>;
  title: Scalars['String']['output'];
  titleSecondLine?: Maybe<Scalars['String']['output']>;
  upperBackgroundColor?: Maybe<Enum_Componentsharedstripe_Upperbackgroundcolor>;
};

export type ComponentSharedTasksRulesCard = {
  __typename?: 'ComponentSharedTasksRulesCard';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentSharedTasksRulesCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedTasksRulesCardFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedTasksRulesCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedTasksRulesCardFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedTasksRulesCardInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedTasksRulesWidget = {
  __typename?: 'ComponentSharedTasksRulesWidget';
  cards?: Maybe<Array<Maybe<ComponentSharedTasksRulesCard>>>;
  id: Scalars['ID']['output'];
  routes?: Maybe<ComponentSharedRoutes>;
  subtitle?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  workouts?: Maybe<ComponentSharedWorkouts>;
};


export type ComponentSharedTasksRulesWidgetCardsArgs = {
  filters?: InputMaybe<ComponentSharedTasksRulesCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedTasksRulesWidgetFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedTasksRulesWidgetFiltersInput>>>;
  cards?: InputMaybe<ComponentSharedTasksRulesCardFiltersInput>;
  not?: InputMaybe<ComponentSharedTasksRulesWidgetFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedTasksRulesWidgetFiltersInput>>>;
  routes?: InputMaybe<ComponentSharedRoutesFiltersInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  text?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  workouts?: InputMaybe<ComponentSharedWorkoutsFiltersInput>;
};

export type ComponentSharedTasksRulesWidgetInput = {
  cards?: InputMaybe<Array<InputMaybe<ComponentSharedTasksRulesCardInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  routes?: InputMaybe<ComponentSharedRoutesInput>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  workouts?: InputMaybe<ComponentSharedWorkoutsInput>;
};

export type ComponentSharedTestimonial = {
  __typename?: 'ComponentSharedTestimonial';
  author: Scalars['String']['output'];
  authorType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  testimonial: Scalars['String']['output'];
};

export type ComponentSharedTestimonialFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedTestimonialFiltersInput>>>;
  author?: InputMaybe<StringFilterInput>;
  authorType?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedTestimonialFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedTestimonialFiltersInput>>>;
  testimonial?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedTestimonialsSection = {
  __typename?: 'ComponentSharedTestimonialsSection';
  anchorId?: Maybe<Scalars['String']['output']>;
  autoscrollInterval: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  testimonials: Array<Maybe<ComponentSharedTestimonial>>;
};


export type ComponentSharedTestimonialsSectionTestimonialsArgs = {
  filters?: InputMaybe<ComponentSharedTestimonialFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedTextBlock = {
  __typename?: 'ComponentSharedTextBlock';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type ComponentSharedTextWidget = {
  __typename?: 'ComponentSharedTextWidget';
  carousel?: Maybe<Array<Maybe<ComponentSharedImage>>>;
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ComponentSharedTextWidgetCarouselArgs = {
  filters?: InputMaybe<ComponentSharedImageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedTextWidgetFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedTextWidgetFiltersInput>>>;
  carousel?: InputMaybe<ComponentSharedImageFiltersInput>;
  not?: InputMaybe<ComponentSharedTextWidgetFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedTextWidgetFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedTextWidgetInput = {
  carousel?: InputMaybe<Array<InputMaybe<ComponentSharedImageInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedTwoColumnsContent = {
  __typename?: 'ComponentSharedTwoColumnsContent';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedVideo = {
  __typename?: 'ComponentSharedVideo';
  autoPlay: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  loop: Scalars['Boolean']['output'];
  muted: Scalars['Boolean']['output'];
  showControls: Scalars['Boolean']['output'];
  showVideo: Enum_Componentsharedvideo_Showvideo;
  thumbnail?: Maybe<UploadFileEntityResponse>;
  video: UploadFileEntityResponse;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedWorkouts = {
  __typename?: 'ComponentSharedWorkouts';
  id: Scalars['ID']['output'];
  ids?: Maybe<Scalars['String']['output']>;
  list: Array<Interval>;
  workoutDetails: Array<WorkoutDetail>;
};

export type ComponentSharedWorkoutsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedWorkoutsFiltersInput>>>;
  ids?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedWorkoutsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedWorkoutsFiltersInput>>>;
};

export type ComponentSharedWorkoutsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedWorkoutsSection = {
  __typename?: 'ComponentSharedWorkoutsSection';
  anchorId?: Maybe<Scalars['String']['output']>;
  expand?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  workouts?: Maybe<ComponentSharedWorkouts>;
};

export type ComponentSharedYouTubeVideo = {
  __typename?: 'ComponentSharedYouTubeVideo';
  anchorId?: Maybe<Scalars['String']['output']>;
  caption: Scalars['String']['output'];
  cover?: Maybe<UploadFileEntityResponse>;
  embedCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type ComponentWinnablePrize = {
  __typename?: 'ComponentWinnablePrize';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  title?: Maybe<Scalars['String']['output']>;
  winner?: Maybe<ComponentWinnableWinner>;
};

export type ComponentWinnablePrizeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentWinnablePrizeFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentWinnablePrizeFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  winner?: InputMaybe<ComponentWinnableWinnerFiltersInput>;
};

export type ComponentWinnablePrizeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  winner?: InputMaybe<ComponentWinnableWinnerInput>;
};

export type ComponentWinnableWinner = {
  __typename?: 'ComponentWinnableWinner';
  countryCode: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /** @deprecated This will not be used in future use firstName and lastName */
  name?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
};

export type ComponentWinnableWinnerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentWinnableWinnerFiltersInput>>>;
  not?: InputMaybe<ComponentWinnableWinnerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentWinnableWinnerFiltersInput>>>;
  userName?: InputMaybe<StringFilterInput>;
};

export type ComponentWinnableWinnerInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nei?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DynamicPage = {
  __typename?: 'DynamicPage';
  SEO: ComponentSharedSeo;
  body?: Maybe<Array<Maybe<DynamicPageBodyDynamicZone>>>;
  contentLayers?: Maybe<ComponentSharedContentLayers>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<DynamicPageRelationResponseCollection>;
  navbarSettings?: Maybe<ComponentSharedNavbarSettings>;
  path: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  structuredDataHeadline?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type DynamicPageLocalizationsArgs = {
  filters?: InputMaybe<DynamicPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DynamicPageBodyDynamicZone = ComponentSharedBlogPosts | ComponentSharedChallenges | ComponentSharedChecklist | ComponentSharedCompanionAppCta | ComponentSharedContentTeaser | ComponentSharedEvents | ComponentSharedFaq | ComponentSharedFeaturedLogo | ComponentSharedHeader | ComponentSharedHeaderAcceptInvite | ComponentSharedHeaderVideo | ComponentSharedHighlights | ComponentSharedLinksCarousel | ComponentSharedLogoClouds | ComponentSharedNavbar | ComponentSharedNewsletterCta | ComponentSharedPageNavigation | ComponentSharedPlansSelector | ComponentSharedPricing | ComponentSharedPrizes | ComponentSharedProductsComparison | ComponentSharedRegisterCta | ComponentSharedRoutesSection | ComponentSharedSimpleCta | ComponentSharedSpotlights | ComponentSharedSpotlightsList | ComponentSharedSteps | ComponentSharedStripe | ComponentSharedTestimonialsSection | ComponentSharedTextBlock | ComponentSharedTwoColumnsContent | ComponentSharedWorkoutsSection | ComponentSharedYouTubeVideo | Error;

export type DynamicPageEntity = {
  __typename?: 'DynamicPageEntity';
  attributes?: Maybe<DynamicPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type DynamicPageEntityResponse = {
  __typename?: 'DynamicPageEntityResponse';
  data?: Maybe<DynamicPageEntity>;
};

export type DynamicPageFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<DynamicPageFiltersInput>>>;
  contentLayers?: InputMaybe<ComponentSharedContentLayersFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<DynamicPageFiltersInput>;
  navbarSettings?: InputMaybe<ComponentSharedNavbarSettingsFiltersInput>;
  not?: InputMaybe<DynamicPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<DynamicPageFiltersInput>>>;
  path?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  structuredDataHeadline?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type DynamicPageInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  body?: InputMaybe<Array<Scalars['DynamicPageBodyDynamicZoneInput']['input']>>;
  contentLayers?: InputMaybe<ComponentSharedContentLayersInput>;
  navbarSettings?: InputMaybe<ComponentSharedNavbarSettingsInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  structuredDataHeadline?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DynamicPageRelationResponseCollection = {
  __typename?: 'DynamicPageRelationResponseCollection';
  data: Array<DynamicPageEntity>;
};

export enum Enum_Componentsharedbutton_Buttonstyle {
  Alternative = 'alternative',
  Danger = 'danger',
  Primary = 'primary',
  Secondary = 'secondary',
  Subtle = 'subtle'
}

export enum Enum_Componentsharedbutton_Buttontype {
  Default = 'default',
  Download = 'download',
  StravaConnect = 'stravaConnect',
  StravaPremium = 'stravaPremium'
}

export enum Enum_Componentsharedcancelpageslide_Type {
  Challenges = 'CHALLENGES',
  Events = 'EVENTS',
  Header = 'HEADER',
  Measurements = 'MEASUREMENTS'
}

export enum Enum_Componentsharedcontentlayers_Aim {
  Acquisition = 'acquisition',
  Brand = 'brand',
  Education = 'education',
  Reactivation = 'reactivation'
}

export enum Enum_Componentsharedcontentlayers_Contenttype {
  Blog = 'blog',
  General = 'general',
  Help = 'help',
  Lp = 'lp',
  Press = 'press'
}

export enum Enum_Componentsharedcontentlayers_Perspective {
  Benefits = 'benefits',
  Event = 'event',
  Feature = 'feature',
  General = 'general',
  Help = 'help',
  Solutions = 'solutions'
}

export enum Enum_Componentsharedcontentteaser_Size {
  Large = 'large',
  Small = 'small'
}

export enum Enum_Componentsharedhighlights_Layout {
  AlternateLeft = 'alternate_left',
  AlternateRight = 'alternate_right',
  Left = 'left',
  Right = 'right'
}

export enum Enum_Componentsharedlinkscarousel_Background {
  None = 'none',
  Pattern_1 = 'pattern_1',
  Pattern_1b = 'pattern_1b',
  Pattern_2 = 'pattern_2',
  Pattern_3 = 'pattern_3'
}

export enum Enum_Componentsharednewslettercta_Formtype {
  Affil = 'affil',
  Newsletter = 'newsletter',
  Trial = 'trial'
}

export enum Enum_Componentsharedpricing_Plan {
  RouvyDuo = 'rouvy_duo',
  RouvyGroup = 'rouvy_group',
  RouvySingle = 'rouvy_single'
}

export enum Enum_Componentsharedroutessection_Type {
  New = 'new',
  Other = 'other',
  Recommended = 'recommended'
}

export enum Enum_Componentsharedsocialplatform_Type {
  Facebook = 'facebook',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  Rouvy = 'rouvy',
  Strava = 'strava',
  X = 'x'
}

export enum Enum_Componentsharedstripe_Backgroundcolor {
  AccentPumpkin = 'accentPumpkin',
  AlmostBlack = 'almostBlack',
  Alto = 'alto',
  Black = 'black',
  BlackPearl = 'blackPearl',
  BlackPearl2 = 'blackPearl2',
  Chicago = 'chicago',
  CodGray = 'codGray',
  Concrete = 'concrete',
  DustyGray = 'dustyGray',
  FuscousGray = 'fuscousGray',
  MediumGray = 'mediumGray',
  Mercury = 'mercury',
  MineShaft = 'mineShaft',
  PartnerStrava = 'partnerStrava',
  PersianBlue = 'persianBlue',
  PhilippineYellow = 'philippineYellow',
  Porcelain = 'porcelain',
  SoftGray = 'softGray',
  SolidBlack = 'solidBlack',
  SolidLight = 'solidLight',
  SolidSurface = 'solidSurface',
  Transparent = 'transparent',
  Tuataraapprox = 'tuataraapprox',
  Tundora = 'tundora',
  White = 'white',
  WoodSmoke = 'woodSmoke'
}

export enum Enum_Componentsharedstripe_Lowerbackgroundcolor {
  AccentPumpkin = 'accentPumpkin',
  AlmostBlack = 'almostBlack',
  Alto = 'alto',
  Black = 'black',
  BlackPearl = 'blackPearl',
  BlackPearl2 = 'blackPearl2',
  Chicago = 'chicago',
  CodGray = 'codGray',
  Concrete = 'concrete',
  DustyGray = 'dustyGray',
  FuscousGray = 'fuscousGray',
  MediumGray = 'mediumGray',
  Mercury = 'mercury',
  MineShaft = 'mineShaft',
  PartnerStrava = 'partnerStrava',
  PersianBlue = 'persianBlue',
  PhilippineYellow = 'philippineYellow',
  Porcelain = 'porcelain',
  SoftGray = 'softGray',
  SolidBlack = 'solidBlack',
  SolidLight = 'solidLight',
  SolidSurface = 'solidSurface',
  Transparent = 'transparent',
  Tuataraapprox = 'tuataraapprox',
  Tundora = 'tundora',
  White = 'white',
  WoodSmoke = 'woodSmoke'
}

export enum Enum_Componentsharedstripe_Textcolor {
  AccentPumpkin = 'accentPumpkin',
  AlmostBlack = 'almostBlack',
  Alto = 'alto',
  Black = 'black',
  BlackPearl = 'blackPearl',
  BlackPearl2 = 'blackPearl2',
  Chicago = 'chicago',
  CodGray = 'codGray',
  Concrete = 'concrete',
  DustyGray = 'dustyGray',
  FuscousGray = 'fuscousGray',
  MediumGray = 'mediumGray',
  Mercury = 'mercury',
  MineShaft = 'mineShaft',
  PartnerStrava = 'partnerStrava',
  PersianBlue = 'persianBlue',
  PhilippineYellow = 'philippineYellow',
  Porcelain = 'porcelain',
  SoftGray = 'softGray',
  SolidBlack = 'solidBlack',
  SolidLight = 'solidLight',
  SolidSurface = 'solidSurface',
  Transparent = 'transparent',
  Tuataraapprox = 'tuataraapprox',
  Tundora = 'tundora',
  White = 'white',
  WoodSmoke = 'woodSmoke'
}

export enum Enum_Componentsharedstripe_Upperbackgroundcolor {
  AccentPumpkin = 'accentPumpkin',
  AlmostBlack = 'almostBlack',
  Alto = 'alto',
  Black = 'black',
  BlackPearl = 'blackPearl',
  BlackPearl2 = 'blackPearl2',
  Chicago = 'chicago',
  CodGray = 'codGray',
  Concrete = 'concrete',
  DustyGray = 'dustyGray',
  FuscousGray = 'fuscousGray',
  MediumGray = 'mediumGray',
  Mercury = 'mercury',
  MineShaft = 'mineShaft',
  PartnerStrava = 'partnerStrava',
  PersianBlue = 'persianBlue',
  PhilippineYellow = 'philippineYellow',
  Porcelain = 'porcelain',
  SoftGray = 'softGray',
  SolidBlack = 'solidBlack',
  SolidLight = 'solidLight',
  SolidSurface = 'solidSurface',
  Transparent = 'transparent',
  Tuataraapprox = 'tuataraapprox',
  Tundora = 'tundora',
  White = 'white',
  WoodSmoke = 'woodSmoke'
}

export enum Enum_Componentsharedvideo_Showvideo {
  OnClick = 'on_click',
  OnHover = 'on_hover',
  OnLoad = 'on_load'
}

export enum Enum_Post_Category {
  News = 'NEWS',
  Press = 'PRESS'
}

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type EventInfo = {
  __typename?: 'EventInfo';
  author: UserInfo;
  brandPhoto?: Maybe<UploadFileEntityResponse>;
  capacity: Scalars['Int']['output'];
  carousels?: Maybe<Array<Maybe<ComponentSharedSimpleCardsWidget>>>;
  category?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use eventSession coinsForCompletion */
  coinsForCompletion: Scalars['Int']['output'];
  contents?: Maybe<Array<Maybe<ComponentSharedTextWidget>>>;
  coverPhoto?: Maybe<UploadFileEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enteringOffsetSeconds: Scalars['Int']['output'];
  eventId: Scalars['ID']['output'];
  expandTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDrafting: Scalars['Boolean']['output'];
  laps: Scalars['Int']['output'];
  lateStartOffsetSeconds: Scalars['Int']['output'];
  /** @deprecated Use route field */
  legacyRoute: Route;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<EventInfoRelationResponseCollection>;
  longDescription?: Maybe<Scalars['String']['output']>;
  mainMedia?: Maybe<ComponentSharedMedia>;
  mainPhoto?: Maybe<UploadFileEntityResponse>;
  official: Scalars['Boolean']['output'];
  originalTitle: Scalars['String']['output'];
  passwordProtected: Scalars['Boolean']['output'];
  preview?: Maybe<Scalars['Boolean']['output']>;
  prizes?: Maybe<Array<Maybe<ComponentWinnablePrize>>>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  registrationsCount: Scalars['Int']['output'];
  route: RouteOverview;
  sessions: Array<EventSession>;
  smartTrainersOnly: Scalars['Boolean']['output'];
  subcategory?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: EventInfoType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  winners?: Maybe<Array<Maybe<ComponentWinnableWinner>>>;
};


export type EventInfoCarouselsArgs = {
  filters?: InputMaybe<ComponentSharedSimpleCardsWidgetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EventInfoContentsArgs = {
  filters?: InputMaybe<ComponentSharedTextWidgetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EventInfoLocalizationsArgs = {
  filters?: InputMaybe<EventInfoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EventInfoPrizesArgs = {
  filters?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EventInfoWinnersArgs = {
  filters?: InputMaybe<ComponentWinnableWinnerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EventInfoEntity = {
  __typename?: 'EventInfoEntity';
  attributes?: Maybe<EventInfo>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type EventInfoEntityResponse = {
  __typename?: 'EventInfoEntityResponse';
  data?: Maybe<EventInfoEntity>;
};

export type EventInfoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EventInfoFiltersInput>>>;
  carousels?: InputMaybe<ComponentSharedSimpleCardsWidgetFiltersInput>;
  category?: InputMaybe<StringFilterInput>;
  contents?: InputMaybe<ComponentSharedTextWidgetFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  eventId?: InputMaybe<StringFilterInput>;
  expandTitle?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<EventInfoFiltersInput>;
  longDescription?: InputMaybe<StringFilterInput>;
  mainMedia?: InputMaybe<ComponentSharedMediaFiltersInput>;
  not?: InputMaybe<EventInfoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EventInfoFiltersInput>>>;
  prizes?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  subcategory?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  winners?: InputMaybe<ComponentWinnableWinnerFiltersInput>;
};

export type EventInfoInput = {
  brandPhoto?: InputMaybe<Scalars['ID']['input']>;
  carousels?: InputMaybe<Array<InputMaybe<ComponentSharedSimpleCardsWidgetInput>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<Array<InputMaybe<ComponentSharedTextWidgetInput>>>;
  coverPhoto?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  expandTitle?: InputMaybe<Scalars['String']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  mainMedia?: InputMaybe<ComponentSharedMediaInput>;
  mainPhoto?: InputMaybe<Scalars['ID']['input']>;
  prizes?: InputMaybe<Array<InputMaybe<ComponentWinnablePrizeInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EventInfoType>;
  winners?: InputMaybe<Array<InputMaybe<ComponentWinnableWinnerInput>>>;
};

export type EventInfoRelationResponseCollection = {
  __typename?: 'EventInfoRelationResponseCollection';
  data: Array<EventInfoEntity>;
};

export enum EventInfoType {
  GroupRide = 'GROUP_RIDE',
  Race = 'RACE'
}

export type EventLeader = {
  __typename?: 'EventLeader';
  avatar?: Maybe<Scalars['String']['output']>;
  countryCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  username: Scalars['String']['output'];
};

export type EventSession = {
  __typename?: 'EventSession';
  coinsForCompletion: Scalars['Int']['output'];
  event: EventInfo;
  experience: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isUserAuthor: Scalars['Boolean']['output'];
  isUserRegistered: Scalars['Boolean']['output'];
  leader?: Maybe<UserInfo>;
  name?: Maybe<Scalars['String']['output']>;
  registrations: Array<EventSessionRegistration>;
  registrationsCount: Scalars['Int']['output'];
  startDateTime: Scalars['Date']['output'];
  status: EventSessionStatus;
};

export enum EventSessionOrderDir {
  Asc = 'asc',
  Desc = 'desc'
}

export type EventSessionRegistration = {
  __typename?: 'EventSessionRegistration';
  id: Scalars['ID']['output'];
  status?: Maybe<EventSessionRegistrationStatus>;
  user: UserInfo;
};

export enum EventSessionRegistrationStatus {
  Active = 'ACTIVE',
  DidNotFinish = 'DID_NOT_FINISH',
  DidNotStart = 'DID_NOT_START',
  Disqualified = 'DISQUALIFIED',
  Finished = 'FINISHED'
}

export enum EventSessionRunStatus {
  All = 'ALL',
  Current = 'CURRENT',
  Finished = 'FINISHED',
  Unfinished = 'UNFINISHED',
  Upcoming = 'UPCOMING'
}

export enum EventSessionStatus {
  Finished = 'FINISHED',
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export enum EventSessionVisibility {
  All = 'ALL',
  PublicOnly = 'PUBLIC_ONLY'
}

export type FeaturedWorkoutItem = TrainingPlanOverview | WorkoutOverview;

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nei?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type Footer = {
  __typename?: 'Footer';
  bottomLinks: Array<Maybe<ComponentSharedLink>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  groups: Array<Maybe<ComponentSharedLinksGroup>>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<FooterRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type FooterBottomLinksArgs = {
  filters?: InputMaybe<ComponentSharedLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type FooterGroupsArgs = {
  filters?: InputMaybe<ComponentSharedLinksGroupFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type FooterLocalizationsArgs = {
  publicationState?: InputMaybe<PublicationState>;
};

export type FooterEntity = {
  __typename?: 'FooterEntity';
  attributes?: Maybe<Footer>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type FooterEntityResponse = {
  __typename?: 'FooterEntityResponse';
  data?: Maybe<FooterEntity>;
};

export type FooterInput = {
  bottomLinks?: InputMaybe<Array<InputMaybe<ComponentSharedLinkInput>>>;
  groups?: InputMaybe<Array<InputMaybe<ComponentSharedLinksGroupInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FooterRelationResponseCollection = {
  __typename?: 'FooterRelationResponseCollection';
  data: Array<FooterEntity>;
};

export type Friend = {
  __typename?: 'Friend';
  befriendedAt: Scalars['Date']['output'];
  firebaseUid: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  status: UserStatus;
  user: UserInfo;
};

export enum FriendStatus {
  GroupRide = 'GROUP_RIDE',
  JustRide = 'JUST_RIDE',
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  PacedRide = 'PACED_RIDE',
  Race = 'RACE',
  TimeTrial = 'TIME_TRIAL',
  Workout = 'WORKOUT'
}

export enum Gender {
  Female = 'female',
  Male = 'male'
}

export enum GenderType {
  Female = 'female',
  Male = 'male'
}

export type GenericMorph = AccountPortalDynamicPage | Author | AvatarPart | BlogCategory | BlogPost | BlogTag | Branding | Challenge | ComponentSharedBlogPosts | ComponentSharedButton | ComponentSharedCancelPageSlide | ComponentSharedCard | ComponentSharedChallenges | ComponentSharedChecklist | ComponentSharedCompanionAppCta | ComponentSharedContent | ComponentSharedContentLayers | ComponentSharedContentTeaser | ComponentSharedEvents | ComponentSharedFaq | ComponentSharedFeaturedLogo | ComponentSharedHeader | ComponentSharedHeaderAcceptInvite | ComponentSharedHeaderVideo | ComponentSharedHighlights | ComponentSharedImage | ComponentSharedLink | ComponentSharedLinksCarousel | ComponentSharedLinksCarouselItem | ComponentSharedLinksGroup | ComponentSharedLogo | ComponentSharedLogoClouds | ComponentSharedMedia | ComponentSharedNavbar | ComponentSharedNavbarItem | ComponentSharedNavbarSettings | ComponentSharedNewsletterCta | ComponentSharedPageNavigation | ComponentSharedParagraph | ComponentSharedPlansSelector | ComponentSharedPricing | ComponentSharedPrizes | ComponentSharedProductsComparison | ComponentSharedQuestion | ComponentSharedRegisterCta | ComponentSharedRoutes | ComponentSharedRoutesSection | ComponentSharedSeo | ComponentSharedSideTextAndImage | ComponentSharedSimpleCard | ComponentSharedSimpleCardsWidget | ComponentSharedSimpleCta | ComponentSharedSocialPlatform | ComponentSharedSpotlight | ComponentSharedSpotlights | ComponentSharedSpotlightsList | ComponentSharedStepCard | ComponentSharedSteps | ComponentSharedStripe | ComponentSharedTasksRulesCard | ComponentSharedTasksRulesWidget | ComponentSharedTestimonial | ComponentSharedTestimonialsSection | ComponentSharedTextBlock | ComponentSharedTextWidget | ComponentSharedTwoColumnsContent | ComponentSharedVideo | ComponentSharedWorkouts | ComponentSharedWorkoutsSection | ComponentSharedYouTubeVideo | ComponentWinnablePrize | ComponentWinnableWinner | DynamicPage | EventInfo | Footer | GlobalChallenge | GlobalChallengeStage | Homepage | I18NLocale | LoadingScreen | Navbar | Partner | Post | Redirect | Spotlight | StaticPage | SubscriptionCancelPage | SubscriptionCancelReason | UploadFile | UploadFolder | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser;

export type GlobalChallenge = {
  __typename?: 'GlobalChallenge';
  backgroundImage: UploadFileEntityResponse;
  coins: Scalars['Int']['output'];
  completed: Scalars['Boolean']['output'];
  completedMeters: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDateTime: Scalars['Date']['output'];
  experience: Scalars['Int']['output'];
  globalChallengeId: Scalars['ID']['output'];
  gradientStartColor?: Maybe<Scalars['String']['output']>;
  gradientStopColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  joined: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<GlobalChallengeRelationResponseCollection>;
  logo: UploadFileEntityResponse;
  metersToComplete: Scalars['Float']['output'];
  minimalUserContributionGoalInMetersPerStage: Scalars['Int']['output'];
  preview?: Maybe<Scalars['Boolean']['output']>;
  promoReward: ComponentWinnablePrize;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  realRewards?: Maybe<Array<Maybe<ComponentWinnablePrize>>>;
  registeredUsersCount: Scalars['Int']['output'];
  rewardClaimed: Scalars['Boolean']['output'];
  stages: Array<GlobalChallengeStage>;
  startDateTime: Scalars['Date']['output'];
  title: Scalars['String']['output'];
  trophyBadge: UploadFileEntityResponse;
  type: GlobalChallengeGoalType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userCompleted: Scalars['Boolean']['output'];
  virtualRewards: Array<AvatarPart>;
  webLink?: Maybe<Scalars['String']['output']>;
};


export type GlobalChallengeLocalizationsArgs = {
  filters?: InputMaybe<GlobalChallengeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type GlobalChallengeRealRewardsArgs = {
  filters?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GlobalChallengeEntity = {
  __typename?: 'GlobalChallengeEntity';
  attributes?: Maybe<GlobalChallenge>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type GlobalChallengeEntityResponse = {
  __typename?: 'GlobalChallengeEntityResponse';
  data?: Maybe<GlobalChallengeEntity>;
};

export type GlobalChallengeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<GlobalChallengeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  globalChallengeId?: InputMaybe<StringFilterInput>;
  gradientStartColor?: InputMaybe<StringFilterInput>;
  gradientStopColor?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<GlobalChallengeFiltersInput>;
  not?: InputMaybe<GlobalChallengeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<GlobalChallengeFiltersInput>>>;
  promoReward?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  realRewards?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  webLink?: InputMaybe<StringFilterInput>;
};

export enum GlobalChallengeGoalType {
  Distance = 'DISTANCE',
  Elevation = 'ELEVATION'
}

export type GlobalChallengeInput = {
  backgroundImage?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  globalChallengeId?: InputMaybe<Scalars['String']['input']>;
  gradientStartColor?: InputMaybe<Scalars['String']['input']>;
  gradientStopColor?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['ID']['input']>;
  promoReward?: InputMaybe<ComponentWinnablePrizeInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  realRewards?: InputMaybe<Array<InputMaybe<ComponentWinnablePrizeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  trophyBadge?: InputMaybe<Scalars['ID']['input']>;
  webLink?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalChallengeRelationResponseCollection = {
  __typename?: 'GlobalChallengeRelationResponseCollection';
  data: Array<GlobalChallengeEntity>;
};

export type GlobalChallengeStage = {
  __typename?: 'GlobalChallengeStage';
  badge: UploadFileEntityResponse;
  coins: Scalars['Int']['output'];
  /** @deprecated use userCompleted */
  completed: Scalars['Boolean']['output'];
  completedMeters: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDateTime?: Maybe<Scalars['Date']['output']>;
  experience: Scalars['Int']['output'];
  globalChallengeStageId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<GlobalChallengeStageRelationResponseCollection>;
  metersToComplete: Scalars['Float']['output'];
  preview?: Maybe<Scalars['Boolean']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  realRewards?: Maybe<Array<Maybe<ComponentWinnablePrize>>>;
  rewardClaimed: Scalars['Boolean']['output'];
  state: GlobalChallengeStageState;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userCompleted: Scalars['Boolean']['output'];
  virtualRewards: Array<AvatarPart>;
};


export type GlobalChallengeStageLocalizationsArgs = {
  filters?: InputMaybe<GlobalChallengeStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type GlobalChallengeStageRealRewardsArgs = {
  filters?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GlobalChallengeStageEntity = {
  __typename?: 'GlobalChallengeStageEntity';
  attributes?: Maybe<GlobalChallengeStage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type GlobalChallengeStageEntityResponse = {
  __typename?: 'GlobalChallengeStageEntityResponse';
  data?: Maybe<GlobalChallengeStageEntity>;
};

export type GlobalChallengeStageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<GlobalChallengeStageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  globalChallengeStageId?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<GlobalChallengeStageFiltersInput>;
  not?: InputMaybe<GlobalChallengeStageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<GlobalChallengeStageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  realRewards?: InputMaybe<ComponentWinnablePrizeFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type GlobalChallengeStageInput = {
  badge?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  globalChallengeStageId?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  realRewards?: InputMaybe<Array<InputMaybe<ComponentWinnablePrizeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalChallengeStageRelationResponseCollection = {
  __typename?: 'GlobalChallengeStageRelationResponseCollection';
  data: Array<GlobalChallengeStageEntity>;
};

export enum GlobalChallengeStageState {
  Completed = 'COMPLETED',
  Locked = 'LOCKED',
  Ongoing = 'ONGOING'
}

export type Homepage = {
  __typename?: 'Homepage';
  SEO: ComponentSharedSeo;
  body?: Maybe<Array<Maybe<HomepageBodyDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<HomepageRelationResponseCollection>;
  navbarSettings?: Maybe<ComponentSharedNavbarSettings>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  variant: Scalars['String']['output'];
};


export type HomepageLocalizationsArgs = {
  filters?: InputMaybe<HomepageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HomepageBodyDynamicZone = ComponentSharedBlogPosts | ComponentSharedChallenges | ComponentSharedChecklist | ComponentSharedCompanionAppCta | ComponentSharedContentTeaser | ComponentSharedEvents | ComponentSharedFaq | ComponentSharedFeaturedLogo | ComponentSharedHeader | ComponentSharedHeaderVideo | ComponentSharedHighlights | ComponentSharedLinksCarousel | ComponentSharedLogoClouds | ComponentSharedNavbar | ComponentSharedNewsletterCta | ComponentSharedPageNavigation | ComponentSharedPlansSelector | ComponentSharedPricing | ComponentSharedPrizes | ComponentSharedProductsComparison | ComponentSharedRegisterCta | ComponentSharedRoutesSection | ComponentSharedSimpleCta | ComponentSharedSpotlights | ComponentSharedSpotlightsList | ComponentSharedSteps | ComponentSharedStripe | ComponentSharedTestimonialsSection | ComponentSharedTextBlock | ComponentSharedWorkoutsSection | ComponentSharedYouTubeVideo | Error;

export type HomepageEntity = {
  __typename?: 'HomepageEntity';
  attributes?: Maybe<Homepage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type HomepageEntityResponse = {
  __typename?: 'HomepageEntityResponse';
  data?: Maybe<HomepageEntity>;
};

export type HomepageFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<HomepageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<HomepageFiltersInput>;
  navbarSettings?: InputMaybe<ComponentSharedNavbarSettingsFiltersInput>;
  not?: InputMaybe<HomepageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<HomepageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  variant?: InputMaybe<StringFilterInput>;
};

export type HomepageInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  body?: InputMaybe<Array<Scalars['HomepageBodyDynamicZoneInput']['input']>>;
  navbarSettings?: InputMaybe<ComponentSharedNavbarSettingsInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type HomepageRelationResponseCollection = {
  __typename?: 'HomepageRelationResponseCollection';
  data: Array<HomepageEntity>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<I18NLocale>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nei?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nei?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type Interval = {
  __typename?: 'Interval';
  /** @deprecated Will always returns 0 */
  authorId: Scalars['Int']['output'];
  authorName: Scalars['String']['output'];
  /** @deprecated Will always returns [] */
  categories: Array<IntervalCategory>;
  coinsForCompletion: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  /** @deprecated Will be removed */
  difficulty: Scalars['Float']['output'];
  duration: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  if?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Will be removed */
  intervalType?: Maybe<IntervalType>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Will always returns 0 */
  np?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Will always be empty */
  preview?: Maybe<Scalars['String']['output']>;
  /** @deprecated Will always be empty */
  promoPictureUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Will always returns 0 */
  rating?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Will always returns 0 */
  ratingsCount?: Maybe<Scalars['Int']['output']>;
  recommendedRouteId?: Maybe<Scalars['Int']['output']>;
  segments: Array<Segment>;
  tss?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Will always be empty */
  videourl?: Maybe<Scalars['String']['output']>;
};

export type IntervalType = {
  __typename?: 'IntervalType';
  id: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type InviteFriendResult = {
  __typename?: 'InviteFriendResult';
  id: Scalars['ID']['output'];
  status: Scalars['Boolean']['output'];
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nei?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type Links = {
  __typename?: 'Links';
  detail: Scalars['String']['output'];
};

export type LoadingScreen = {
  __typename?: 'LoadingScreen';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  image: UploadFileEntityResponse;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<LoadingScreenRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  trainingType: Scalars['JSON']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  weight: Scalars['Int']['output'];
};


export type LoadingScreenLocalizationsArgs = {
  filters?: InputMaybe<LoadingScreenFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LoadingScreenEntity = {
  __typename?: 'LoadingScreenEntity';
  attributes?: Maybe<LoadingScreen>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type LoadingScreenEntityResponse = {
  __typename?: 'LoadingScreenEntityResponse';
  data?: Maybe<LoadingScreenEntity>;
};

export type LoadingScreenEntityResponseCollection = {
  __typename?: 'LoadingScreenEntityResponseCollection';
  data: Array<LoadingScreenEntity>;
  meta: ResponseCollectionMeta;
};

export type LoadingScreenFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LoadingScreenFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<LoadingScreenFiltersInput>;
  not?: InputMaybe<LoadingScreenFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LoadingScreenFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  trainingType?: InputMaybe<JsonFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  weight?: InputMaybe<IntFilterInput>;
};

export type LoadingScreenInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  trainingType?: InputMaybe<Scalars['JSON']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type LoadingScreenRelationResponseCollection = {
  __typename?: 'LoadingScreenRelationResponseCollection';
  data: Array<LoadingScreenEntity>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  acceptFriendRequest: Friend;
  acceptRequest: Scalars['Boolean']['output'];
  addWorkoutToCollection: WorkoutCollectionDetail;
  addWorkoutToFavouriteCollection: WorkoutCollectionDetail;
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createAccountPortalDynamicPageLocalization?: Maybe<AccountPortalDynamicPageEntityResponse>;
  createAuthorLocalization?: Maybe<AuthorEntityResponse>;
  createAvatarPartLocalization?: Maybe<AvatarPartEntityResponse>;
  createBlogCategoryLocalization?: Maybe<BlogCategoryEntityResponse>;
  createBlogPostLocalization?: Maybe<BlogPostEntityResponse>;
  createBlogTagLocalization?: Maybe<BlogTagEntityResponse>;
  createBranding?: Maybe<BrandingEntityResponse>;
  createChallengeLocalization?: Maybe<ChallengeEntityResponse>;
  createDynamicPageLocalization?: Maybe<DynamicPageEntityResponse>;
  createEventInfoLocalization?: Maybe<EventInfoEntityResponse>;
  createFooterLocalization?: Maybe<FooterEntityResponse>;
  createGlobalChallengeLocalization?: Maybe<GlobalChallengeEntityResponse>;
  createGlobalChallengeStageLocalization?: Maybe<GlobalChallengeStageEntityResponse>;
  createHomepageLocalization?: Maybe<HomepageEntityResponse>;
  createLoadingScreen?: Maybe<LoadingScreenEntityResponse>;
  createLoadingScreenLocalization?: Maybe<LoadingScreenEntityResponse>;
  createNavbarLocalization?: Maybe<NavbarEntityResponse>;
  createPartnerLocalization?: Maybe<PartnerEntityResponse>;
  createPostLocalization?: Maybe<PostEntityResponse>;
  createSpotlightLocalization?: Maybe<SpotlightEntityResponse>;
  createStaticPageLocalization?: Maybe<StaticPageEntityResponse>;
  createSubscriptionCancelPageLocalization?: Maybe<SubscriptionCancelPageEntityResponse>;
  createSubscriptionCancelReasonLocalization?: Maybe<SubscriptionCancelReasonEntityResponse>;
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  createUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  createWorkout?: Maybe<WorkoutDetail>;
  declineRequest: Notification;
  deleteActivity?: Maybe<Scalars['Boolean']['output']>;
  deleteBranding?: Maybe<BrandingEntityResponse>;
  deleteEventSession: Scalars['Boolean']['output'];
  deleteLoadingScreen?: Maybe<LoadingScreenEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>;
  deleteUserProfile?: Maybe<Scalars['Boolean']['output']>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteWorkout: Scalars['Boolean']['output'];
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  inviteFriendsToChallenge: Array<InviteFriendResult>;
  joinTrainingPlan?: Maybe<TrainingPlanDetail>;
  leaveTrainingPlan?: Maybe<TrainingPlanDetail>;
  login: UsersPermissionsLoginPayload;
  markNotificationsV2AsSeen: Scalars['Boolean']['output'];
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  registerToChallenge: Scalars['Boolean']['output'];
  registerToEventSession: Scalars['Boolean']['output'];
  registerToOngoingGlobalChallenge: GlobalChallenge;
  removeFile?: Maybe<UploadFileEntityResponse>;
  removeFriend: Scalars['Boolean']['output'];
  removeWorkoutFromCollection: WorkoutCollectionDetail;
  removeWorkoutFromFavouriteCollection: WorkoutCollectionDetail;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  sendFriendRequest: Notification;
  unregisterFromChallenge: Scalars['Boolean']['output'];
  unregisterFromEventSession: Scalars['Boolean']['output'];
  updateBranding?: Maybe<BrandingEntityResponse>;
  updateFileInfo: UploadFileEntityResponse;
  updateLoadingScreen?: Maybe<LoadingScreenEntityResponse>;
  updatePersonalInformation?: Maybe<UserProfile>;
  updateUnitsAndBodyProportions?: Maybe<UserProfile>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>;
  updateUserAccountSetting?: Maybe<UserProfile>;
  updateUserProfileAvatar?: Maybe<UserProfile>;
  updateUserProfileSetting?: Maybe<UserProfile>;
  updateUserZone?: Maybe<Scalars['Boolean']['output']>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  updateWorkout?: Maybe<WorkoutDetail>;
  upload: UploadFileEntityResponse;
};


export type MutationAcceptFriendRequestArgs = {
  firebaseUid: Scalars['ID']['input'];
};


export type MutationAcceptRequestArgs = {
  entityId: Scalars['ID']['input'];
  type: NotificationType;
};


export type MutationAddWorkoutToCollectionArgs = {
  collectionSlug: Scalars['String']['input'];
  workoutId: Scalars['ID']['input'];
};


export type MutationAddWorkoutToFavouriteCollectionArgs = {
  workoutId: Scalars['ID']['input'];
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationCreateAccountPortalDynamicPageLocalizationArgs = {
  data?: InputMaybe<AccountPortalDynamicPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateAuthorLocalizationArgs = {
  data?: InputMaybe<AuthorInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateAvatarPartLocalizationArgs = {
  data?: InputMaybe<AvatarPartInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateBlogCategoryLocalizationArgs = {
  data?: InputMaybe<BlogCategoryInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateBlogPostLocalizationArgs = {
  data?: InputMaybe<BlogPostInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateBlogTagLocalizationArgs = {
  data?: InputMaybe<BlogTagInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateBrandingArgs = {
  data: BrandingInput;
};


export type MutationCreateChallengeLocalizationArgs = {
  data?: InputMaybe<ChallengeInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateDynamicPageLocalizationArgs = {
  data?: InputMaybe<DynamicPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateEventInfoLocalizationArgs = {
  data?: InputMaybe<EventInfoInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateFooterLocalizationArgs = {
  data?: InputMaybe<FooterInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateGlobalChallengeLocalizationArgs = {
  data?: InputMaybe<GlobalChallengeInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateGlobalChallengeStageLocalizationArgs = {
  data?: InputMaybe<GlobalChallengeStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateHomepageLocalizationArgs = {
  data?: InputMaybe<HomepageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateLoadingScreenArgs = {
  data: LoadingScreenInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateLoadingScreenLocalizationArgs = {
  data?: InputMaybe<LoadingScreenInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateNavbarLocalizationArgs = {
  data?: InputMaybe<NavbarInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreatePartnerLocalizationArgs = {
  data?: InputMaybe<PartnerInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreatePostLocalizationArgs = {
  data?: InputMaybe<PostInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateSpotlightLocalizationArgs = {
  data?: InputMaybe<SpotlightInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateStaticPageLocalizationArgs = {
  data?: InputMaybe<StaticPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateSubscriptionCancelPageLocalizationArgs = {
  data?: InputMaybe<SubscriptionCancelPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateSubscriptionCancelReasonLocalizationArgs = {
  data?: InputMaybe<SubscriptionCancelReasonInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};


export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationCreateWorkoutArgs = {
  data: WorkoutInput;
};


export type MutationDeclineRequestArgs = {
  requestId: Scalars['ID']['input'];
  type: NotificationType;
};


export type MutationDeleteActivityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBrandingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEventSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLoadingScreenArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserProfileArgs = {
  firebaseUid: Scalars['String']['input'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWorkoutArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationInviteFriendsToChallengeArgs = {
  firebaseUid?: InputMaybe<Scalars['String']['input']>;
  friendIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationJoinTrainingPlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLeaveTrainingPlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMarkNotificationsV2AsSeenArgs = {
  notificationIds: Array<Scalars['ID']['input']>;
};


export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  files: Array<InputMaybe<Scalars['Upload']['input']>>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationRegisterToChallengeArgs = {
  firebaseUid?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationRegisterToEventSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveFriendArgs = {
  firebaseUid: Scalars['ID']['input'];
};


export type MutationRemoveWorkoutFromCollectionArgs = {
  collectionSlug: Scalars['String']['input'];
  workoutId: Scalars['ID']['input'];
};


export type MutationRemoveWorkoutFromFavouriteCollectionArgs = {
  workoutId: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationSendFriendRequestArgs = {
  firebaseUid: Scalars['ID']['input'];
};


export type MutationUnregisterFromChallengeArgs = {
  firebaseUid?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUnregisterFromEventSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateBrandingArgs = {
  data: BrandingInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateLoadingScreenArgs = {
  data: LoadingScreenInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdatePersonalInformationArgs = {
  firebaseUid: Scalars['String']['input'];
  input: UpdatePersonalInformationInput;
};


export type MutationUpdateUnitsAndBodyProportionsArgs = {
  firebaseUid: Scalars['String']['input'];
  input: UpdateUnitsAndBodyProportionsInput;
};


export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUploadFolderArgs = {
  data: UploadFolderInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUserAccountSettingArgs = {
  firebaseUid: Scalars['String']['input'];
  input: UpdateUserAccountSettingInput;
};


export type MutationUpdateUserProfileAvatarArgs = {
  firebaseUid: Scalars['String']['input'];
  input: UpdateUserProfileAvatarInput;
};


export type MutationUpdateUserProfileSettingArgs = {
  firebaseUid: Scalars['String']['input'];
  input: UpdateUserProfileSettingInput;
};


export type MutationUpdateUserZoneArgs = {
  input: UpdateUserZonesInput;
  type: UserZoneType;
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateWorkoutArgs = {
  data: WorkoutInput;
  id: Scalars['ID']['input'];
};


export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};

export type Navbar = {
  __typename?: 'Navbar';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<NavbarRelationResponseCollection>;
  navbarSettings: ComponentSharedNavbarSettings;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type NavbarLocalizationsArgs = {
  publicationState?: InputMaybe<PublicationState>;
};

export type NavbarEntity = {
  __typename?: 'NavbarEntity';
  attributes?: Maybe<Navbar>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type NavbarEntityResponse = {
  __typename?: 'NavbarEntityResponse';
  data?: Maybe<NavbarEntity>;
};

export type NavbarInput = {
  navbarSettings?: InputMaybe<ComponentSharedNavbarSettingsInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NavbarRelationResponseCollection = {
  __typename?: 'NavbarRelationResponseCollection';
  data: Array<NavbarEntity>;
};

export type NearbyRider = {
  __typename?: 'NearbyRider';
  userInfo: UserInfo;
};

export type Notification = {
  __typename?: 'Notification';
  challenge?: Maybe<Challenge>;
  createdAt: Scalars['Date']['output'];
  direction: NotificationDirection;
  eventSession?: Maybe<EventSession>;
  id: Scalars['ID']['output'];
  state: NotificationState;
  type: NotificationType;
  user: UserInfo;
};

export enum NotificationDirection {
  Received = 'RECEIVED',
  Sent = 'SENT'
}

export enum NotificationState {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export enum NotificationType {
  Challenge = 'CHALLENGE',
  EventSession = 'EVENT_SESSION',
  Friendship = 'FRIENDSHIP'
}

export type NotificationV2 = {
  __typename?: 'NotificationV2';
  content: NotificationV2Content;
  createdAt: Scalars['String']['output'];
  entityId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  status?: Maybe<NotificationV2Status>;
  type: NotificationV2Type;
  userImpression?: Maybe<NotificationV2UserImpression>;
};

export type NotificationV2Action = {
  __typename?: 'NotificationV2Action';
  appActionUrl?: Maybe<Scalars['String']['output']>;
  onPressText?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  type?: Maybe<NotificationV2UserImpression>;
  webActionUrl?: Maybe<Scalars['String']['output']>;
};

export type NotificationV2CenterContent = {
  __typename?: 'NotificationV2CenterContent';
  actions?: Maybe<Array<Maybe<NotificationV2Action>>>;
  customPayload?: Maybe<NotificationV2CustomPayload>;
  imageUrl: Scalars['String']['output'];
  message: Scalars['String']['output'];
  subImageUrl?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<NotificationV2CenterTeaser>;
};

export type NotificationV2CenterTeaser = {
  __typename?: 'NotificationV2CenterTeaser';
  actions?: Maybe<Array<Maybe<NotificationV2Action>>>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type NotificationV2Content = {
  __typename?: 'NotificationV2Content';
  notificationCenter?: Maybe<NotificationV2CenterContent>;
  popUp?: Maybe<NotificationV2PopUpContent>;
};

export type NotificationV2ContentReward = {
  __typename?: 'NotificationV2ContentReward';
  coins: Scalars['Int']['output'];
  experience: Scalars['Int']['output'];
  partId: Scalars['ID']['output'];
  presetId: Scalars['ID']['output'];
};

export type NotificationV2ContentStats = {
  __typename?: 'NotificationV2ContentStats';
  distance: Scalars['String']['output'];
  duration: Scalars['String']['output'];
  elevation: Scalars['String']['output'];
};

export type NotificationV2CustomPayload = NotificationV2ContentReward | NotificationV2ContentStats | NotificationV2EventInvitation | NotificationV2FriendRequest;

export type NotificationV2EventInvitation = {
  __typename?: 'NotificationV2EventInvitation';
  eventSessionId: Scalars['String']['output'];
  fromFirebaseUID: Scalars['String']['output'];
  invitationId: Scalars['String']['output'];
};

export type NotificationV2FriendRequest = {
  __typename?: 'NotificationV2FriendRequest';
  fromFirebaseUID: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
};

export type NotificationV2PopUpContent = {
  __typename?: 'NotificationV2PopUpContent';
  actions?: Maybe<Array<Maybe<NotificationV2Action>>>;
  customPayload?: Maybe<NotificationV2CustomPayload>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum NotificationV2Status {
  Seen = 'seen',
  Unseen = 'unseen'
}

export enum NotificationV2Type {
  AchievementCompleted = 'achievementCompleted',
  ActivityCompleted = 'activityCompleted',
  CareerLevelReached = 'careerLevelReached',
  ChallengeCompleted = 'challengeCompleted',
  ChallengeIncomplete = 'challengeIncomplete',
  Chargebee = 'chargebee',
  Crm = 'crm',
  EventCompleted = 'eventCompleted',
  EventInvitation = 'eventInvitation',
  FriendRequest = 'friendRequest',
  FriendRequestAccepted = 'friendRequestAccepted',
  MonthlyStatsOverview = 'monthlyStatsOverview',
  TrainingPlanCompleted = 'trainingPlanCompleted',
  WeeklyGoalCompleted = 'weeklyGoalCompleted',
  WeeklyStatsOverview = 'weeklyStatsOverview'
}

export enum NotificationV2UserImpression {
  Negative = 'negative',
  Positive = 'positive'
}

export type OutdoorActivity = {
  __typename?: 'OutdoorActivity';
  calories: Scalars['Float']['output'];
  careerPoints: Scalars['Int']['output'];
  distance: Scalars['Float']['output'];
  duration: Scalars['Float']['output'];
  elevation: Scalars['Float']['output'];
  experience: Scalars['Int']['output'];
  hourOffset?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  power: Scalars['Float']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  speed: Scalars['Float']['output'];
  startUTC?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['String']['output'];
};

export enum PaceUnits {
  DistancePerTime = 'DISTANCE_PER_TIME',
  TimePerDistance = 'TIME_PER_DISTANCE'
}

export type PagedRoutesResponse = {
  __typename?: 'PagedRoutesResponse';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  routes: Array<RouteOverview>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type Partner = {
  __typename?: 'Partner';
  SEO?: Maybe<ComponentSharedSeo>;
  about?: Maybe<Scalars['String']['output']>;
  carousels?: Maybe<Array<Maybe<ComponentSharedSimpleCardsWidget>>>;
  contents?: Maybe<Array<Maybe<ComponentSharedTextWidget>>>;
  countryIsoCode?: Maybe<Scalars['String']['output']>;
  cover?: Maybe<UploadFileEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lead?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<PartnerRelationResponseCollection>;
  logo: UploadFileEntityResponse;
  mainMedia?: Maybe<ComponentSharedMedia>;
  name: Scalars['String']['output'];
  partnerId: Scalars['Int']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  routes: Array<Route>;
  slug?: Maybe<Scalars['String']['output']>;
  thumbnailImage?: Maybe<UploadFileEntityResponse>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  web?: Maybe<Scalars['String']['output']>;
};


export type PartnerCarouselsArgs = {
  filters?: InputMaybe<ComponentSharedSimpleCardsWidgetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PartnerContentsArgs = {
  filters?: InputMaybe<ComponentSharedTextWidgetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PartnerLocalizationsArgs = {
  filters?: InputMaybe<PartnerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PartnerRoutesArgs = {
  input?: InputMaybe<PartnerRoutesInput>;
};

export type PartnerByIdInput = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerEntity = {
  __typename?: 'PartnerEntity';
  attributes?: Maybe<Partner>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PartnerEntityResponse = {
  __typename?: 'PartnerEntityResponse';
  data?: Maybe<PartnerEntity>;
};

export type PartnerFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  about?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<PartnerFiltersInput>>>;
  carousels?: InputMaybe<ComponentSharedSimpleCardsWidgetFiltersInput>;
  contents?: InputMaybe<ComponentSharedTextWidgetFiltersInput>;
  countryIsoCode?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  featured?: InputMaybe<BooleanFilterInput>;
  headline?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  lead?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<PartnerFiltersInput>;
  mainMedia?: InputMaybe<ComponentSharedMediaFiltersInput>;
  not?: InputMaybe<PartnerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PartnerFiltersInput>>>;
  partnerId?: InputMaybe<IntFilterInput>;
  position?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  web?: InputMaybe<StringFilterInput>;
};

export type PartnerInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  carousels?: InputMaybe<Array<InputMaybe<ComponentSharedSimpleCardsWidgetInput>>>;
  contents?: InputMaybe<Array<InputMaybe<ComponentSharedTextWidgetInput>>>;
  countryIsoCode?: InputMaybe<Scalars['String']['input']>;
  cover?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['ID']['input']>;
  mainMedia?: InputMaybe<ComponentSharedMediaInput>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  thumbnailImage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  web?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerRelationResponseCollection = {
  __typename?: 'PartnerRelationResponseCollection';
  data: Array<PartnerEntity>;
};

export type PartnerRoutesInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<RouteListType>;
};

export type Post = {
  __typename?: 'Post';
  SEO?: Maybe<ComponentSharedSeo>;
  background?: Maybe<UploadFileEntityResponse>;
  category?: Maybe<Enum_Post_Category>;
  cover: UploadFileEntityResponse;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  localazy?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<PostRelationResponseCollection>;
  paragraphs?: Maybe<Array<Maybe<ComponentSharedParagraph>>>;
  perex: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type PostLocalizationsArgs = {
  filters?: InputMaybe<PostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PostParagraphsArgs = {
  filters?: InputMaybe<ComponentSharedParagraphFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PostEntity = {
  __typename?: 'PostEntity';
  attributes?: Maybe<Post>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PostEntityResponse = {
  __typename?: 'PostEntityResponse';
  data?: Maybe<PostEntity>;
};

export type PostFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<PostFiltersInput>>>;
  category?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  localazy?: InputMaybe<BooleanFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<PostFiltersInput>;
  not?: InputMaybe<PostFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PostFiltersInput>>>;
  paragraphs?: InputMaybe<ComponentSharedParagraphFiltersInput>;
  perex?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  text?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PostInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  background?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<Enum_Post_Category>;
  cover?: InputMaybe<Scalars['ID']['input']>;
  localazy?: InputMaybe<Scalars['Boolean']['input']>;
  paragraphs?: InputMaybe<Array<InputMaybe<ComponentSharedParagraphInput>>>;
  perex?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PostRelationResponseCollection = {
  __typename?: 'PostRelationResponseCollection';
  data: Array<PostEntity>;
};

export type PromoPreview = {
  __typename?: 'PromoPreview';
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  _cmsAvatarPartById?: Maybe<AvatarPart>;
  _cmsChallenge?: Maybe<Challenge>;
  _cmsChallenges: Array<Challenge>;
  _cmsChallengesByIds: Array<Maybe<Challenge>>;
  _cmsEventInfo?: Maybe<EventInfo>;
  _cmsEventInfos: Array<EventInfo>;
  _cmsEventInfosByIds: Array<Maybe<EventInfo>>;
  _cmsGlobalChallengeById?: Maybe<GlobalChallenge>;
  _cmsGlobalChallengeStageById?: Maybe<GlobalChallengeStage>;
  _cmsPartner?: Maybe<Partner>;
  _cmsPartnersByIds: Array<Maybe<Partner>>;
  _empty?: Maybe<Scalars['String']['output']>;
  _serverActivitiesByIds: Array<Activity>;
  _serverActivityDetailsByIds: Array<Activity>;
  _serverAmbassadorsByUserId: Array<Maybe<Ambassador>>;
  _serverChallengesByIds: Array<Maybe<Challenge>>;
  _serverComponentSharedRoutes?: Maybe<ComponentSharedRoutes>;
  _serverComponentSharedRoutesByIds: Array<Maybe<ComponentSharedRoutes>>;
  _serverComponentSharedRoutesSection?: Maybe<ComponentSharedRoutesSection>;
  _serverComponentSharedSpotlight?: Maybe<ComponentSharedSpotlight>;
  _serverComponentSharedWorkouts?: Maybe<ComponentSharedWorkouts>;
  _serverComponentSharedWorkoutsByIds: Array<Maybe<ComponentSharedWorkouts>>;
  _serverFeaturedEventInfos?: Maybe<ComponentSharedEvents>;
  _serverPartners: Array<Partner>;
  _serverPartnersByIds: Array<Maybe<Partner>>;
  _serverWinnerByUserName?: Maybe<ComponentWinnableWinner>;
  _serverWinnersByUserNames: Array<Maybe<ComponentWinnableWinner>>;
  _serverWorkoutDetailsByIds: Array<WorkoutDetail>;
  _serverWorkoutOverviewsByIds: Array<WorkoutOverview>;
  _usersEventSessionsIsAuthor?: Maybe<Scalars['Boolean']['output']>;
  _usersEventSessionsIsRegistered?: Maybe<Scalars['Boolean']['output']>;
  _usersOngoingGlobalChallenge: GlobalChallenge;
  _usersOngoingGlobalChallengeStages: Array<GlobalChallengeStage>;
  _usersRoutesByIds: Array<Route>;
  accountPortalDynamicPage: Array<AccountPortalDynamicPage>;
  accountPortalDynamicPageByPath?: Maybe<AccountPortalDynamicPage>;
  activities: Array<Activity>;
  activityDetail?: Maybe<ActivityDetail>;
  activityDetails: ActivityDetailsResponse;
  activityStravaSegments: Array<ActivityStravaSegment>;
  authorBySlug?: Maybe<Author>;
  authors: Array<Author>;
  blogCategories: Array<BlogCategory>;
  blogCategoryBySlug?: Maybe<BlogCategory>;
  blogPostBySlug?: Maybe<BlogPost>;
  blogPosts: Array<BlogPost>;
  blogPostsSearch: Array<BlogPost>;
  blogTagBySlug?: Maybe<BlogTag>;
  blogTags: Array<BlogTag>;
  branding?: Maybe<BrandingEntityResponse>;
  brandings?: Maybe<BrandingEntityResponseCollection>;
  challenge?: Maybe<Challenge>;
  challengeBySlug?: Maybe<Challenge>;
  challengeResults: Array<ChallengeResult>;
  challenges: Array<Challenge>;
  countries: Array<Country>;
  dynamicPage: Array<DynamicPage>;
  dynamicPageByPath?: Maybe<DynamicPage>;
  eventInfo?: Maybe<EventInfo>;
  eventInfoBySessionId?: Maybe<EventInfo>;
  eventSession?: Maybe<EventSession>;
  eventSessions: Array<EventSession>;
  exploreRoutes: Array<Route>;
  featuredPartners: Array<Partner>;
  featuredWorkouts: Array<FeaturedWorkoutItem>;
  filterEventInfos: Array<Maybe<EventInfo>>;
  filterRegisteredChallengeUsers: RegisteredChallengeUsers;
  footer?: Maybe<Footer>;
  friends: Array<Friend>;
  homepage?: Maybe<Homepage>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  interval?: Maybe<Interval>;
  intervalCategories: Array<IntervalCategory>;
  intervals: Array<Interval>;
  latestSpotlight?: Maybe<Spotlight>;
  loadingScreen?: Maybe<LoadingScreenEntityResponse>;
  loadingScreens?: Maybe<LoadingScreenEntityResponseCollection>;
  me?: Maybe<UsersPermissionsMe>;
  navbar?: Maybe<Navbar>;
  notifications: Array<Notification>;
  notificationsV2: Array<NotificationV2>;
  ongoingGlobalChallenge: GlobalChallenge;
  outdoorActivities: Array<OutdoorActivity>;
  partner?: Maybe<Partner>;
  partnerBySlug?: Maybe<Partner>;
  partners: Array<Partner>;
  postBySlug?: Maybe<Post>;
  posts: Array<Post>;
  recommendedNextRoutes: RecommendedRoutesResponse;
  recommendedRoutes: Array<Route>;
  recommendedRoutesToUser: RecommendedRoutesResponse;
  recommendedSimilarRoutes: RecommendedRoutesResponse;
  redirect?: Maybe<Redirect>;
  redirects: Array<Redirect>;
  route?: Maybe<Route>;
  routeCategories: Array<RouteCategory>;
  routeCollection: RouteCollectionDetail;
  routeCollections: Array<Maybe<RouteCollection>>;
  routeGlobalCollections: Array<Maybe<RouteCollection>>;
  routeOverview?: Maybe<RouteOverview>;
  routeTags: Array<RouteTagGroup>;
  routes: Array<Route>;
  routesAdvancedFilter: Array<Route>;
  routesFulltextSearch: PagedRoutesResponse;
  routesSearch: RecommendedRoutesResponse;
  searchUser: Array<UserInfo>;
  similarRoutes: Array<Route>;
  spotlightBySlug?: Maybe<Spotlight>;
  spotlights: Array<Spotlight>;
  staticPage?: Maybe<StaticPage>;
  subscriptionCancelPageBySlug?: Maybe<SubscriptionCancelPage>;
  subscriptionCancelReasons: Array<SubscriptionCancelReason>;
  terms?: Maybe<Terms>;
  trainingPlanDetail?: Maybe<TrainingPlanDetail>;
  trainingPlans: Array<TrainingPlanOverview>;
  trendingRoutes: Array<RouteOverview>;
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<UploadFolderEntityResponse>;
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>;
  userChallenge: UserChallenge;
  userChallengeResults: UserChallengeResults;
  userChallenges: Array<UserChallenge>;
  userInfo: UserInfo;
  userNameExists: Scalars['Boolean']['output'];
  userProfile?: Maybe<UserProfile>;
  userStatisticsOverview?: Maybe<UserStatisticsOverview>;
  usersEventSessions: Array<EventSession>;
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>;
  workoutCollection: WorkoutCollectionDetail;
  workoutCollections: Array<WorkoutCollection>;
  workoutCollectionsGlobal: Array<WorkoutCollection>;
  workoutDetail?: Maybe<WorkoutDetail>;
  workoutOverview?: Maybe<WorkoutOverview>;
  workoutTags: Array<WorkoutTagGroup>;
  workoutsSearch: Array<WorkoutOverview>;
};


export type Query_CmsAvatarPartByIdArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  partId: Scalars['ID']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type Query_CmsChallengeArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type Query_CmsChallengesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type Query_CmsChallengesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type Query_CmsEventInfoArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type Query_CmsEventInfosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type Query_CmsEventInfosByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
};


export type Query_CmsGlobalChallengeByIdArgs = {
  globalChallengeId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
};


export type Query_CmsGlobalChallengeStageByIdArgs = {
  globalChallengeStageId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
};


export type Query_CmsPartnerArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type Query_CmsPartnersByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type Query_ServerActivitiesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type Query_ServerActivityDetailsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type Query_ServerAmbassadorsByUserIdArgs = {
  ids: Array<AmbassadorByIdInput>;
};


export type Query_ServerChallengesByIdsArgs = {
  ids: Array<ChallengeByIdInput>;
};


export type Query_ServerComponentSharedRoutesArgs = {
  routeIds: Array<Scalars['Int']['input']>;
};


export type Query_ServerComponentSharedRoutesByIdsArgs = {
  ids: Array<ComponentSharedRouteIdsInput>;
};


export type Query_ServerComponentSharedRoutesSectionArgs = {
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type Query_ServerComponentSharedSpotlightArgs = {
  routeId?: InputMaybe<Scalars['Int']['input']>;
  trainingPlanId?: InputMaybe<Scalars['Int']['input']>;
  workoutId?: InputMaybe<Scalars['Int']['input']>;
};


export type Query_ServerComponentSharedWorkoutsArgs = {
  workoutIds: Array<Scalars['Int']['input']>;
};


export type Query_ServerComponentSharedWorkoutsByIdsArgs = {
  ids: Array<ComponentShareWorkoutIdsInput>;
};


export type Query_ServerFeaturedEventInfosArgs = {
  featured?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Query_ServerPartnersArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type Query_ServerPartnersByIdsArgs = {
  ids: Array<PartnerByIdInput>;
};


export type Query_ServerWinnerByUserNameArgs = {
  userName: Scalars['String']['input'];
};


export type Query_ServerWinnersByUserNamesArgs = {
  userNames: Array<Scalars['String']['input']>;
};


export type Query_ServerWorkoutDetailsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type Query_ServerWorkoutOverviewsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type Query_UsersEventSessionsIsAuthorArgs = {
  id: Scalars['String']['input'];
};


export type Query_UsersEventSessionsIsRegisteredArgs = {
  id: Scalars['String']['input'];
};


export type Query_UsersRoutesByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAccountPortalDynamicPageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryAccountPortalDynamicPageByPathArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  path: Scalars['String']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryActivitiesArgs = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  firebaseUid: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyWorkouts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryActivityDetailArgs = {
  activityId: Scalars['ID']['input'];
  eventSessionId?: InputMaybe<Scalars['ID']['input']>;
  timeSeriesIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryActivityDetailsArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyFriends?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<ActivityOrderBy>;
  orderDir?: InputMaybe<ActivityOrderDir>;
  timeSeriesIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  withFriends?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryActivityStravaSegmentsArgs = {
  activityId: Scalars['ID']['input'];
};


export type QueryAuthorBySlugArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QueryAuthorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryBlogCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryBlogCategoryBySlugArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QueryBlogPostBySlugArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QueryBlogPostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryBlogPostsSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryBlogTagBySlugArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QueryBlogTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryBrandingArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBrandingsArgs = {
  filters?: InputMaybe<BrandingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryChallengeArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChallengeBySlugArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QueryChallengeResultsArgs = {
  category?: ChallengeResultCategory;
  id: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryChallengesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<ChallengeOrderBy>;
  orderDir?: InputMaybe<ChallengeOrderDir>;
  state?: InputMaybe<ChallengeState>;
};


export type QueryDynamicPageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryDynamicPageByPathArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  path: Scalars['String']['input'];
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryEventInfoArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEventInfoBySessionIdArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  sessionId: Scalars['ID']['input'];
};


export type QueryEventSessionArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEventSessionsArgs = {
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdByFriendsOf?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  joinedByFriendsOf?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  nonDrafting?: InputMaybe<Scalars['Boolean']['input']>;
  official?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderDir?: InputMaybe<EventSessionOrderDir>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  smartTrainersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<EventSessionRunStatus>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<EventInfoType>;
  visibility?: InputMaybe<EventSessionVisibility>;
};


export type QueryFeaturedPartnersArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFilterEventInfosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryFilterRegisteredChallengeUsersArgs = {
  challengeId: Scalars['ID']['input'];
  firebaseUidArray: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryFooterArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryFriendsArgs = {
  firebaseUid: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHomepageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  variant: Scalars['String']['input'];
};


export type QueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryIntervalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIntervalsArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLatestSpotlightArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryLoadingScreenArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryLoadingScreensArgs = {
  filters?: InputMaybe<LoadingScreenFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryNavbarArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryNotificationsArgs = {
  direction?: InputMaybe<NotificationDirection>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  state?: InputMaybe<NotificationState>;
  type?: InputMaybe<NotificationType>;
};


export type QueryNotificationsV2Args = {
  createdBefore?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryOngoingGlobalChallengeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOutdoorActivitiesArgs = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  firebaseUid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPartnerBySlugArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QueryPartnersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryPostBySlugArgs = {
  category?: InputMaybe<Enum_Post_Category>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QueryPostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryRecommendedNextRoutesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  recommendationId: Scalars['String']['input'];
};


export type QueryRecommendedRoutesArgs = {
  firebaseUid: Scalars['String']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryRecommendedRoutesToUserArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  scenario: Scalars['String']['input'];
};


export type QueryRecommendedSimilarRoutesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  itemId: Scalars['String']['input'];
  scenario: Scalars['String']['input'];
};


export type QueryRedirectArgs = {
  publicationState?: InputMaybe<PublicationState>;
  source?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRedirectsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryRouteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRouteCategoriesArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRouteCollectionArgs = {
  collectionSlug: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRouteOverviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRoutesArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  partnerId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<RouteListType>;
  updatedFrom?: InputMaybe<Scalars['Date']['input']>;
  video?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRoutesAdvancedFilterArgs = {
  averageSlopeInDegreesFrom?: InputMaybe<Scalars['Int']['input']>;
  averageSlopeInDegreesTo?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  distanceInMetersFrom?: InputMaybe<Scalars['Int']['input']>;
  distanceInMetersTo?: InputMaybe<Scalars['Int']['input']>;
  elevationInMetersFrom?: InputMaybe<Scalars['Int']['input']>;
  elevationInMetersTo?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  supportsAugmentedReality?: InputMaybe<Scalars['Boolean']['input']>;
  video?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRoutesFulltextSearchArgs = {
  collection?: InputMaybe<Scalars['String']['input']>;
  contentSource?: InputMaybe<RouteContentSource>;
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxAscended?: InputMaybe<Scalars['Int']['input']>;
  maxAvgSlope?: InputMaybe<Scalars['Int']['input']>;
  maxDistance?: InputMaybe<Scalars['Int']['input']>;
  maxMaxSlope?: InputMaybe<Scalars['Int']['input']>;
  minAscended?: InputMaybe<Scalars['Int']['input']>;
  minAvgSlope?: InputMaybe<Scalars['Int']['input']>;
  minDistance?: InputMaybe<Scalars['Int']['input']>;
  minMaxSlope?: InputMaybe<Scalars['Int']['input']>;
  multilapOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RouteOrderBy>;
  orderDir?: InputMaybe<RouteOrderDir>;
  routeTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRoutesSearchArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  maxAscended?: InputMaybe<Scalars['Int']['input']>;
  maxDistance?: InputMaybe<Scalars['Int']['input']>;
  minAscended?: InputMaybe<Scalars['Int']['input']>;
  minDistance?: InputMaybe<Scalars['Int']['input']>;
  routeTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scenario: Scalars['String']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchUserArgs = {
  includeFriends?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  match: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySimilarRoutesArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySpotlightBySlugArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QuerySpotlightsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryStaticPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QuerySubscriptionCancelPageBySlugArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  slug: Scalars['String']['input'];
};


export type QuerySubscriptionCancelReasonsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryTermsArgs = {
  language: Scalars['String']['input'];
};


export type QueryTrainingPlanDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTrendingRoutesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFoldersArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUserChallengeArgs = {
  firebaseUid?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  locale?: Scalars['String']['input'];
};


export type QueryUserChallengeResultsArgs = {
  category?: UserChallengeResultCategory;
  firebaseUid?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryUserChallengesArgs = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  firebaseUid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserChallengeOrderBy>;
  orderDir?: InputMaybe<UserChallengeOrderDir>;
  registered?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<UserChallengeStatus>;
};


export type QueryUserInfoArgs = {
  firebaseUid: Scalars['ID']['input'];
};


export type QueryUserNameExistsArgs = {
  userName: Scalars['String']['input'];
};


export type QueryUserProfileArgs = {
  firebaseUid: Scalars['String']['input'];
};


export type QueryUserStatisticsOverviewArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersEventSessionsArgs = {
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdByFriendsOf?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  joinedByFriendsOf?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  nonDrafting?: InputMaybe<Scalars['Boolean']['input']>;
  official?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderDir?: InputMaybe<EventSessionOrderDir>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  smartTrainersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<EventSessionRunStatus>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<EventInfoType>;
  visibility?: InputMaybe<EventSessionVisibility>;
};


export type QueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryWorkoutCollectionArgs = {
  collectionSlug: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorkoutCollectionOrderBy>;
  orderDir?: InputMaybe<WorkoutCollectionOrderDir>;
};


export type QueryWorkoutDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkoutOverviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkoutsSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxDuration?: InputMaybe<Scalars['Int']['input']>;
  minDuration?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  searchRange?: InputMaybe<WorkoutSearchRange>;
  workoutTags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RecommendedRoutesResponse = {
  __typename?: 'RecommendedRoutesResponse';
  recommendationId: Scalars['String']['output'];
  routes?: Maybe<Array<Maybe<RouteOverview>>>;
};

export type Redirect = {
  __typename?: 'Redirect';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  destination: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  permanent: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  source: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RegisteredChallengeUsers = {
  __typename?: 'RegisteredChallengeUsers';
  registeredChallengeUsers: Array<Maybe<Scalars['String']['output']>>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type Route = {
  __typename?: 'Route';
  averageSlopeInDegrees?: Maybe<Scalars['Float']['output']>;
  categories: Array<RouteCategory>;
  /** @deprecated Use categories field */
  categoryIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  coinsForCompletion: Scalars['Int']['output'];
  completedDistanceMeters: Scalars['Float']['output'];
  countryCode: Scalars['String']['output'];
  created: Scalars['Date']['output'];
  createdBy: Scalars['Int']['output'];
  createdByUsername: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  distanceInMeters: Scalars['Float']['output'];
  elevationInMeters: Scalars['Float']['output'];
  estimatedTime: Scalars['Int']['output'];
  fullGeometry: Array<RoutePointGeo>;
  geometry: Array<RoutePointGeo>;
  geometryJsonUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isNew: Scalars['Boolean']['output'];
  links: Links;
  maxSlopeInDegrees?: Maybe<Scalars['Float']['output']>;
  maxVideoQuality: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  omniMode: Scalars['Boolean']['output'];
  onlineCount?: Maybe<Scalars['Int']['output']>;
  partner?: Maybe<Partner>;
  promoPreview: Array<PromoPreview>;
  rating: Scalars['Float']['output'];
  ratingCount: Scalars['Int']['output'];
  sls_count: Scalars['Int']['output'];
  splits: Array<Split>;
  stravaLiveSegments: Array<RouteStravaLiveSegment>;
  stravaLiveSegmentsCount: Scalars['Int']['output'];
  supportsAugmentedReality: Scalars['Boolean']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  userCompletedDistanceMeters: Scalars['Float']['output'];
  userEstimatedTime: Scalars['Int']['output'];
  videoPreview: VideoPreview;
  videoQualities: Array<Scalars['Int']['output']>;
};


export type RouteGeometryArgs = {
  tolerance?: Scalars['Int']['input'];
};


export type RoutePartnerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type RouteCategory = {
  __typename?: 'RouteCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type RouteCollection = {
  __typename?: 'RouteCollection';
  collectionType: Scalars['String']['output'];
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  itemsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  thumbnails?: Maybe<RouteThumbnails>;
};

export type RouteCollectionDetail = {
  __typename?: 'RouteCollectionDetail';
  collectionType: Scalars['String']['output'];
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  itemsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  routes: Array<Maybe<RouteOverview>>;
  slug: Scalars['String']['output'];
  thumbnails?: Maybe<RouteThumbnails>;
};

export enum RouteContentSource {
  Community = 'community',
  Official = 'official'
}

export type RouteGeometryPoint = {
  __typename?: 'RouteGeometryPoint';
  altitude: Scalars['Float']['output'];
  distance: Scalars['Float']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export enum RouteListType {
  New = 'new',
  Other = 'other',
  Recommended = 'recommended'
}

export enum RouteOrderBy {
  CreatedAt = 'created_at',
  Distance = 'distance',
  Elevation = 'elevation',
  Eta = 'eta',
  Name = 'name',
  OnlineRiders = 'onlineRiders',
  Rating = 'rating'
}

export enum RouteOrderDir {
  Asc = 'asc',
  Desc = 'desc'
}

export type RouteOverview = {
  __typename?: 'RouteOverview';
  ascendedMeters: Scalars['Int']['output'];
  coinsForCompletion: Scalars['Int']['output'];
  completedDistanceMeters?: Maybe<Scalars['Float']['output']>;
  contentSource?: Maybe<RouteContentSource>;
  countryCodeISO?: Maybe<Scalars['String']['output']>;
  distanceMeters: Scalars['Float']['output'];
  estimatedTimeSeconds: Scalars['Int']['output'];
  flags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  geometryJsonUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  onlineRidersCount: Scalars['Int']['output'];
  /** @deprecated Always 0, will be removed in future */
  personalRecordSeconds?: Maybe<Scalars['Int']['output']>;
  promoVideoSet?: Maybe<Array<Maybe<RoutePromoVideo>>>;
  /** @deprecated Always null, will be removed in future */
  promoVideoUrl?: Maybe<Scalars['String']['output']>;
  rating: Scalars['Float']['output'];
  recommendationId?: Maybe<Scalars['String']['output']>;
  simplifiedGeometryPoints?: Maybe<Array<Maybe<RouteGeometryPoint>>>;
  stravaSegmentsCount: Scalars['Int']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnails: RouteThumbnails;
};

export type RoutePointGeo = {
  __typename?: 'RoutePointGeo';
  altitude: Scalars['Float']['output'];
  distance: Scalars['Float']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  slope?: Maybe<Scalars['Float']['output']>;
};

export type RoutePromoVideo = {
  __typename?: 'RoutePromoVideo';
  format: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type RouteStravaLiveSegment = {
  __typename?: 'RouteStravaLiveSegment';
  averageGrade: Scalars['Float']['output'];
  distanceMeters: Scalars['Float']['output'];
  elevationDifference: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RouteTag = {
  __typename?: 'RouteTag';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type RouteTagGroup = {
  __typename?: 'RouteTagGroup';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  tags: Array<RouteTag>;
};

export type RouteThumbnails = {
  __typename?: 'RouteThumbnails';
  large: Scalars['String']['output'];
  medium: Scalars['String']['output'];
  small: Scalars['String']['output'];
};

export type Segment = {
  __typename?: 'Segment';
  duration: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
};

export type Split = {
  __typename?: 'Split';
  distance: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  isFinish: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum SportType {
  Cycling = 'cycling',
  Running = 'running'
}

export type Spotlight = {
  __typename?: 'Spotlight';
  anchorId?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<UploadFileEntityResponse>;
  button?: Maybe<ComponentSharedButton>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latest?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<SpotlightRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  spotlights?: Maybe<Array<Maybe<ComponentSharedSpotlight>>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SpotlightLocalizationsArgs = {
  filters?: InputMaybe<SpotlightFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SpotlightSpotlightsArgs = {
  filters?: InputMaybe<ComponentSharedSpotlightFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SpotlightEntity = {
  __typename?: 'SpotlightEntity';
  attributes?: Maybe<Spotlight>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SpotlightEntityResponse = {
  __typename?: 'SpotlightEntityResponse';
  data?: Maybe<SpotlightEntity>;
};

export type SpotlightFiltersInput = {
  anchorId?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SpotlightFiltersInput>>>;
  button?: InputMaybe<ComponentSharedButtonFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  latest?: InputMaybe<BooleanFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<SpotlightFiltersInput>;
  not?: InputMaybe<SpotlightFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SpotlightFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  spotlights?: InputMaybe<ComponentSharedSpotlightFiltersInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SpotlightInput = {
  anchorId?: InputMaybe<Scalars['String']['input']>;
  backgroundImage?: InputMaybe<Scalars['ID']['input']>;
  button?: InputMaybe<ComponentSharedButtonInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  latest?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  spotlights?: InputMaybe<Array<InputMaybe<ComponentSharedSpotlightInput>>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SpotlightRelationResponseCollection = {
  __typename?: 'SpotlightRelationResponseCollection';
  data: Array<SpotlightEntity>;
};

export type StaticPage = {
  __typename?: 'StaticPage';
  SEO?: Maybe<ComponentSharedSeo>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StaticPageRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type StaticPageLocalizationsArgs = {
  filters?: InputMaybe<StaticPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StaticPageEntity = {
  __typename?: 'StaticPageEntity';
  attributes?: Maybe<StaticPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StaticPageEntityResponse = {
  __typename?: 'StaticPageEntityResponse';
  data?: Maybe<StaticPageEntity>;
};

export type StaticPageFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<StaticPageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<StaticPageFiltersInput>;
  not?: InputMaybe<StaticPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StaticPageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  text?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type StaticPageInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StaticPageRelationResponseCollection = {
  __typename?: 'StaticPageRelationResponseCollection';
  data: Array<StaticPageEntity>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCancelPage = {
  __typename?: 'SubscriptionCancelPage';
  SEO?: Maybe<ComponentSharedSeo>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<SubscriptionCancelPageRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slides?: Maybe<Array<Maybe<ComponentSharedCancelPageSlide>>>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SubscriptionCancelPageLocalizationsArgs = {
  filters?: InputMaybe<SubscriptionCancelPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubscriptionCancelPageSlidesArgs = {
  filters?: InputMaybe<ComponentSharedCancelPageSlideFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SubscriptionCancelPageEntity = {
  __typename?: 'SubscriptionCancelPageEntity';
  attributes?: Maybe<SubscriptionCancelPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SubscriptionCancelPageEntityResponse = {
  __typename?: 'SubscriptionCancelPageEntityResponse';
  data?: Maybe<SubscriptionCancelPageEntity>;
};

export type SubscriptionCancelPageFiltersInput = {
  SEO?: InputMaybe<ComponentSharedSeoFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<SubscriptionCancelPageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<SubscriptionCancelPageFiltersInput>;
  not?: InputMaybe<SubscriptionCancelPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SubscriptionCancelPageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slides?: InputMaybe<ComponentSharedCancelPageSlideFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SubscriptionCancelPageInput = {
  SEO?: InputMaybe<ComponentSharedSeoInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slides?: InputMaybe<Array<InputMaybe<ComponentSharedCancelPageSlideInput>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCancelPageRelationResponseCollection = {
  __typename?: 'SubscriptionCancelPageRelationResponseCollection';
  data: Array<SubscriptionCancelPageEntity>;
};

export type SubscriptionCancelReason = {
  __typename?: 'SubscriptionCancelReason';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<SubscriptionCancelReasonRelationResponseCollection>;
  position: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  showNote: Scalars['Boolean']['output'];
  subscriptionCancelPage?: Maybe<SubscriptionCancelPageEntityResponse>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SubscriptionCancelReasonLocalizationsArgs = {
  filters?: InputMaybe<SubscriptionCancelReasonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SubscriptionCancelReasonEntity = {
  __typename?: 'SubscriptionCancelReasonEntity';
  attributes?: Maybe<SubscriptionCancelReason>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SubscriptionCancelReasonEntityResponse = {
  __typename?: 'SubscriptionCancelReasonEntityResponse';
  data?: Maybe<SubscriptionCancelReasonEntity>;
};

export type SubscriptionCancelReasonFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SubscriptionCancelReasonFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<SubscriptionCancelReasonFiltersInput>;
  not?: InputMaybe<SubscriptionCancelReasonFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SubscriptionCancelReasonFiltersInput>>>;
  position?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  showNote?: InputMaybe<BooleanFilterInput>;
  subscriptionCancelPage?: InputMaybe<SubscriptionCancelPageFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SubscriptionCancelReasonInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  showNote?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionCancelPage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCancelReasonRelationResponseCollection = {
  __typename?: 'SubscriptionCancelReasonRelationResponseCollection';
  data: Array<SubscriptionCancelReasonEntity>;
};

export type Terms = {
  __typename?: 'Terms';
  effectiveAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  majorVersion?: Maybe<Scalars['Int']['output']>;
  minorVersion?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type TrainingPlanBlock = {
  __typename?: 'TrainingPlanBlock';
  expectedDurationDays: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  trainingUnits: Array<TrainingPlanUnit>;
};

export type TrainingPlanDetail = {
  __typename?: 'TrainingPlanDetail';
  blocks: Array<TrainingPlanBlock>;
  trainingPlan: TrainingPlanOverview;
};

export type TrainingPlanOverview = {
  __typename?: 'TrainingPlanOverview';
  backgroundImageUrl: Scalars['String']['output'];
  blocksCount: Scalars['Int']['output'];
  coinsForCompletion: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  expectedDurationDays: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastUserSession?: Maybe<TrainingPlanUserSession>;
  name: Scalars['String']['output'];
  tags: Array<TrainingPlanTag>;
  totalDurationSeconds: Scalars['Int']['output'];
  trainingUnitsCount: Scalars['Int']['output'];
};

export type TrainingPlanTag = {
  __typename?: 'TrainingPlanTag';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TrainingPlanUnit = {
  __typename?: 'TrainingPlanUnit';
  durationSeconds: Scalars['Int']['output'];
  finished: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  unitId: Scalars['ID']['output'];
  unitType: TrainingPlanUnitType;
};

export enum TrainingPlanUnitType {
  Workout = 'workout'
}

export type TrainingPlanUserSession = {
  __typename?: 'TrainingPlanUserSession';
  elapsedTimeSeconds: Scalars['Int']['output'];
  finishedUnitsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  startTimeUTC: Scalars['String']['output'];
  state: TrainingPlanUserSessionState;
};

export enum TrainingPlanUserSessionState {
  Active = 'active',
  Cancelled = 'cancelled',
  Completed = 'completed'
}

export enum Units {
  EnglishUs = 'ENGLISH_US',
  Metric = 'METRIC'
}

export type UpdatePersonalInformationInput = {
  birthDate: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryIsoCode: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender: GenderType;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type UpdateUnitsAndBodyProportionsInput = {
  ftp?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  maxHeartRate?: InputMaybe<Scalars['Float']['input']>;
  paceUnits?: InputMaybe<PaceUnits>;
  restHeartRate?: InputMaybe<Scalars['Int']['input']>;
  units?: InputMaybe<Units>;
  vo2max?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateUserAccountSettingInput = {
  accountPrivacy?: InputMaybe<AccountPrivacy>;
  countryNumber?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserProfileAvatarInput = {
  encodedImage: Scalars['String']['input'];
};

export type UpdateUserProfileSettingInput = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  ftp?: InputMaybe<Scalars['Float']['input']>;
  gender?: InputMaybe<GenderType>;
  height?: InputMaybe<Scalars['Float']['input']>;
  paceUnits?: InputMaybe<PaceUnits>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  units?: InputMaybe<Units>;
  username?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateUserZonesInput = {
  threshold1: Scalars['Int']['input'];
  threshold2: Scalars['Int']['input'];
  threshold3: Scalars['Int']['input'];
  threshold4: Scalars['Int']['input'];
  threshold5: Scalars['Int']['input'];
  threshold6: Scalars['Int']['input'];
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ext?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<UploadFile>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  folder?: InputMaybe<UploadFolderFiltersInput>;
  folderPath?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  folderPath?: InputMaybe<Scalars['String']['input']>;
  formats?: InputMaybe<Scalars['JSON']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_metadata?: InputMaybe<Scalars['JSON']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  children?: Maybe<UploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  name: Scalars['String']['output'];
  parent?: Maybe<UploadFolderEntityResponse>;
  path: Scalars['String']['output'];
  pathId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UploadFolderChildrenArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UploadFolderFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes?: Maybe<UploadFolder>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  children?: InputMaybe<UploadFolderFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  files?: InputMaybe<UploadFileFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  parent?: InputMaybe<UploadFolderFiltersInput>;
  path?: InputMaybe<StringFilterInput>;
  pathId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathId?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type UserCareer = {
  __typename?: 'UserCareer';
  sublevelBadge: Scalars['String']['output'];
};

export type UserChallenge = {
  __typename?: 'UserChallenge';
  challenge: Challenge;
  completed: Scalars['Boolean']['output'];
  friends: Array<UserChallengeFriend>;
  id: Scalars['ID']['output'];
  registered: Scalars['Boolean']['output'];
  registeredFriends: Array<Friend>;
  registeredFriendsCount: Scalars['Int']['output'];
  segments: Array<UserChallengeSegment>;
};


export type UserChallengeRegisteredFriendsArgs = {
  limit?: Scalars['Int']['input'];
};

export type UserChallengeFriend = {
  __typename?: 'UserChallengeFriend';
  id: Scalars['ID']['output'];
  invited: Scalars['Boolean']['output'];
  profile: Friend;
  registered: Scalars['Boolean']['output'];
};

export type UserChallengeMyResult = {
  __typename?: 'UserChallengeMyResult';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  segments: Array<UserChallengeResultSegment>;
  totalTime: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export enum UserChallengeOrderBy {
  Datefrom = 'datefrom',
  Dateto = 'dateto',
  Status = 'status'
}

export enum UserChallengeOrderDir {
  Asc = 'asc',
  Desc = 'desc'
}

export type UserChallengeResult = {
  __typename?: 'UserChallengeResult';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  segments: Array<UserChallengeResultSegment>;
  totalTime: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export enum UserChallengeResultCategory {
  All = 'all',
  Friends = 'friends',
  Men = 'men',
  Women = 'women'
}

export type UserChallengeResultSegment = {
  __typename?: 'UserChallengeResultSegment';
  routeId: Scalars['String']['output'];
  timeSeconds: Scalars['Float']['output'];
};

export type UserChallengeResults = {
  __typename?: 'UserChallengeResults';
  myResult?: Maybe<UserChallengeMyResult>;
  results: Array<UserChallengeResult>;
  resultsCount: Scalars['Int']['output'];
};

export type UserChallengeSegment = {
  __typename?: 'UserChallengeSegment';
  attributeType?: Maybe<Scalars['Int']['output']>;
  completed: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isRoute: Scalars['Boolean']['output'];
  routeId?: Maybe<Scalars['Int']['output']>;
  target: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  type: UserChallengeSegmentType;
  unit: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
  workoutId?: Maybe<Scalars['Int']['output']>;
};

export enum UserChallengeSegmentType {
  Attribute = 'attribute',
  Distance = 'distance',
  Route = 'route',
  SingleDistance = 'single_distance',
  Time = 'time',
  Workout = 'workout'
}

export enum UserChallengeStatus {
  Actual = 'actual',
  Finished = 'finished',
  Open = 'open',
  Planned = 'planned'
}

export type UserInfo = {
  __typename?: 'UserInfo';
  ageGroup?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  career?: Maybe<UserCareer>;
  countryCode?: Maybe<Scalars['String']['output']>;
  firebaseUid: Scalars['ID']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  gender: Gender;
  lastName?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type UserInterval = {
  __typename?: 'UserInterval';
  id: Scalars['ID']['output'];
  segments: Array<UserIntervalSegment>;
};

export type UserIntervalSegment = {
  __typename?: 'UserIntervalSegment';
  duration: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
};

export type UserProfile = {
  __typename?: 'UserProfile';
  accountPrivacy?: Maybe<AccountPrivacy>;
  accountSet: Scalars['Boolean']['output'];
  avatarUrl?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryIsoCode?: Maybe<Scalars['String']['output']>;
  estimateFtp?: Maybe<Scalars['Float']['output']>;
  firebaseUid: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  ftp?: Maybe<Scalars['Float']['output']>;
  gender?: Maybe<GenderType>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  maxHeartRate?: Maybe<Scalars['Float']['output']>;
  paceUnits?: Maybe<PaceUnits>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  restHeartRate?: Maybe<Scalars['Int']['output']>;
  subscription?: Maybe<UserSubscription>;
  team?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Units>;
  userName?: Maybe<Scalars['String']['output']>;
  vo2max?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  zones: Array<UserZone>;
};

export enum UserStatisticItemType {
  Ascent = 'ascent',
  Count = 'count',
  Distance = 'distance',
  Duration = 'duration',
  Energy = 'energy',
  Power = 'power',
  Speed = 'speed'
}

export type UserStatisticsOverview = {
  __typename?: 'UserStatisticsOverview';
  last7Days: Array<UserStatiticItem>;
  last30Days: Array<UserStatiticItem>;
  lifetime: Array<UserStatiticItem>;
};

export type UserStatiticItem = {
  __typename?: 'UserStatiticItem';
  iconUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: UserStatisticItemType;
  value: Scalars['Float']['output'];
};

export type UserStatus = {
  __typename?: 'UserStatus';
  entityId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  value: FriendStatus;
};

export type UserSubscription = {
  __typename?: 'UserSubscription';
  authority?: Maybe<UserSubscriptionAuthority>;
  canBeManaged?: Maybe<Scalars['Boolean']['output']>;
  deviceAllowed?: Maybe<Scalars['Boolean']['output']>;
  inChargebee: Scalars['Boolean']['output'];
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  pendingSubscription?: Maybe<Scalars['Boolean']['output']>;
  remainingTime?: Maybe<Scalars['Int']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  trial?: Maybe<UserTrialSubscription>;
  type?: Maybe<UserSubscriptionType>;
};

export enum UserSubscriptionAuthority {
  GooglePlay = 'GooglePlay',
  Rouvy = 'Rouvy',
  ITunes = 'iTunes'
}

export enum UserSubscriptionType {
  Premium = 'PREMIUM',
  Standard = 'STANDARD'
}

export type UserTrialSubscription = {
  __typename?: 'UserTrialSubscription';
  credit?: Maybe<Scalars['Int']['output']>;
  remainingTime?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<UserTrialSubscriptionType>;
};

export enum UserTrialSubscriptionType {
  Firstride = 'FIRSTRIDE',
  Trial = 'TRIAL',
  TrialDevice = 'TRIAL_DEVICE',
  Verifyemail = 'VERIFYEMAIL'
}

export type UserZone = {
  __typename?: 'UserZone';
  defaultValues: UserZoneValues;
  type: UserZoneType;
  values: UserZoneValues;
};

export enum UserZoneType {
  HeartRate = 'heart_rate',
  Power = 'power'
}

export type UserZoneValues = {
  __typename?: 'UserZoneValues';
  threshold1: Scalars['Int']['output'];
  threshold2: Scalars['Int']['output'];
  threshold3: Scalars['Int']['output'];
  threshold4: Scalars['Int']['output'];
  threshold5: Scalars['Int']['output'];
  threshold6: Scalars['Int']['output'];
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes?: Maybe<UsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<UsersPermissionsRole>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<UsersPermissionsUser>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmationToken?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  resetPasswordToken?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type VideoPreview = {
  __typename?: 'VideoPreview';
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailClear?: Maybe<Scalars['String']['output']>;
  thumbnailHiRes?: Maybe<Scalars['String']['output']>;
  thumbnailMidRes?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum WorkoutAccess {
  Private = 'private',
  Public = 'public'
}

export type WorkoutCollection = {
  __typename?: 'WorkoutCollection';
  collectionType: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  itemsCount: Scalars['Int']['output'];
  linkUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

export type WorkoutCollectionDetail = {
  __typename?: 'WorkoutCollectionDetail';
  collectionType: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  itemsCount: Scalars['Int']['output'];
  linkUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  workouts: Array<Maybe<WorkoutOverview>>;
};

export enum WorkoutCollectionOrderBy {
  Difficulty = 'difficulty',
  Duration = 'duration',
  Latest = 'latest'
}

export enum WorkoutCollectionOrderDir {
  Asc = 'asc',
  Desc = 'desc'
}

export type WorkoutDetail = {
  __typename?: 'WorkoutDetail';
  access: WorkoutAccess;
  coinsForCompletion: Scalars['Int']['output'];
  collection: Array<Scalars['String']['output']>;
  createdByUid: Scalars['String']['output'];
  createdByUsername: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  difficulty?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  durationSeconds: Scalars['Int']['output'];
  durationType: WorkoutDurationType;
  id: Scalars['ID']['output'];
  if: Scalars['Float']['output'];
  instructions: Array<WorkoutInstruction>;
  name: Scalars['String']['output'];
  recommendedRoute?: Maybe<RouteOverview>;
  routeCanBeChanged: Scalars['Boolean']['output'];
  segments: Array<WorkoutSegment>;
  tags: Array<Scalars['String']['output']>;
  /** @deprecated will be removed in future */
  trainingEffect?: Maybe<Scalars['String']['output']>;
  trainingEffects: Array<Scalars['String']['output']>;
  tss: Scalars['Int']['output'];
  workoutSegmentsSecondaryType?: Maybe<WorkoutSegmentSecondaryType>;
  workoutSegmentsType: WorkoutSegmentPrimaryType;
  workoutType: WorkoutType;
};

export enum WorkoutDurationType {
  DistanceInMeters = 'distanceInMeters',
  TimeInSeconds = 'timeInSeconds'
}

export type WorkoutInput = {
  access: WorkoutAccess;
  description?: InputMaybe<Scalars['String']['input']>;
  instructions: Array<WorkoutInstructionInput>;
  name: Scalars['String']['input'];
  recommendedRouteId: Scalars['ID']['input'];
  segments: Array<WorkoutSegmentInput>;
  tags: Array<Scalars['String']['input']>;
};

export type WorkoutInstruction = {
  __typename?: 'WorkoutInstruction';
  durationFromStart: Scalars['Float']['output'];
  showTimeDuration: Scalars['Float']['output'];
  text: Scalars['String']['output'];
  timeFromStart: Scalars['Float']['output'];
};

export type WorkoutInstructionInput = {
  durationFromStart: Scalars['Int']['input'];
  showTimeDuration: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  timeFromStart: Scalars['Int']['input'];
};

export type WorkoutOverview = {
  __typename?: 'WorkoutOverview';
  coinsForCompletion: Scalars['Int']['output'];
  difficulty?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  durationSeconds: Scalars['Int']['output'];
  durationType: WorkoutDurationType;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  recommendedRoute?: Maybe<RouteOverview>;
  segments: Array<WorkoutSegment>;
  tags: Array<Scalars['String']['output']>;
  /** @deprecated will be removed in future */
  trainingEffect?: Maybe<Scalars['String']['output']>;
  trainingEffects: Array<Scalars['String']['output']>;
  tss: Scalars['Int']['output'];
  workoutSegmentsSecondaryType?: Maybe<WorkoutSegmentSecondaryType>;
  workoutSegmentsType: WorkoutSegmentPrimaryType;
  workoutType: WorkoutType;
};

export enum WorkoutSearchRange {
  OnlyOfficial = 'onlyOfficial',
  OwnedAndOfficial = 'ownedAndOfficial',
  Public = 'public'
}

export type WorkoutSegment = {
  __typename?: 'WorkoutSegment';
  duration: Scalars['Int']['output'];
  durationSeconds: Scalars['Int']['output'];
  intervalType: WorkoutSegmentIntervalType;
  isTestSegment: Scalars['Boolean']['output'];
  phaseType: WorkoutSegmentPhaseType;
  primaryEnd: Scalars['Float']['output'];
  /** @deprecated Avg of primaryStart and primaryEnd, will be removed in future */
  primaryMax: Scalars['Float']['output'];
  /** @deprecated Avg of primaryStart and primaryEnd, will be removed in future */
  primaryMin: Scalars['Float']['output'];
  primaryStart: Scalars['Float']['output'];
  primaryType: WorkoutSegmentPrimaryType;
  secondaryMax?: Maybe<Scalars['Float']['output']>;
  secondaryMin?: Maybe<Scalars['Float']['output']>;
  secondaryType?: Maybe<WorkoutSegmentSecondaryType>;
};

export type WorkoutSegmentInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  durationSeconds: Scalars['Int']['input'];
  intervalType?: InputMaybe<WorkoutSegmentIntervalType>;
  phaseType?: InputMaybe<WorkoutSegmentPhaseType>;
  primaryMax: Scalars['Float']['input'];
  primaryMin: Scalars['Float']['input'];
  primaryType: WorkoutSegmentPrimaryType;
  secondaryMax?: InputMaybe<Scalars['Float']['input']>;
  secondaryMin?: InputMaybe<Scalars['Float']['input']>;
  secondaryType?: InputMaybe<WorkoutSegmentSecondaryType>;
};

export enum WorkoutSegmentIntervalType {
  Constant = 'CONSTANT',
  FreeRide = 'FREE_RIDE',
  Ramp = 'RAMP'
}

export enum WorkoutSegmentPhaseType {
  Cooldown = 'COOLDOWN',
  Training = 'TRAINING',
  Warmup = 'WARMUP'
}

export enum WorkoutSegmentPrimaryType {
  Ftp = 'ftp',
  Power = 'power',
  Slope = 'slope',
  Wkg = 'wkg'
}

export enum WorkoutSegmentSecondaryType {
  Cadence = 'cadence'
}

export type WorkoutTag = {
  __typename?: 'WorkoutTag';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type WorkoutTagGroup = {
  __typename?: 'WorkoutTagGroup';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  tags: Array<WorkoutTag>;
};

export enum WorkoutType {
  FtpTest20Minutes = 'ftpTest20Minutes',
  RampTest = 'rampTest',
  Workout = 'workout'
}

export type IntervalCategory = {
  __typename?: 'intervalCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ButtonFragment = { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null };

export type ChallengeEntityResponseCollectionFragment = { __typename?: 'ChallengeRelationResponseCollection', data: Array<{ __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, logoOriginal?: string | null, startDateTime: string, endDateTime: string, prize?: string | null, state: ChallengeState, branded: boolean, experience: number, registeredCount: number, links: { __typename?: 'Links', detail: string } } | null }> };

export type ChallengeEntityResponseFragment = { __typename?: 'ChallengeEntityResponse', data?: { __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, logoOriginal?: string | null, startDateTime: string, endDateTime: string, prize?: string | null, state: ChallengeState, branded: boolean, experience: number, registeredCount: number, links: { __typename?: 'Links', detail: string } } | null } | null };

export type ChallengeEntityFragment = { __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, logoOriginal?: string | null, startDateTime: string, endDateTime: string, prize?: string | null, state: ChallengeState, branded: boolean, experience: number, registeredCount: number, links: { __typename?: 'Links', detail: string } } | null };

export type ChallengesListItemFragment = { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, logoOriginal?: string | null, startDateTime: string, endDateTime: string, prize?: string | null, state: ChallengeState, branded: boolean, experience: number, registeredCount: number, links: { __typename?: 'Links', detail: string } };

export type ContentLayersFragment = { __typename?: 'ComponentSharedContentLayers', aim: Enum_Componentsharedcontentlayers_Aim, perspective: Enum_Componentsharedcontentlayers_Perspective, segment: {}, contentType: Enum_Componentsharedcontentlayers_Contenttype };

type HomepageBody_ComponentSharedBlogPosts_Fragment = { __typename: 'ComponentSharedBlogPosts', id: string, expand?: boolean | null, blogPostsTitle?: string | null, blogPostsAnchor?: string | null, blogPosts?: { __typename?: 'BlogPostRelationResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', title: string, perex: string, slug: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null }> } | null };

type HomepageBody_ComponentSharedChallenges_Fragment = { __typename: 'ComponentSharedChallenges', id: string, expand?: boolean | null, challengesAnchor?: string | null, challengesTitle?: string | null, challenges?: { __typename?: 'ChallengeRelationResponseCollection', data: Array<{ __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', challengeId: string, experience: number, startDateTime: string, endDateTime: string, title: string, expandTitle?: string | null, registeredCount: number, description?: string | null, logoOriginal?: string | null, coins: number, tasksAndRules?: Array<{ __typename?: 'ComponentSharedTasksRulesWidget', title: string, subtitle?: string | null, routes?: { __typename?: 'ComponentSharedRoutes', id: string } | null, workouts?: { __typename?: 'ComponentSharedWorkouts', id: string } | null } | null> | null } | null }> } | null };

type HomepageBody_ComponentSharedChecklist_Fragment = { __typename: 'ComponentSharedChecklist', id: string, vertical?: boolean | null, checklistTitle: string, checklistAnchor?: string | null, checklistItems: string };

type HomepageBody_ComponentSharedCompanionAppCta_Fragment = { __typename: 'ComponentSharedCompanionAppCta', id: string, companionAppCtaAnchor?: string | null, companionAppCtaTitle: string, companionAppCtaDescription?: string | null, companionAppCtaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null };

type HomepageBody_ComponentSharedContentTeaser_Fragment = { __typename: 'ComponentSharedContentTeaser', id: string, size: Enum_Componentsharedcontentteaser_Size, teaserTitle: string, teaserDescription?: string | null, teaserAnchor?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logoResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImageResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, cards?: Array<{ __typename?: 'ComponentSharedSimpleCard', title: string, description: string, url?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null };

type HomepageBody_ComponentSharedEvents_Fragment = { __typename: 'ComponentSharedEvents', id: string, category?: string | null, subcategory?: string | null, featured?: boolean | null, inverted?: boolean | null, expand?: boolean | null, eventsAnchor?: string | null, eventsTitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, eventInfos?: { __typename?: 'EventInfoRelationResponseCollection', data: Array<{ __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null }> } | null, featuredEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null>, filterEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null>, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null };

type HomepageBody_ComponentSharedFaq_Fragment = { __typename: 'ComponentSharedFaq', id: string, faqAnchor?: string | null, faqTitle?: string | null, question?: Array<{ __typename?: 'ComponentSharedQuestion', questionText?: string | null, answer?: string | null } | null> | null, faqButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type HomepageBody_ComponentSharedFeaturedLogo_Fragment = { __typename: 'ComponentSharedFeaturedLogo', id: string, title: string, featuredLogo: { __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } };

type HomepageBody_ComponentSharedHeader_Fragment = { __typename: 'ComponentSharedHeader', id: string, textLogo?: string | null, headline: string, subheading?: string | null, cdnVideoUrl?: string | null, cdnBackgroundImageUrl?: string | null, linkAfterEmailSubmit?: string | null, headerAnchor?: string | null, headerDescription?: string | null, headerCampaignId?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, responsiveImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null };

type HomepageBody_ComponentSharedHeaderVideo_Fragment = { __typename: 'ComponentSharedHeaderVideo', headline: string, subheading?: string | null, campaingId?: string | null, headerVideoDescription?: string | null, headerVideoAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null, headerVideo: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, headerVideoResponsive?: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null };

type HomepageBody_ComponentSharedHighlights_Fragment = { __typename: 'ComponentSharedHighlights', id: string, Layout?: Enum_Componentsharedhighlights_Layout | null, highlightsAnchor?: string | null, highlightsTitle?: string | null, Highlight?: Array<{ __typename?: 'ComponentSharedCard', contentTitle: string, contentText?: string | null, contentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | null> | null };

type HomepageBody_ComponentSharedLinksCarousel_Fragment = { __typename: 'ComponentSharedLinksCarousel', id: string, background?: Enum_Componentsharedlinkscarousel_Background | null, linksCarouselTitle?: string | null, linksCarouselAnchor?: string | null, linksCarouselButtonClickThrough?: boolean | null, items?: Array<{ __typename?: 'ComponentSharedLinksCarouselItem', title: string, description?: string | null, url?: string | null, label?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null };

type HomepageBody_ComponentSharedLogoClouds_Fragment = { __typename: 'ComponentSharedLogoClouds', id: string, logoCloudsTitle: string, logos: Array<{ __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> };

type HomepageBody_ComponentSharedNavbar_Fragment = { __typename: 'ComponentSharedNavbar', id: string, navbarAnchor?: string | null, navbarItems?: Array<{ __typename?: 'ComponentSharedNavbarItem', title: string, path: string } | null> | null };

type HomepageBody_ComponentSharedNewsletterCta_Fragment = { __typename: 'ComponentSharedNewsletterCta', id: string, description: string, hint: string, campaignId: string, formType?: Enum_Componentsharednewslettercta_Formtype | null, newsletterCtaAnchor?: string | null, ctaTitle: string, newsletterCtaButtonLabel?: string | null, visual?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

type HomepageBody_ComponentSharedPageNavigation_Fragment = { __typename: 'ComponentSharedPageNavigation', id: string, pageNavTitle?: string | null, pageNavDescription?: string | null, pageNavAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null };

type HomepageBody_ComponentSharedPlansSelector_Fragment = { __typename: 'ComponentSharedPlansSelector', id: string, termsSection?: string | null, plansSelectorTitle: string, plansSelectorSubtitle?: string | null, plansSelectorAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type HomepageBody_ComponentSharedPricing_Fragment = { __typename: 'ComponentSharedPricing', id: string, yearlyToMonths?: boolean | null, monthly: boolean, plan: Enum_Componentsharedpricing_Plan, termsSection?: string | null, linkAfterEmailSubmit?: string | null, pricingTitle: string, pricingContent?: string | null, pricingAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type HomepageBody_ComponentSharedPrizes_Fragment = { __typename: 'ComponentSharedPrizes', id: string, prizesAnchor?: string | null, prizesTitle?: string | null, Prizes?: Array<{ __typename?: 'ComponentWinnablePrize', title?: string | null, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, winner?: { __typename?: 'ComponentWinnableWinner', userName: string, profileImage?: string | null, firstName?: string | null, lastName?: string | null, countryCode: string } | null } | null> | null, Button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type HomepageBody_ComponentSharedProductsComparison_Fragment = { __typename: 'ComponentSharedProductsComparison', id: string, productsJson?: {} | null, productsComparisonTitle: string, productsComparisonSubtitle?: string | null, productsComparisonFeaturesTitle?: string | null, productsComparisonAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type HomepageBody_ComponentSharedRegisterCta_Fragment = { __typename: 'ComponentSharedRegisterCta', id: string, linkAfterEmailSubmit?: string | null, registerCtaTitle: string, registerCtaDescription?: string | null, registerCtaAnchor?: string | null, registerCtaCampaignId?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

type HomepageBody_ComponentSharedRoutesSection_Fragment = { __typename: 'ComponentSharedRoutesSection', id: string, type?: Enum_Componentsharedroutessection_Type | null, categorySlug?: string | null, offset?: number | null, limit?: number | null, expand?: boolean | null, routesTitle?: string | null, routesAnchor?: string | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null, routeIds?: { __typename?: 'ComponentSharedRoutes', ids?: string | null, list: Array<{ __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> }> } | null, routes?: Array<{ __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> }> | null };

type HomepageBody_ComponentSharedSimpleCta_Fragment = { __typename: 'ComponentSharedSimpleCta', id: string, simpleCtaAnchor?: string | null, simpleCtaTitle: string, simpleCtaDescription?: string | null, simpleCtaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, simpleCtaButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } };

type HomepageBody_ComponentSharedSpotlights_Fragment = { __typename: 'ComponentSharedSpotlights', id: string, spotlightsAnchorId?: string | null, spotlight?: { __typename?: 'SpotlightEntityResponse', data?: { __typename?: 'SpotlightEntity', attributes?: { __typename?: 'Spotlight', title: string, anchorId?: string | null, subtitle?: string | null, description?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, spotlights?: Array<{ __typename?: 'ComponentSharedSpotlight', id: string, routeId?: number | null, workoutId?: number | null, trainingPlanId?: number | null, route?: { __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> } | null, eventInfo?: { __typename?: 'EventInfoEntityResponse', data?: { __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null } | null } | null, challenge?: { __typename?: 'ChallengeEntityResponse', data?: { __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, logoOriginal?: string | null, startDateTime: string, endDateTime: string, prize?: string | null, state: ChallengeState, branded: boolean, experience: number, registeredCount: number, links: { __typename?: 'Links', detail: string } } | null } | null } | null, workout?: { __typename?: 'WorkoutDetail', id: string, name: string, duration: number, durationType: WorkoutDurationType, description?: string | null, tss: number, coinsForCompletion: number, difficulty?: string | null, trainingEffects: Array<string>, intensityFactor: number, segments: Array<{ __typename?: 'WorkoutSegment', duration: number, intervalType: WorkoutSegmentIntervalType, type: WorkoutSegmentPrimaryType, valueStart: number, valueEnd: number }>, recommendedRoute?: { __typename?: 'RouteOverview', simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', altitude: number, distance: number } | null> | null } | null } | null, trainingPlan?: { __typename?: 'TrainingPlanOverview', id: string, name: string, description: string, backgroundImageUrl: string, totalDurationSeconds: number, expectedDurationDays: number, coinsForCompletion: number, blocksCount: number, trainingUnitsCount: number, trainingPlanTags: Array<{ __typename?: 'TrainingPlanTag', id: string, name: string, color: string }> } | null, card?: { __typename?: 'ComponentSharedSimpleCard', id: string, title: string, description: string, url?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null } | null> | null } | null } | null } | null };

type HomepageBody_ComponentSharedSpotlightsList_Fragment = { __typename: 'ComponentSharedSpotlightsList', id: string, spotlightsListTitle?: string | null, spotlightsListAnchor?: string | null, spotlights?: { __typename?: 'SpotlightRelationResponseCollection', data: Array<{ __typename?: 'SpotlightEntity', id?: string | null, attributes?: { __typename?: 'Spotlight', title: string, subtitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null }> } | null };

type HomepageBody_ComponentSharedSteps_Fragment = { __typename: 'ComponentSharedSteps', id: string, alternativeTitle?: string | null, disableNumbering?: boolean | null, stepsAnchor?: string | null, stepsTitle?: string | null, step?: Array<{ __typename?: 'ComponentSharedStepCard', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, alternativeImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | null> | null, stepsButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type HomepageBody_ComponentSharedStripe_Fragment = { __typename: 'ComponentSharedStripe', id: string, titleSecondLine?: string | null, textColor?: Enum_Componentsharedstripe_Textcolor | null, backgroundColor?: Enum_Componentsharedstripe_Backgroundcolor | null, upperBackgroundColor?: Enum_Componentsharedstripe_Upperbackgroundcolor | null, lowerBackgroundColor?: Enum_Componentsharedstripe_Lowerbackgroundcolor | null, stripeTitle: string, stripeAnchorId?: string | null };

type HomepageBody_ComponentSharedTestimonialsSection_Fragment = { __typename: 'ComponentSharedTestimonialsSection', autoscrollInterval: number, testimonialsAnchor?: string | null, testimonials: Array<{ __typename?: 'ComponentSharedTestimonial', testimonial: string, author: string, authorType: string } | null> };

type HomepageBody_ComponentSharedTextBlock_Fragment = { __typename: 'ComponentSharedTextBlock', id: string, text: string };

type HomepageBody_ComponentSharedWorkoutsSection_Fragment = { __typename: 'ComponentSharedWorkoutsSection', id: string, expand?: boolean | null, workoutsTitle?: string | null, workoutsAnchor?: string | null, workouts?: { __typename?: 'ComponentSharedWorkouts', ids?: string | null, list: Array<{ __typename?: 'WorkoutDetail', id: string, name: string, duration: number, durationType: WorkoutDurationType, description?: string | null, tss: number, coinsForCompletion: number, difficulty?: string | null, trainingEffects: Array<string>, intensityFactor: number, segments: Array<{ __typename?: 'WorkoutSegment', duration: number, intervalType: WorkoutSegmentIntervalType, type: WorkoutSegmentPrimaryType, valueStart: number, valueEnd: number }>, recommendedRoute?: { __typename?: 'RouteOverview', simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', altitude: number, distance: number } | null> | null } | null }> } | null };

type HomepageBody_ComponentSharedYouTubeVideo_Fragment = { __typename: 'ComponentSharedYouTubeVideo', id: string, embedCode?: string | null, videoUrl?: string | null, caption: string, youTubeTitle: string, youTubeAnchor?: string | null, cover?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

type HomepageBody_Error_Fragment = { __typename: 'Error' };

export type HomepageBodyFragment = HomepageBody_ComponentSharedBlogPosts_Fragment | HomepageBody_ComponentSharedChallenges_Fragment | HomepageBody_ComponentSharedChecklist_Fragment | HomepageBody_ComponentSharedCompanionAppCta_Fragment | HomepageBody_ComponentSharedContentTeaser_Fragment | HomepageBody_ComponentSharedEvents_Fragment | HomepageBody_ComponentSharedFaq_Fragment | HomepageBody_ComponentSharedFeaturedLogo_Fragment | HomepageBody_ComponentSharedHeader_Fragment | HomepageBody_ComponentSharedHeaderVideo_Fragment | HomepageBody_ComponentSharedHighlights_Fragment | HomepageBody_ComponentSharedLinksCarousel_Fragment | HomepageBody_ComponentSharedLogoClouds_Fragment | HomepageBody_ComponentSharedNavbar_Fragment | HomepageBody_ComponentSharedNewsletterCta_Fragment | HomepageBody_ComponentSharedPageNavigation_Fragment | HomepageBody_ComponentSharedPlansSelector_Fragment | HomepageBody_ComponentSharedPricing_Fragment | HomepageBody_ComponentSharedPrizes_Fragment | HomepageBody_ComponentSharedProductsComparison_Fragment | HomepageBody_ComponentSharedRegisterCta_Fragment | HomepageBody_ComponentSharedRoutesSection_Fragment | HomepageBody_ComponentSharedSimpleCta_Fragment | HomepageBody_ComponentSharedSpotlights_Fragment | HomepageBody_ComponentSharedSpotlightsList_Fragment | HomepageBody_ComponentSharedSteps_Fragment | HomepageBody_ComponentSharedStripe_Fragment | HomepageBody_ComponentSharedTestimonialsSection_Fragment | HomepageBody_ComponentSharedTextBlock_Fragment | HomepageBody_ComponentSharedWorkoutsSection_Fragment | HomepageBody_ComponentSharedYouTubeVideo_Fragment | HomepageBody_Error_Fragment;

type DynamicPageBody_ComponentSharedBlogPosts_Fragment = { __typename: 'ComponentSharedBlogPosts', id: string, expand?: boolean | null, blogPostsTitle?: string | null, blogPostsAnchor?: string | null, blogPosts?: { __typename?: 'BlogPostRelationResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', title: string, perex: string, slug: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null }> } | null };

type DynamicPageBody_ComponentSharedChallenges_Fragment = { __typename: 'ComponentSharedChallenges', id: string, expand?: boolean | null, challengesAnchor?: string | null, challengesTitle?: string | null, challenges?: { __typename?: 'ChallengeRelationResponseCollection', data: Array<{ __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', challengeId: string, experience: number, startDateTime: string, endDateTime: string, title: string, expandTitle?: string | null, registeredCount: number, description?: string | null, logoOriginal?: string | null, coins: number, tasksAndRules?: Array<{ __typename?: 'ComponentSharedTasksRulesWidget', title: string, subtitle?: string | null, routes?: { __typename?: 'ComponentSharedRoutes', id: string } | null, workouts?: { __typename?: 'ComponentSharedWorkouts', id: string } | null } | null> | null } | null }> } | null };

type DynamicPageBody_ComponentSharedChecklist_Fragment = { __typename: 'ComponentSharedChecklist', id: string, vertical?: boolean | null, checklistTitle: string, checklistAnchor?: string | null, checklistItems: string };

type DynamicPageBody_ComponentSharedCompanionAppCta_Fragment = { __typename: 'ComponentSharedCompanionAppCta', id: string, companionAppCtaAnchor?: string | null, companionAppCtaTitle: string, companionAppCtaDescription?: string | null, companionAppCtaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null };

type DynamicPageBody_ComponentSharedContentTeaser_Fragment = { __typename: 'ComponentSharedContentTeaser', id: string, size: Enum_Componentsharedcontentteaser_Size, teaserTitle: string, teaserDescription?: string | null, teaserAnchor?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logoResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImageResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, cards?: Array<{ __typename?: 'ComponentSharedSimpleCard', title: string, description: string, url?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null };

type DynamicPageBody_ComponentSharedEvents_Fragment = { __typename: 'ComponentSharedEvents', id: string, category?: string | null, subcategory?: string | null, featured?: boolean | null, inverted?: boolean | null, expand?: boolean | null, eventsAnchor?: string | null, eventsTitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, eventInfos?: { __typename?: 'EventInfoRelationResponseCollection', data: Array<{ __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null }> } | null, featuredEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null>, filterEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null>, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null };

type DynamicPageBody_ComponentSharedFaq_Fragment = { __typename: 'ComponentSharedFaq', id: string, faqAnchor?: string | null, faqTitle?: string | null, question?: Array<{ __typename?: 'ComponentSharedQuestion', questionText?: string | null, answer?: string | null } | null> | null, faqButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type DynamicPageBody_ComponentSharedFeaturedLogo_Fragment = { __typename: 'ComponentSharedFeaturedLogo', id: string, title: string, featuredLogo: { __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } };

type DynamicPageBody_ComponentSharedHeader_Fragment = { __typename: 'ComponentSharedHeader', id: string, textLogo?: string | null, headline: string, subheading?: string | null, cdnVideoUrl?: string | null, cdnBackgroundImageUrl?: string | null, linkAfterEmailSubmit?: string | null, headerAnchor?: string | null, headerDescription?: string | null, headerCampaignId?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, responsiveImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null };

type DynamicPageBody_ComponentSharedHeaderAcceptInvite_Fragment = { __typename: 'ComponentSharedHeaderAcceptInvite', id: string, acceptInviteHeading: string, acceptInviteHeadingFallback?: string | null, acceptInviteSubheading: string, acceptInviteSubheadingFallback?: string | null, acceptInviteButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null }, acceptInviteButtonFallback?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, acceptInviteBackgroundImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } };

type DynamicPageBody_ComponentSharedHeaderVideo_Fragment = { __typename: 'ComponentSharedHeaderVideo', headline: string, subheading?: string | null, campaingId?: string | null, headerVideoDescription?: string | null, headerVideoAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null, headerVideo: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, headerVideoResponsive?: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null };

type DynamicPageBody_ComponentSharedHighlights_Fragment = { __typename: 'ComponentSharedHighlights', id: string, Layout?: Enum_Componentsharedhighlights_Layout | null, highlightsAnchor?: string | null, highlightsTitle?: string | null, Highlight?: Array<{ __typename?: 'ComponentSharedCard', contentTitle: string, contentText?: string | null, contentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | null> | null };

type DynamicPageBody_ComponentSharedLinksCarousel_Fragment = { __typename: 'ComponentSharedLinksCarousel', id: string, background?: Enum_Componentsharedlinkscarousel_Background | null, linksCarouselTitle?: string | null, linksCarouselAnchor?: string | null, linksCarouselButtonClickThrough?: boolean | null, items?: Array<{ __typename?: 'ComponentSharedLinksCarouselItem', title: string, description?: string | null, url?: string | null, label?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null };

type DynamicPageBody_ComponentSharedLogoClouds_Fragment = { __typename: 'ComponentSharedLogoClouds', id: string, logoCloudsTitle: string, logos: Array<{ __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> };

type DynamicPageBody_ComponentSharedNavbar_Fragment = { __typename: 'ComponentSharedNavbar', id: string, navbarAnchor?: string | null, navbarItems?: Array<{ __typename?: 'ComponentSharedNavbarItem', title: string, path: string } | null> | null };

type DynamicPageBody_ComponentSharedNewsletterCta_Fragment = { __typename: 'ComponentSharedNewsletterCta', id: string, description: string, hint: string, campaignId: string, formType?: Enum_Componentsharednewslettercta_Formtype | null, newsletterCtaAnchor?: string | null, ctaTitle: string, newsletterCtaButtonLabel?: string | null, visual?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

type DynamicPageBody_ComponentSharedPageNavigation_Fragment = { __typename: 'ComponentSharedPageNavigation', id: string, pageNavTitle?: string | null, pageNavDescription?: string | null, pageNavAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null };

type DynamicPageBody_ComponentSharedPlansSelector_Fragment = { __typename: 'ComponentSharedPlansSelector', id: string, termsSection?: string | null, plansSelectorTitle: string, plansSelectorSubtitle?: string | null, plansSelectorAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type DynamicPageBody_ComponentSharedPricing_Fragment = { __typename: 'ComponentSharedPricing', id: string, yearlyToMonths?: boolean | null, monthly: boolean, plan: Enum_Componentsharedpricing_Plan, termsSection?: string | null, linkAfterEmailSubmit?: string | null, pricingTitle: string, pricingContent?: string | null, pricingAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type DynamicPageBody_ComponentSharedPrizes_Fragment = { __typename: 'ComponentSharedPrizes', id: string, prizesAnchor?: string | null, prizesTitle?: string | null, Prizes?: Array<{ __typename?: 'ComponentWinnablePrize', title?: string | null, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, winner?: { __typename?: 'ComponentWinnableWinner', userName: string, profileImage?: string | null, firstName?: string | null, lastName?: string | null, countryCode: string } | null } | null> | null, Button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type DynamicPageBody_ComponentSharedProductsComparison_Fragment = { __typename: 'ComponentSharedProductsComparison', id: string, productsJson?: {} | null, productsComparisonTitle: string, productsComparisonSubtitle?: string | null, productsComparisonFeaturesTitle?: string | null, productsComparisonAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type DynamicPageBody_ComponentSharedRegisterCta_Fragment = { __typename: 'ComponentSharedRegisterCta', id: string, linkAfterEmailSubmit?: string | null, registerCtaTitle: string, registerCtaDescription?: string | null, registerCtaAnchor?: string | null, registerCtaCampaignId?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

type DynamicPageBody_ComponentSharedRoutesSection_Fragment = { __typename: 'ComponentSharedRoutesSection', id: string, type?: Enum_Componentsharedroutessection_Type | null, categorySlug?: string | null, offset?: number | null, limit?: number | null, expand?: boolean | null, routesTitle?: string | null, routesAnchor?: string | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null, routeIds?: { __typename?: 'ComponentSharedRoutes', ids?: string | null, list: Array<{ __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> }> } | null, routes?: Array<{ __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> }> | null };

type DynamicPageBody_ComponentSharedSimpleCta_Fragment = { __typename: 'ComponentSharedSimpleCta', id: string, simpleCtaAnchor?: string | null, simpleCtaTitle: string, simpleCtaDescription?: string | null, simpleCtaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, simpleCtaButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } };

type DynamicPageBody_ComponentSharedSpotlights_Fragment = { __typename: 'ComponentSharedSpotlights', id: string, spotlightsAnchorId?: string | null, spotlight?: { __typename?: 'SpotlightEntityResponse', data?: { __typename?: 'SpotlightEntity', attributes?: { __typename?: 'Spotlight', title: string, anchorId?: string | null, subtitle?: string | null, description?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, spotlights?: Array<{ __typename?: 'ComponentSharedSpotlight', id: string, routeId?: number | null, workoutId?: number | null, trainingPlanId?: number | null, route?: { __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> } | null, eventInfo?: { __typename?: 'EventInfoEntityResponse', data?: { __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null } | null } | null, challenge?: { __typename?: 'ChallengeEntityResponse', data?: { __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, logoOriginal?: string | null, startDateTime: string, endDateTime: string, prize?: string | null, state: ChallengeState, branded: boolean, experience: number, registeredCount: number, links: { __typename?: 'Links', detail: string } } | null } | null } | null, workout?: { __typename?: 'WorkoutDetail', id: string, name: string, duration: number, durationType: WorkoutDurationType, description?: string | null, tss: number, coinsForCompletion: number, difficulty?: string | null, trainingEffects: Array<string>, intensityFactor: number, segments: Array<{ __typename?: 'WorkoutSegment', duration: number, intervalType: WorkoutSegmentIntervalType, type: WorkoutSegmentPrimaryType, valueStart: number, valueEnd: number }>, recommendedRoute?: { __typename?: 'RouteOverview', simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', altitude: number, distance: number } | null> | null } | null } | null, trainingPlan?: { __typename?: 'TrainingPlanOverview', id: string, name: string, description: string, backgroundImageUrl: string, totalDurationSeconds: number, expectedDurationDays: number, coinsForCompletion: number, blocksCount: number, trainingUnitsCount: number, trainingPlanTags: Array<{ __typename?: 'TrainingPlanTag', id: string, name: string, color: string }> } | null, card?: { __typename?: 'ComponentSharedSimpleCard', id: string, title: string, description: string, url?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null } | null> | null } | null } | null } | null };

type DynamicPageBody_ComponentSharedSpotlightsList_Fragment = { __typename: 'ComponentSharedSpotlightsList', id: string, spotlightsListTitle?: string | null, spotlightsListAnchor?: string | null, spotlights?: { __typename?: 'SpotlightRelationResponseCollection', data: Array<{ __typename?: 'SpotlightEntity', id?: string | null, attributes?: { __typename?: 'Spotlight', title: string, subtitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null }> } | null };

type DynamicPageBody_ComponentSharedSteps_Fragment = { __typename: 'ComponentSharedSteps', id: string, alternativeTitle?: string | null, disableNumbering?: boolean | null, stepsAnchor?: string | null, stepsTitle?: string | null, step?: Array<{ __typename?: 'ComponentSharedStepCard', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, alternativeImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | null> | null, stepsButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type DynamicPageBody_ComponentSharedStripe_Fragment = { __typename: 'ComponentSharedStripe', id: string, titleSecondLine?: string | null, textColor?: Enum_Componentsharedstripe_Textcolor | null, backgroundColor?: Enum_Componentsharedstripe_Backgroundcolor | null, upperBackgroundColor?: Enum_Componentsharedstripe_Upperbackgroundcolor | null, lowerBackgroundColor?: Enum_Componentsharedstripe_Lowerbackgroundcolor | null, stripeTitle: string, stripeAnchorId?: string | null };

type DynamicPageBody_ComponentSharedTestimonialsSection_Fragment = { __typename: 'ComponentSharedTestimonialsSection', autoscrollInterval: number, testimonialsAnchor?: string | null, testimonials: Array<{ __typename?: 'ComponentSharedTestimonial', testimonial: string, author: string, authorType: string } | null> };

type DynamicPageBody_ComponentSharedTextBlock_Fragment = { __typename: 'ComponentSharedTextBlock', id: string, text: string };

type DynamicPageBody_ComponentSharedTwoColumnsContent_Fragment = { __typename: 'ComponentSharedTwoColumnsContent', twoColumnsContentTitle?: string | null, twoColumnsContentDescription?: string | null, twoColumnsContentText: string, twoColumnsContentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null };

type DynamicPageBody_ComponentSharedWorkoutsSection_Fragment = { __typename: 'ComponentSharedWorkoutsSection', id: string, expand?: boolean | null, workoutsTitle?: string | null, workoutsAnchor?: string | null, workouts?: { __typename?: 'ComponentSharedWorkouts', ids?: string | null, list: Array<{ __typename?: 'WorkoutDetail', id: string, name: string, duration: number, durationType: WorkoutDurationType, description?: string | null, tss: number, coinsForCompletion: number, difficulty?: string | null, trainingEffects: Array<string>, intensityFactor: number, segments: Array<{ __typename?: 'WorkoutSegment', duration: number, intervalType: WorkoutSegmentIntervalType, type: WorkoutSegmentPrimaryType, valueStart: number, valueEnd: number }>, recommendedRoute?: { __typename?: 'RouteOverview', simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', altitude: number, distance: number } | null> | null } | null }> } | null };

type DynamicPageBody_ComponentSharedYouTubeVideo_Fragment = { __typename: 'ComponentSharedYouTubeVideo', id: string, embedCode?: string | null, videoUrl?: string | null, caption: string, youTubeTitle: string, youTubeAnchor?: string | null, cover?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

type DynamicPageBody_Error_Fragment = { __typename: 'Error' };

export type DynamicPageBodyFragment = DynamicPageBody_ComponentSharedBlogPosts_Fragment | DynamicPageBody_ComponentSharedChallenges_Fragment | DynamicPageBody_ComponentSharedChecklist_Fragment | DynamicPageBody_ComponentSharedCompanionAppCta_Fragment | DynamicPageBody_ComponentSharedContentTeaser_Fragment | DynamicPageBody_ComponentSharedEvents_Fragment | DynamicPageBody_ComponentSharedFaq_Fragment | DynamicPageBody_ComponentSharedFeaturedLogo_Fragment | DynamicPageBody_ComponentSharedHeader_Fragment | DynamicPageBody_ComponentSharedHeaderAcceptInvite_Fragment | DynamicPageBody_ComponentSharedHeaderVideo_Fragment | DynamicPageBody_ComponentSharedHighlights_Fragment | DynamicPageBody_ComponentSharedLinksCarousel_Fragment | DynamicPageBody_ComponentSharedLogoClouds_Fragment | DynamicPageBody_ComponentSharedNavbar_Fragment | DynamicPageBody_ComponentSharedNewsletterCta_Fragment | DynamicPageBody_ComponentSharedPageNavigation_Fragment | DynamicPageBody_ComponentSharedPlansSelector_Fragment | DynamicPageBody_ComponentSharedPricing_Fragment | DynamicPageBody_ComponentSharedPrizes_Fragment | DynamicPageBody_ComponentSharedProductsComparison_Fragment | DynamicPageBody_ComponentSharedRegisterCta_Fragment | DynamicPageBody_ComponentSharedRoutesSection_Fragment | DynamicPageBody_ComponentSharedSimpleCta_Fragment | DynamicPageBody_ComponentSharedSpotlights_Fragment | DynamicPageBody_ComponentSharedSpotlightsList_Fragment | DynamicPageBody_ComponentSharedSteps_Fragment | DynamicPageBody_ComponentSharedStripe_Fragment | DynamicPageBody_ComponentSharedTestimonialsSection_Fragment | DynamicPageBody_ComponentSharedTextBlock_Fragment | DynamicPageBody_ComponentSharedTwoColumnsContent_Fragment | DynamicPageBody_ComponentSharedWorkoutsSection_Fragment | DynamicPageBody_ComponentSharedYouTubeVideo_Fragment | DynamicPageBody_Error_Fragment;

type BlogDynamicBody_ComponentSharedBlogPosts_Fragment = { __typename: 'ComponentSharedBlogPosts', id: string, expand?: boolean | null, blogPostsTitle?: string | null, blogPostsAnchor?: string | null, blogPosts?: { __typename?: 'BlogPostRelationResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', title: string, perex: string, slug: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null }> } | null };

type BlogDynamicBody_ComponentSharedChallenges_Fragment = { __typename: 'ComponentSharedChallenges', id: string, expand?: boolean | null, challengesAnchor?: string | null, challengesTitle?: string | null, challenges?: { __typename?: 'ChallengeRelationResponseCollection', data: Array<{ __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', challengeId: string, experience: number, startDateTime: string, endDateTime: string, title: string, expandTitle?: string | null, registeredCount: number, description?: string | null, logoOriginal?: string | null, coins: number, tasksAndRules?: Array<{ __typename?: 'ComponentSharedTasksRulesWidget', title: string, subtitle?: string | null, routes?: { __typename?: 'ComponentSharedRoutes', id: string } | null, workouts?: { __typename?: 'ComponentSharedWorkouts', id: string } | null } | null> | null } | null }> } | null };

type BlogDynamicBody_ComponentSharedChecklist_Fragment = { __typename: 'ComponentSharedChecklist', id: string, vertical?: boolean | null, checklistTitle: string, checklistAnchor?: string | null, checklistItems: string };

type BlogDynamicBody_ComponentSharedCompanionAppCta_Fragment = { __typename: 'ComponentSharedCompanionAppCta', id: string, companionAppCtaAnchor?: string | null, companionAppCtaTitle: string, companionAppCtaDescription?: string | null, companionAppCtaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null };

type BlogDynamicBody_ComponentSharedEvents_Fragment = { __typename: 'ComponentSharedEvents', id: string, category?: string | null, subcategory?: string | null, featured?: boolean | null, inverted?: boolean | null, expand?: boolean | null, eventsAnchor?: string | null, eventsTitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, eventInfos?: { __typename?: 'EventInfoRelationResponseCollection', data: Array<{ __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null }> } | null, featuredEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null>, filterEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null>, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null };

type BlogDynamicBody_ComponentSharedFaq_Fragment = { __typename: 'ComponentSharedFaq', id: string, faqAnchor?: string | null, faqTitle?: string | null, question?: Array<{ __typename?: 'ComponentSharedQuestion', questionText?: string | null, answer?: string | null } | null> | null, faqButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type BlogDynamicBody_ComponentSharedFeaturedLogo_Fragment = { __typename: 'ComponentSharedFeaturedLogo', id: string, title: string, featuredLogo: { __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } };

type BlogDynamicBody_ComponentSharedHighlights_Fragment = { __typename: 'ComponentSharedHighlights', id: string, Layout?: Enum_Componentsharedhighlights_Layout | null, highlightsAnchor?: string | null, highlightsTitle?: string | null, Highlight?: Array<{ __typename?: 'ComponentSharedCard', contentTitle: string, contentText?: string | null, contentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | null> | null };

type BlogDynamicBody_ComponentSharedLinksCarousel_Fragment = { __typename: 'ComponentSharedLinksCarousel', id: string, background?: Enum_Componentsharedlinkscarousel_Background | null, linksCarouselTitle?: string | null, linksCarouselAnchor?: string | null, linksCarouselButtonClickThrough?: boolean | null, items?: Array<{ __typename?: 'ComponentSharedLinksCarouselItem', title: string, description?: string | null, url?: string | null, label?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null };

type BlogDynamicBody_ComponentSharedLogoClouds_Fragment = { __typename: 'ComponentSharedLogoClouds', id: string, logoCloudsTitle: string, logos: Array<{ __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> };

type BlogDynamicBody_ComponentSharedNavbar_Fragment = { __typename: 'ComponentSharedNavbar', id: string, navbarAnchor?: string | null, navbarItems?: Array<{ __typename?: 'ComponentSharedNavbarItem', title: string, path: string } | null> | null };

type BlogDynamicBody_ComponentSharedNewsletterCta_Fragment = { __typename: 'ComponentSharedNewsletterCta', id: string, description: string, hint: string, campaignId: string, formType?: Enum_Componentsharednewslettercta_Formtype | null, newsletterCtaAnchor?: string | null, ctaTitle: string, newsletterCtaButtonLabel?: string | null, visual?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

type BlogDynamicBody_ComponentSharedPageNavigation_Fragment = { __typename: 'ComponentSharedPageNavigation', id: string, pageNavTitle?: string | null, pageNavDescription?: string | null, pageNavAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null };

type BlogDynamicBody_ComponentSharedPlansSelector_Fragment = { __typename: 'ComponentSharedPlansSelector', id: string, termsSection?: string | null, plansSelectorTitle: string, plansSelectorSubtitle?: string | null, plansSelectorAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type BlogDynamicBody_ComponentSharedPricing_Fragment = { __typename: 'ComponentSharedPricing', id: string, yearlyToMonths?: boolean | null, monthly: boolean, plan: Enum_Componentsharedpricing_Plan, termsSection?: string | null, linkAfterEmailSubmit?: string | null, pricingTitle: string, pricingContent?: string | null, pricingAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type BlogDynamicBody_ComponentSharedPrizes_Fragment = { __typename: 'ComponentSharedPrizes', id: string, prizesAnchor?: string | null, prizesTitle?: string | null, Prizes?: Array<{ __typename?: 'ComponentWinnablePrize', title?: string | null, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, winner?: { __typename?: 'ComponentWinnableWinner', userName: string, profileImage?: string | null, firstName?: string | null, lastName?: string | null, countryCode: string } | null } | null> | null, Button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type BlogDynamicBody_ComponentSharedProductsComparison_Fragment = { __typename: 'ComponentSharedProductsComparison', id: string, productsJson?: {} | null, productsComparisonTitle: string, productsComparisonSubtitle?: string | null, productsComparisonFeaturesTitle?: string | null, productsComparisonAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type BlogDynamicBody_ComponentSharedRegisterCta_Fragment = { __typename: 'ComponentSharedRegisterCta', id: string, linkAfterEmailSubmit?: string | null, registerCtaTitle: string, registerCtaDescription?: string | null, registerCtaAnchor?: string | null, registerCtaCampaignId?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

type BlogDynamicBody_ComponentSharedRoutesSection_Fragment = { __typename: 'ComponentSharedRoutesSection', id: string, type?: Enum_Componentsharedroutessection_Type | null, categorySlug?: string | null, offset?: number | null, limit?: number | null, expand?: boolean | null, routesTitle?: string | null, routesAnchor?: string | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null, routeIds?: { __typename?: 'ComponentSharedRoutes', ids?: string | null, list: Array<{ __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> }> } | null, routes?: Array<{ __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> }> | null };

type BlogDynamicBody_ComponentSharedSimpleCta_Fragment = { __typename: 'ComponentSharedSimpleCta', id: string, simpleCtaAnchor?: string | null, simpleCtaTitle: string, simpleCtaDescription?: string | null, simpleCtaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, simpleCtaButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } };

type BlogDynamicBody_ComponentSharedSpotlights_Fragment = { __typename: 'ComponentSharedSpotlights', id: string, spotlightsAnchorId?: string | null, spotlight?: { __typename?: 'SpotlightEntityResponse', data?: { __typename?: 'SpotlightEntity', attributes?: { __typename?: 'Spotlight', title: string, anchorId?: string | null, subtitle?: string | null, description?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, spotlights?: Array<{ __typename?: 'ComponentSharedSpotlight', id: string, routeId?: number | null, workoutId?: number | null, trainingPlanId?: number | null, route?: { __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> } | null, eventInfo?: { __typename?: 'EventInfoEntityResponse', data?: { __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null } | null } | null, challenge?: { __typename?: 'ChallengeEntityResponse', data?: { __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, logoOriginal?: string | null, startDateTime: string, endDateTime: string, prize?: string | null, state: ChallengeState, branded: boolean, experience: number, registeredCount: number, links: { __typename?: 'Links', detail: string } } | null } | null } | null, workout?: { __typename?: 'WorkoutDetail', id: string, name: string, duration: number, durationType: WorkoutDurationType, description?: string | null, tss: number, coinsForCompletion: number, difficulty?: string | null, trainingEffects: Array<string>, intensityFactor: number, segments: Array<{ __typename?: 'WorkoutSegment', duration: number, intervalType: WorkoutSegmentIntervalType, type: WorkoutSegmentPrimaryType, valueStart: number, valueEnd: number }>, recommendedRoute?: { __typename?: 'RouteOverview', simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', altitude: number, distance: number } | null> | null } | null } | null, trainingPlan?: { __typename?: 'TrainingPlanOverview', id: string, name: string, description: string, backgroundImageUrl: string, totalDurationSeconds: number, expectedDurationDays: number, coinsForCompletion: number, blocksCount: number, trainingUnitsCount: number, trainingPlanTags: Array<{ __typename?: 'TrainingPlanTag', id: string, name: string, color: string }> } | null, card?: { __typename?: 'ComponentSharedSimpleCard', id: string, title: string, description: string, url?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null } | null> | null } | null } | null } | null };

type BlogDynamicBody_ComponentSharedSpotlightsList_Fragment = { __typename: 'ComponentSharedSpotlightsList', id: string, spotlightsListTitle?: string | null, spotlightsListAnchor?: string | null, spotlights?: { __typename?: 'SpotlightRelationResponseCollection', data: Array<{ __typename?: 'SpotlightEntity', id?: string | null, attributes?: { __typename?: 'Spotlight', title: string, subtitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null }> } | null };

type BlogDynamicBody_ComponentSharedSteps_Fragment = { __typename: 'ComponentSharedSteps', id: string, alternativeTitle?: string | null, disableNumbering?: boolean | null, stepsAnchor?: string | null, stepsTitle?: string | null, step?: Array<{ __typename?: 'ComponentSharedStepCard', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, alternativeImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | null> | null, stepsButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

type BlogDynamicBody_ComponentSharedStripe_Fragment = { __typename: 'ComponentSharedStripe', id: string, titleSecondLine?: string | null, textColor?: Enum_Componentsharedstripe_Textcolor | null, backgroundColor?: Enum_Componentsharedstripe_Backgroundcolor | null, upperBackgroundColor?: Enum_Componentsharedstripe_Upperbackgroundcolor | null, lowerBackgroundColor?: Enum_Componentsharedstripe_Lowerbackgroundcolor | null, stripeTitle: string, stripeAnchorId?: string | null };

type BlogDynamicBody_ComponentSharedTestimonialsSection_Fragment = { __typename: 'ComponentSharedTestimonialsSection', autoscrollInterval: number, testimonialsAnchor?: string | null, testimonials: Array<{ __typename?: 'ComponentSharedTestimonial', testimonial: string, author: string, authorType: string } | null> };

type BlogDynamicBody_ComponentSharedTextBlock_Fragment = { __typename: 'ComponentSharedTextBlock', id: string, text: string };

type BlogDynamicBody_ComponentSharedTwoColumnsContent_Fragment = { __typename: 'ComponentSharedTwoColumnsContent', twoColumnsContentTitle?: string | null, twoColumnsContentDescription?: string | null, twoColumnsContentText: string, twoColumnsContentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null };

type BlogDynamicBody_ComponentSharedWorkoutsSection_Fragment = { __typename: 'ComponentSharedWorkoutsSection', id: string, expand?: boolean | null, workoutsTitle?: string | null, workoutsAnchor?: string | null, workouts?: { __typename?: 'ComponentSharedWorkouts', ids?: string | null, list: Array<{ __typename?: 'WorkoutDetail', id: string, name: string, duration: number, durationType: WorkoutDurationType, description?: string | null, tss: number, coinsForCompletion: number, difficulty?: string | null, trainingEffects: Array<string>, intensityFactor: number, segments: Array<{ __typename?: 'WorkoutSegment', duration: number, intervalType: WorkoutSegmentIntervalType, type: WorkoutSegmentPrimaryType, valueStart: number, valueEnd: number }>, recommendedRoute?: { __typename?: 'RouteOverview', simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', altitude: number, distance: number } | null> | null } | null }> } | null };

type BlogDynamicBody_ComponentSharedYouTubeVideo_Fragment = { __typename: 'ComponentSharedYouTubeVideo', id: string, embedCode?: string | null, videoUrl?: string | null, caption: string, youTubeTitle: string, youTubeAnchor?: string | null, cover?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

type BlogDynamicBody_Error_Fragment = { __typename: 'Error' };

export type BlogDynamicBodyFragment = BlogDynamicBody_ComponentSharedBlogPosts_Fragment | BlogDynamicBody_ComponentSharedChallenges_Fragment | BlogDynamicBody_ComponentSharedChecklist_Fragment | BlogDynamicBody_ComponentSharedCompanionAppCta_Fragment | BlogDynamicBody_ComponentSharedEvents_Fragment | BlogDynamicBody_ComponentSharedFaq_Fragment | BlogDynamicBody_ComponentSharedFeaturedLogo_Fragment | BlogDynamicBody_ComponentSharedHighlights_Fragment | BlogDynamicBody_ComponentSharedLinksCarousel_Fragment | BlogDynamicBody_ComponentSharedLogoClouds_Fragment | BlogDynamicBody_ComponentSharedNavbar_Fragment | BlogDynamicBody_ComponentSharedNewsletterCta_Fragment | BlogDynamicBody_ComponentSharedPageNavigation_Fragment | BlogDynamicBody_ComponentSharedPlansSelector_Fragment | BlogDynamicBody_ComponentSharedPricing_Fragment | BlogDynamicBody_ComponentSharedPrizes_Fragment | BlogDynamicBody_ComponentSharedProductsComparison_Fragment | BlogDynamicBody_ComponentSharedRegisterCta_Fragment | BlogDynamicBody_ComponentSharedRoutesSection_Fragment | BlogDynamicBody_ComponentSharedSimpleCta_Fragment | BlogDynamicBody_ComponentSharedSpotlights_Fragment | BlogDynamicBody_ComponentSharedSpotlightsList_Fragment | BlogDynamicBody_ComponentSharedSteps_Fragment | BlogDynamicBody_ComponentSharedStripe_Fragment | BlogDynamicBody_ComponentSharedTestimonialsSection_Fragment | BlogDynamicBody_ComponentSharedTextBlock_Fragment | BlogDynamicBody_ComponentSharedTwoColumnsContent_Fragment | BlogDynamicBody_ComponentSharedWorkoutsSection_Fragment | BlogDynamicBody_ComponentSharedYouTubeVideo_Fragment | BlogDynamicBody_Error_Fragment;

export type BlogPostListItemFragment = { __typename?: 'BlogPost', title: string, perex: string, slug: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } };

export type BlogPostsFragment = { __typename?: 'ComponentSharedBlogPosts', id: string, expand?: boolean | null, blogPostsTitle?: string | null, blogPostsAnchor?: string | null, blogPosts?: { __typename?: 'BlogPostRelationResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', title: string, perex: string, slug: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null }> } | null };

export type ChallengeFragment = { __typename?: 'Challenge', challengeId: string, experience: number, startDateTime: string, endDateTime: string, title: string, expandTitle?: string | null, registeredCount: number, description?: string | null, logoOriginal?: string | null, coins: number, tasksAndRules?: Array<{ __typename?: 'ComponentSharedTasksRulesWidget', title: string, subtitle?: string | null, routes?: { __typename?: 'ComponentSharedRoutes', id: string } | null, workouts?: { __typename?: 'ComponentSharedWorkouts', id: string } | null } | null> | null };

export type ChallengesFragment = { __typename?: 'ComponentSharedChallenges', id: string, expand?: boolean | null, challengesAnchor?: string | null, challengesTitle?: string | null, challenges?: { __typename?: 'ChallengeRelationResponseCollection', data: Array<{ __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', challengeId: string, experience: number, startDateTime: string, endDateTime: string, title: string, expandTitle?: string | null, registeredCount: number, description?: string | null, logoOriginal?: string | null, coins: number, tasksAndRules?: Array<{ __typename?: 'ComponentSharedTasksRulesWidget', title: string, subtitle?: string | null, routes?: { __typename?: 'ComponentSharedRoutes', id: string } | null, workouts?: { __typename?: 'ComponentSharedWorkouts', id: string } | null } | null> | null } | null }> } | null };

export type ChecklistFragment = { __typename?: 'ComponentSharedChecklist', id: string, vertical?: boolean | null, checklistTitle: string, checklistAnchor?: string | null, checklistItems: string };

export type CompanionAppCtaFragment = { __typename?: 'ComponentSharedCompanionAppCta', id: string, companionAppCtaAnchor?: string | null, companionAppCtaTitle: string, companionAppCtaDescription?: string | null, companionAppCtaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null };

export type ContentTeaserFragment = { __typename?: 'ComponentSharedContentTeaser', id: string, size: Enum_Componentsharedcontentteaser_Size, teaserTitle: string, teaserDescription?: string | null, teaserAnchor?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logoResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImageResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, cards?: Array<{ __typename?: 'ComponentSharedSimpleCard', title: string, description: string, url?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null };

export type EventsFragment = { __typename?: 'ComponentSharedEvents', id: string, category?: string | null, subcategory?: string | null, featured?: boolean | null, inverted?: boolean | null, expand?: boolean | null, eventsAnchor?: string | null, eventsTitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, eventInfos?: { __typename?: 'EventInfoRelationResponseCollection', data: Array<{ __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null }> } | null, featuredEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null>, filterEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null>, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null };

export type QuestionFragment = { __typename?: 'ComponentSharedQuestion', questionText?: string | null, answer?: string | null };

export type FaqFragment = { __typename?: 'ComponentSharedFaq', id: string, faqAnchor?: string | null, faqTitle?: string | null, question?: Array<{ __typename?: 'ComponentSharedQuestion', questionText?: string | null, answer?: string | null } | null> | null, faqButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

export type FeaturedLogoFragment = { __typename?: 'ComponentSharedFeaturedLogo', id: string, title: string, featuredLogo: { __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } };

export type HeaderAcceptInviteFragment = { __typename?: 'ComponentSharedHeaderAcceptInvite', id: string, acceptInviteHeading: string, acceptInviteHeadingFallback?: string | null, acceptInviteSubheading: string, acceptInviteSubheadingFallback?: string | null, acceptInviteButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null }, acceptInviteButtonFallback?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, acceptInviteBackgroundImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } };

export type VideoFragment = { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

export type HeaderVideoFragment = { __typename?: 'ComponentSharedHeaderVideo', headline: string, subheading?: string | null, campaingId?: string | null, headerVideoDescription?: string | null, headerVideoAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null, headerVideo: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, headerVideoResponsive?: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null };

export type HeaderFragment = { __typename?: 'ComponentSharedHeader', id: string, textLogo?: string | null, headline: string, subheading?: string | null, cdnVideoUrl?: string | null, cdnBackgroundImageUrl?: string | null, linkAfterEmailSubmit?: string | null, headerAnchor?: string | null, headerDescription?: string | null, headerCampaignId?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, responsiveImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null };

export type ContentCardFragment = { __typename?: 'ComponentSharedCard', contentTitle: string, contentText?: string | null, contentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

export type HighlightsFragment = { __typename?: 'ComponentSharedHighlights', id: string, Layout?: Enum_Componentsharedhighlights_Layout | null, highlightsAnchor?: string | null, highlightsTitle?: string | null, Highlight?: Array<{ __typename?: 'ComponentSharedCard', contentTitle: string, contentText?: string | null, contentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | null> | null };

export type LinksCarouselFragment = { __typename?: 'ComponentSharedLinksCarousel', id: string, background?: Enum_Componentsharedlinkscarousel_Background | null, linksCarouselTitle?: string | null, linksCarouselAnchor?: string | null, linksCarouselButtonClickThrough?: boolean | null, items?: Array<{ __typename?: 'ComponentSharedLinksCarouselItem', title: string, description?: string | null, url?: string | null, label?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null };

export type LogoCloudsFragment = { __typename?: 'ComponentSharedLogoClouds', id: string, logoCloudsTitle: string, logos: Array<{ __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> };

export type NavbarFragment = { __typename?: 'ComponentSharedNavbar', id: string, navbarAnchor?: string | null, navbarItems?: Array<{ __typename?: 'ComponentSharedNavbarItem', title: string, path: string } | null> | null };

export type NewsletterCtaFragment = { __typename?: 'ComponentSharedNewsletterCta', id: string, description: string, hint: string, campaignId: string, formType?: Enum_Componentsharednewslettercta_Formtype | null, newsletterCtaAnchor?: string | null, ctaTitle: string, newsletterCtaButtonLabel?: string | null, visual?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

export type PageNavigationFragment = { __typename?: 'ComponentSharedPageNavigation', id: string, pageNavTitle?: string | null, pageNavDescription?: string | null, pageNavAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null };

export type PlansSelectorFragment = { __typename?: 'ComponentSharedPlansSelector', id: string, termsSection?: string | null, plansSelectorTitle: string, plansSelectorSubtitle?: string | null, plansSelectorAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

export type PricingFragment = { __typename?: 'ComponentSharedPricing', id: string, yearlyToMonths?: boolean | null, monthly: boolean, plan: Enum_Componentsharedpricing_Plan, termsSection?: string | null, linkAfterEmailSubmit?: string | null, pricingTitle: string, pricingContent?: string | null, pricingAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

export type EventsWinnerFragment = { __typename?: 'ComponentWinnableWinner', userName: string, profileImage?: string | null, firstName?: string | null, lastName?: string | null, countryCode: string };

export type ChallengePrizeFragment = { __typename?: 'ComponentWinnablePrize', title?: string | null, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, winner?: { __typename?: 'ComponentWinnableWinner', userName: string, profileImage?: string | null, firstName?: string | null, lastName?: string | null, countryCode: string } | null };

export type PrizesFragment = { __typename?: 'ComponentSharedPrizes', id: string, prizesAnchor?: string | null, prizesTitle?: string | null, Prizes?: Array<{ __typename?: 'ComponentWinnablePrize', title?: string | null, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, winner?: { __typename?: 'ComponentWinnableWinner', userName: string, profileImage?: string | null, firstName?: string | null, lastName?: string | null, countryCode: string } | null } | null> | null, Button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

export type ProductsComparisonFragment = { __typename?: 'ComponentSharedProductsComparison', id: string, productsJson?: {} | null, productsComparisonTitle: string, productsComparisonSubtitle?: string | null, productsComparisonFeaturesTitle?: string | null, productsComparisonAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

export type RegisterCtaFragment = { __typename?: 'ComponentSharedRegisterCta', id: string, linkAfterEmailSubmit?: string | null, registerCtaTitle: string, registerCtaDescription?: string | null, registerCtaAnchor?: string | null, registerCtaCampaignId?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

export type RoutesSectionFragment = { __typename?: 'ComponentSharedRoutesSection', id: string, type?: Enum_Componentsharedroutessection_Type | null, categorySlug?: string | null, offset?: number | null, limit?: number | null, expand?: boolean | null, routesTitle?: string | null, routesAnchor?: string | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null, routeIds?: { __typename?: 'ComponentSharedRoutes', ids?: string | null, list: Array<{ __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> }> } | null, routes?: Array<{ __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> }> | null };

export type SimpleCtaFragment = { __typename?: 'ComponentSharedSimpleCta', id: string, simpleCtaAnchor?: string | null, simpleCtaTitle: string, simpleCtaDescription?: string | null, simpleCtaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, simpleCtaButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } };

export type SpotlightsListItemFragment = { __typename?: 'Spotlight', title: string, subtitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

export type SpotlightRelationResponseCollectionFragment = { __typename?: 'SpotlightRelationResponseCollection', data: Array<{ __typename?: 'SpotlightEntity', id?: string | null, attributes?: { __typename?: 'Spotlight', title: string, subtitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null }> };

export type SpotlightsListFragment = { __typename?: 'ComponentSharedSpotlightsList', id: string, spotlightsListTitle?: string | null, spotlightsListAnchor?: string | null, spotlights?: { __typename?: 'SpotlightRelationResponseCollection', data: Array<{ __typename?: 'SpotlightEntity', id?: string | null, attributes?: { __typename?: 'Spotlight', title: string, subtitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null }> } | null };

export type SimpleCardFragment = { __typename?: 'ComponentSharedSimpleCard', id: string, title: string, description: string, url?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } };

export type SpotlightFragment = { __typename?: 'ComponentSharedSpotlight', id: string, routeId?: number | null, workoutId?: number | null, trainingPlanId?: number | null, route?: { __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> } | null, eventInfo?: { __typename?: 'EventInfoEntityResponse', data?: { __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null } | null } | null, challenge?: { __typename?: 'ChallengeEntityResponse', data?: { __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, logoOriginal?: string | null, startDateTime: string, endDateTime: string, prize?: string | null, state: ChallengeState, branded: boolean, experience: number, registeredCount: number, links: { __typename?: 'Links', detail: string } } | null } | null } | null, workout?: { __typename?: 'WorkoutDetail', id: string, name: string, duration: number, durationType: WorkoutDurationType, description?: string | null, tss: number, coinsForCompletion: number, difficulty?: string | null, trainingEffects: Array<string>, intensityFactor: number, segments: Array<{ __typename?: 'WorkoutSegment', duration: number, intervalType: WorkoutSegmentIntervalType, type: WorkoutSegmentPrimaryType, valueStart: number, valueEnd: number }>, recommendedRoute?: { __typename?: 'RouteOverview', simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', altitude: number, distance: number } | null> | null } | null } | null, trainingPlan?: { __typename?: 'TrainingPlanOverview', id: string, name: string, description: string, backgroundImageUrl: string, totalDurationSeconds: number, expectedDurationDays: number, coinsForCompletion: number, blocksCount: number, trainingUnitsCount: number, trainingPlanTags: Array<{ __typename?: 'TrainingPlanTag', id: string, name: string, color: string }> } | null, card?: { __typename?: 'ComponentSharedSimpleCard', id: string, title: string, description: string, url?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null };

export type SpotlightsFragment = { __typename?: 'ComponentSharedSpotlights', id: string, spotlightsAnchorId?: string | null, spotlight?: { __typename?: 'SpotlightEntityResponse', data?: { __typename?: 'SpotlightEntity', attributes?: { __typename?: 'Spotlight', title: string, anchorId?: string | null, subtitle?: string | null, description?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, spotlights?: Array<{ __typename?: 'ComponentSharedSpotlight', id: string, routeId?: number | null, workoutId?: number | null, trainingPlanId?: number | null, route?: { __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> } | null, eventInfo?: { __typename?: 'EventInfoEntityResponse', data?: { __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null } | null } | null, challenge?: { __typename?: 'ChallengeEntityResponse', data?: { __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, logoOriginal?: string | null, startDateTime: string, endDateTime: string, prize?: string | null, state: ChallengeState, branded: boolean, experience: number, registeredCount: number, links: { __typename?: 'Links', detail: string } } | null } | null } | null, workout?: { __typename?: 'WorkoutDetail', id: string, name: string, duration: number, durationType: WorkoutDurationType, description?: string | null, tss: number, coinsForCompletion: number, difficulty?: string | null, trainingEffects: Array<string>, intensityFactor: number, segments: Array<{ __typename?: 'WorkoutSegment', duration: number, intervalType: WorkoutSegmentIntervalType, type: WorkoutSegmentPrimaryType, valueStart: number, valueEnd: number }>, recommendedRoute?: { __typename?: 'RouteOverview', simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', altitude: number, distance: number } | null> | null } | null } | null, trainingPlan?: { __typename?: 'TrainingPlanOverview', id: string, name: string, description: string, backgroundImageUrl: string, totalDurationSeconds: number, expectedDurationDays: number, coinsForCompletion: number, blocksCount: number, trainingUnitsCount: number, trainingPlanTags: Array<{ __typename?: 'TrainingPlanTag', id: string, name: string, color: string }> } | null, card?: { __typename?: 'ComponentSharedSimpleCard', id: string, title: string, description: string, url?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null } | null> | null } | null } | null } | null };

export type StepFragment = { __typename?: 'ComponentSharedStepCard', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, alternativeImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null };

export type StepsFragment = { __typename?: 'ComponentSharedSteps', id: string, alternativeTitle?: string | null, disableNumbering?: boolean | null, stepsAnchor?: string | null, stepsTitle?: string | null, step?: Array<{ __typename?: 'ComponentSharedStepCard', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, alternativeImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | null> | null, stepsButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null };

export type StripeFragment = { __typename?: 'ComponentSharedStripe', id: string, titleSecondLine?: string | null, textColor?: Enum_Componentsharedstripe_Textcolor | null, backgroundColor?: Enum_Componentsharedstripe_Backgroundcolor | null, upperBackgroundColor?: Enum_Componentsharedstripe_Upperbackgroundcolor | null, lowerBackgroundColor?: Enum_Componentsharedstripe_Lowerbackgroundcolor | null, stripeTitle: string, stripeAnchorId?: string | null };

export type TestimonialFragment = { __typename?: 'ComponentSharedTestimonial', testimonial: string, author: string, authorType: string };

export type TestimonialsSectionFragment = { __typename?: 'ComponentSharedTestimonialsSection', autoscrollInterval: number, testimonialsAnchor?: string | null, testimonials: Array<{ __typename?: 'ComponentSharedTestimonial', testimonial: string, author: string, authorType: string } | null> };

export type TextBlockFragment = { __typename?: 'ComponentSharedTextBlock', id: string, text: string };

export type TwoColumnsContentFragment = { __typename?: 'ComponentSharedTwoColumnsContent', twoColumnsContentTitle?: string | null, twoColumnsContentDescription?: string | null, twoColumnsContentText: string, twoColumnsContentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null };

export type WorkoutsSectionFragment = { __typename?: 'ComponentSharedWorkoutsSection', id: string, expand?: boolean | null, workoutsTitle?: string | null, workoutsAnchor?: string | null, workouts?: { __typename?: 'ComponentSharedWorkouts', ids?: string | null, list: Array<{ __typename?: 'WorkoutDetail', id: string, name: string, duration: number, durationType: WorkoutDurationType, description?: string | null, tss: number, coinsForCompletion: number, difficulty?: string | null, trainingEffects: Array<string>, intensityFactor: number, segments: Array<{ __typename?: 'WorkoutSegment', duration: number, intervalType: WorkoutSegmentIntervalType, type: WorkoutSegmentPrimaryType, valueStart: number, valueEnd: number }>, recommendedRoute?: { __typename?: 'RouteOverview', simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', altitude: number, distance: number } | null> | null } | null }> } | null };

export type YoutubeVideoFragment = { __typename?: 'ComponentSharedYouTubeVideo', id: string, embedCode?: string | null, videoUrl?: string | null, caption: string, youTubeTitle: string, youTubeAnchor?: string | null, cover?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

export type EventInfoEntityFragment = { __typename?: 'EventInfoEntityResponse', data?: { __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null } | null };

export type EventInfoEntityRelationCollectionItemFragment = { __typename?: 'EventInfoRelationResponseCollection', data: Array<{ __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null }> };

export type EventInfoFragment = { __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> };

export type LogoFragment = { __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } };

export type NavbarSettingsFragment = { __typename?: 'ComponentSharedNavbarSettings', transparent?: boolean | null, fixed?: boolean | null, secondaryLogoLink?: string | null, logoLink?: { __typename?: 'ComponentSharedLink', url: string, title: string } | null, navLinks?: Array<{ __typename?: 'ComponentSharedLink', url: string, title: string } | null> | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null, secondaryLogo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

export type RouteOverviewFragment = { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null };

export type RoutesPageListItemFragment = { __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> };

export type RoutePointGeoFragment = { __typename?: 'RoutePointGeo', distance: number, altitude: number };

export type PartnerListItemFragment = { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

export type SeoFragment = { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null };

export type TrainingPlanTagFragment = { __typename?: 'TrainingPlanTag', id: string, name: string, color: string };

export type TrainingPlanOverviewFragment = { __typename?: 'TrainingPlanOverview', id: string, name: string, description: string, backgroundImageUrl: string, totalDurationSeconds: number, expectedDurationDays: number, coinsForCompletion: number, blocksCount: number, trainingUnitsCount: number, trainingPlanTags: Array<{ __typename?: 'TrainingPlanTag', id: string, name: string, color: string }> };

export type UploadFileRelationResponseCollectionFragment = { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> };

export type UploadFileEntityResponseFragment = { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null };

export type UploadFileEntityFragment = { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null };

export type UploadFileFragment = { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null };

export type WorkoutFragment = { __typename?: 'WorkoutDetail', id: string, name: string, duration: number, durationType: WorkoutDurationType, description?: string | null, tss: number, coinsForCompletion: number, difficulty?: string | null, trainingEffects: Array<string>, intensityFactor: number, segments: Array<{ __typename?: 'WorkoutSegment', duration: number, intervalType: WorkoutSegmentIntervalType, type: WorkoutSegmentPrimaryType, valueStart: number, valueEnd: number }>, recommendedRoute?: { __typename?: 'RouteOverview', simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', altitude: number, distance: number } | null> | null } | null };

export type WorkoutSegmentFragment = { __typename?: 'WorkoutSegment', duration: number, intervalType: WorkoutSegmentIntervalType, type: WorkoutSegmentPrimaryType, valueStart: number, valueEnd: number };

export type AuthorFragment = { __typename?: 'Author', id: string, name: string, slug: string, perex?: string | null, locale?: string | null, updatedAt?: string | null, jobTitle?: string | null, socialPlatform?: Array<{ __typename?: 'ComponentSharedSocialPlatform', type: Enum_Componentsharedsocialplatform_Type, link: string } | null> | null, SEO?: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, profilePhoto?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null };

export type AuthorBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type AuthorBySlugQuery = { __typename?: 'Query', authorBySlug?: { __typename?: 'Author', id: string, name: string, slug: string, perex?: string | null, locale?: string | null, updatedAt?: string | null, jobTitle?: string | null, localizations?: { __typename?: 'AuthorRelationResponseCollection', data: Array<{ __typename?: 'AuthorEntity', attributes?: { __typename?: 'Author', locale?: string | null } | null }> } | null, socialPlatform?: Array<{ __typename?: 'ComponentSharedSocialPlatform', type: Enum_Componentsharedsocialplatform_Type, link: string } | null> | null, SEO?: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, profilePhoto?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | null };

export type AuthorsQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type AuthorsQuery = { __typename?: 'Query', authors: Array<{ __typename?: 'Author', id: string, name: string, slug: string, perex?: string | null, locale?: string | null, updatedAt?: string | null, jobTitle?: string | null, socialPlatform?: Array<{ __typename?: 'ComponentSharedSocialPlatform', type: Enum_Componentsharedsocialplatform_Type, link: string } | null> | null, SEO?: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, profilePhoto?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null }> };

export type AuthorsSitemapQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type AuthorsSitemapQuery = { __typename?: 'Query', authors: Array<{ __typename?: 'Author', slug: string, locale?: string | null, updatedAt?: string | null, SEO?: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null } | null, localizations?: { __typename?: 'AuthorRelationResponseCollection', data: Array<{ __typename?: 'AuthorEntity', attributes?: { __typename?: 'Author', locale?: string | null, updatedAt?: string | null, SEO?: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null } | null } | null }> } | null }> };

export type BlogCategoriesQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type BlogCategoriesQuery = { __typename?: 'Query', blogCategories: Array<{ __typename?: 'BlogCategory', id: string, title: string, slug: string, locale?: string | null, SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, localizations?: { __typename?: 'BlogCategoryRelationResponseCollection', data: Array<{ __typename?: 'BlogCategoryEntity', attributes?: { __typename?: 'BlogCategory', locale?: string | null } | null }> } | null }> };

export type BlogCategoriesSitemapQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type BlogCategoriesSitemapQuery = { __typename?: 'Query', blogCategories: Array<{ __typename?: 'BlogCategory', slug: string, updatedAt?: string | null, SEO: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null }, localizations?: { __typename?: 'BlogCategoryRelationResponseCollection', data: Array<{ __typename?: 'BlogCategoryEntity', attributes?: { __typename?: 'BlogCategory', updatedAt?: string | null, locale?: string | null, SEO: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null } } | null }> } | null }> };

export type BlogPostsQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type BlogPostsQuery = { __typename?: 'Query', blogPosts: Array<{ __typename?: 'BlogPost', id: string, title: string, slug: string, perex: string, publishDate: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, author?: { __typename?: 'AuthorEntityResponse', data?: { __typename?: 'AuthorEntity', attributes?: { __typename?: 'Author', name: string, slug: string, profilePhoto?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | null } | null } | null, blog_tags?: { __typename?: 'BlogTagRelationResponseCollection', data: Array<{ __typename?: 'BlogTagEntity', id?: string | null, attributes?: { __typename?: 'BlogTag', title: string, slug: string } | null }> } | null, blog_category?: { __typename?: 'BlogCategoryEntityResponse', data?: { __typename?: 'BlogCategoryEntity', attributes?: { __typename?: 'BlogCategory', title: string, slug: string } | null } | null } | null }> };

export type BlogPostsSitemapQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type BlogPostsSitemapQuery = { __typename?: 'Query', blogPosts: Array<{ __typename?: 'BlogPost', slug: string, locale?: string | null, updatedAt?: string | null, SEO: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null }, localizations?: { __typename?: 'BlogPostRelationResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', locale?: string | null, updatedAt?: string | null, SEO: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null } } | null }> } | null }> };

export type BlogPostsSearchQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type BlogPostsSearchQuery = { __typename?: 'Query', blogPostsSearch: Array<{ __typename?: 'BlogPost', id: string, title: string, slug: string, perex: string, publishDate: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, author?: { __typename?: 'AuthorEntityResponse', data?: { __typename?: 'AuthorEntity', attributes?: { __typename?: 'Author', name: string, slug: string, profilePhoto?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | null } | null } | null, blog_tags?: { __typename?: 'BlogTagRelationResponseCollection', data: Array<{ __typename?: 'BlogTagEntity', id?: string | null, attributes?: { __typename?: 'BlogTag', title: string, slug: string } | null }> } | null, blog_category?: { __typename?: 'BlogCategoryEntityResponse', data?: { __typename?: 'BlogCategoryEntity', attributes?: { __typename?: 'BlogCategory', title: string, slug: string } | null } | null } | null }> };

export type BlogPostsListItemFragment = { __typename?: 'BlogPost', id: string, title: string, slug: string, perex: string, publishDate: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, author?: { __typename?: 'AuthorEntityResponse', data?: { __typename?: 'AuthorEntity', attributes?: { __typename?: 'Author', name: string, slug: string, profilePhoto?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | null } | null } | null, blog_tags?: { __typename?: 'BlogTagRelationResponseCollection', data: Array<{ __typename?: 'BlogTagEntity', id?: string | null, attributes?: { __typename?: 'BlogTag', title: string, slug: string } | null }> } | null, blog_category?: { __typename?: 'BlogCategoryEntityResponse', data?: { __typename?: 'BlogCategoryEntity', attributes?: { __typename?: 'BlogCategory', title: string, slug: string } | null } | null } | null };

export type BlogPostsBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type BlogPostsBySlugQuery = { __typename?: 'Query', blogPostBySlug?: { __typename?: 'BlogPost', id: string, title: string, slug: string, perex: string, body?: string | null, publishDate: string, structuredDataHeadline?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, author?: { __typename?: 'AuthorEntityResponse', data?: { __typename?: 'AuthorEntity', id?: string | null, attributes?: { __typename?: 'Author', name: string, slug: string, perex?: string | null, locale?: string | null, updatedAt?: string | null, profilePhoto?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | null } | null } | null, blog_tags?: { __typename?: 'BlogTagRelationResponseCollection', data: Array<{ __typename?: 'BlogTagEntity', id?: string | null, attributes?: { __typename?: 'BlogTag', title: string, slug: string } | null }> } | null, blog_category?: { __typename?: 'BlogCategoryEntityResponse', data?: { __typename?: 'BlogCategoryEntity', id?: string | null, attributes?: { __typename?: 'BlogCategory', title: string, slug: string, locale?: string | null, updatedAt?: string | null, SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } } | null } | null } | null, dynamicBody?: Array<{ __typename: 'ComponentSharedBlogPosts', id: string, expand?: boolean | null, blogPostsTitle?: string | null, blogPostsAnchor?: string | null, blogPosts?: { __typename?: 'BlogPostRelationResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', title: string, perex: string, slug: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null }> } | null } | { __typename: 'ComponentSharedChallenges', id: string, expand?: boolean | null, challengesAnchor?: string | null, challengesTitle?: string | null, challenges?: { __typename?: 'ChallengeRelationResponseCollection', data: Array<{ __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', challengeId: string, experience: number, startDateTime: string, endDateTime: string, title: string, expandTitle?: string | null, registeredCount: number, description?: string | null, logoOriginal?: string | null, coins: number, tasksAndRules?: Array<{ __typename?: 'ComponentSharedTasksRulesWidget', title: string, subtitle?: string | null, routes?: { __typename?: 'ComponentSharedRoutes', id: string } | null, workouts?: { __typename?: 'ComponentSharedWorkouts', id: string } | null } | null> | null } | null }> } | null } | { __typename: 'ComponentSharedChecklist', id: string, vertical?: boolean | null, checklistTitle: string, checklistAnchor?: string | null, checklistItems: string } | { __typename: 'ComponentSharedCompanionAppCta', id: string, companionAppCtaAnchor?: string | null, companionAppCtaTitle: string, companionAppCtaDescription?: string | null, companionAppCtaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | { __typename: 'ComponentSharedEvents', id: string, category?: string | null, subcategory?: string | null, featured?: boolean | null, inverted?: boolean | null, expand?: boolean | null, eventsAnchor?: string | null, eventsTitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, eventInfos?: { __typename?: 'EventInfoRelationResponseCollection', data: Array<{ __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null }> } | null, featuredEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null>, filterEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null>, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | { __typename: 'ComponentSharedFaq', id: string, faqAnchor?: string | null, faqTitle?: string | null, question?: Array<{ __typename?: 'ComponentSharedQuestion', questionText?: string | null, answer?: string | null } | null> | null, faqButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedFeaturedLogo', id: string, title: string, featuredLogo: { __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } } | { __typename: 'ComponentSharedHighlights', id: string, Layout?: Enum_Componentsharedhighlights_Layout | null, highlightsAnchor?: string | null, highlightsTitle?: string | null, Highlight?: Array<{ __typename?: 'ComponentSharedCard', contentTitle: string, contentText?: string | null, contentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | null> | null } | { __typename: 'ComponentSharedLinksCarousel', id: string, background?: Enum_Componentsharedlinkscarousel_Background | null, linksCarouselTitle?: string | null, linksCarouselAnchor?: string | null, linksCarouselButtonClickThrough?: boolean | null, items?: Array<{ __typename?: 'ComponentSharedLinksCarouselItem', title: string, description?: string | null, url?: string | null, label?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null } | { __typename: 'ComponentSharedLogoClouds', id: string, logoCloudsTitle: string, logos: Array<{ __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> } | { __typename: 'ComponentSharedNavbar', id: string, navbarAnchor?: string | null, navbarItems?: Array<{ __typename?: 'ComponentSharedNavbarItem', title: string, path: string } | null> | null } | { __typename: 'ComponentSharedNewsletterCta', id: string, description: string, hint: string, campaignId: string, formType?: Enum_Componentsharednewslettercta_Formtype | null, newsletterCtaAnchor?: string | null, ctaTitle: string, newsletterCtaButtonLabel?: string | null, visual?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | { __typename: 'ComponentSharedPageNavigation', id: string, pageNavTitle?: string | null, pageNavDescription?: string | null, pageNavAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | { __typename: 'ComponentSharedPlansSelector', id: string, termsSection?: string | null, plansSelectorTitle: string, plansSelectorSubtitle?: string | null, plansSelectorAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedPricing', id: string, yearlyToMonths?: boolean | null, monthly: boolean, plan: Enum_Componentsharedpricing_Plan, termsSection?: string | null, linkAfterEmailSubmit?: string | null, pricingTitle: string, pricingContent?: string | null, pricingAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedPrizes', id: string, prizesAnchor?: string | null, prizesTitle?: string | null, Prizes?: Array<{ __typename?: 'ComponentWinnablePrize', title?: string | null, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, winner?: { __typename?: 'ComponentWinnableWinner', userName: string, profileImage?: string | null, firstName?: string | null, lastName?: string | null, countryCode: string } | null } | null> | null, Button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedProductsComparison', id: string, productsJson?: {} | null, productsComparisonTitle: string, productsComparisonSubtitle?: string | null, productsComparisonFeaturesTitle?: string | null, productsComparisonAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedRegisterCta', id: string, linkAfterEmailSubmit?: string | null, registerCtaTitle: string, registerCtaDescription?: string | null, registerCtaAnchor?: string | null, registerCtaCampaignId?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | { __typename: 'ComponentSharedRoutesSection', id: string, type?: Enum_Componentsharedroutessection_Type | null, categorySlug?: string | null, offset?: number | null, limit?: number | null, expand?: boolean | null, routesTitle?: string | null, routesAnchor?: string | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null, routeIds?: { __typename?: 'ComponentSharedRoutes', ids?: string | null, list: Array<{ __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> }> } | null, routes?: Array<{ __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> }> | null } | { __typename: 'ComponentSharedSimpleCta', id: string, simpleCtaAnchor?: string | null, simpleCtaTitle: string, simpleCtaDescription?: string | null, simpleCtaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, simpleCtaButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } } | { __typename: 'ComponentSharedSpotlights', id: string, spotlightsAnchorId?: string | null, spotlight?: { __typename?: 'SpotlightEntityResponse', data?: { __typename?: 'SpotlightEntity', attributes?: { __typename?: 'Spotlight', title: string, anchorId?: string | null, subtitle?: string | null, description?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, spotlights?: Array<{ __typename?: 'ComponentSharedSpotlight', id: string, routeId?: number | null, workoutId?: number | null, trainingPlanId?: number | null, route?: { __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> } | null, eventInfo?: { __typename?: 'EventInfoEntityResponse', data?: { __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null } | null } | null, challenge?: { __typename?: 'ChallengeEntityResponse', data?: { __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, logoOriginal?: string | null, startDateTime: string, endDateTime: string, prize?: string | null, state: ChallengeState, branded: boolean, experience: number, registeredCount: number, links: { __typename?: 'Links', detail: string } } | null } | null } | null, workout?: { __typename?: 'WorkoutDetail', id: string, name: string, duration: number, durationType: WorkoutDurationType, description?: string | null, tss: number, coinsForCompletion: number, difficulty?: string | null, trainingEffects: Array<string>, intensityFactor: number, segments: Array<{ __typename?: 'WorkoutSegment', duration: number, intervalType: WorkoutSegmentIntervalType, type: WorkoutSegmentPrimaryType, valueStart: number, valueEnd: number }>, recommendedRoute?: { __typename?: 'RouteOverview', simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', altitude: number, distance: number } | null> | null } | null } | null, trainingPlan?: { __typename?: 'TrainingPlanOverview', id: string, name: string, description: string, backgroundImageUrl: string, totalDurationSeconds: number, expectedDurationDays: number, coinsForCompletion: number, blocksCount: number, trainingUnitsCount: number, trainingPlanTags: Array<{ __typename?: 'TrainingPlanTag', id: string, name: string, color: string }> } | null, card?: { __typename?: 'ComponentSharedSimpleCard', id: string, title: string, description: string, url?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null } | null> | null } | null } | null } | null } | { __typename: 'ComponentSharedSpotlightsList', id: string, spotlightsListTitle?: string | null, spotlightsListAnchor?: string | null, spotlights?: { __typename?: 'SpotlightRelationResponseCollection', data: Array<{ __typename?: 'SpotlightEntity', id?: string | null, attributes?: { __typename?: 'Spotlight', title: string, subtitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null }> } | null } | { __typename: 'ComponentSharedSteps', id: string, alternativeTitle?: string | null, disableNumbering?: boolean | null, stepsAnchor?: string | null, stepsTitle?: string | null, step?: Array<{ __typename?: 'ComponentSharedStepCard', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, alternativeImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | null> | null, stepsButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedStripe', id: string, titleSecondLine?: string | null, textColor?: Enum_Componentsharedstripe_Textcolor | null, backgroundColor?: Enum_Componentsharedstripe_Backgroundcolor | null, upperBackgroundColor?: Enum_Componentsharedstripe_Upperbackgroundcolor | null, lowerBackgroundColor?: Enum_Componentsharedstripe_Lowerbackgroundcolor | null, stripeTitle: string, stripeAnchorId?: string | null } | { __typename: 'ComponentSharedTestimonialsSection', autoscrollInterval: number, testimonialsAnchor?: string | null, testimonials: Array<{ __typename?: 'ComponentSharedTestimonial', testimonial: string, author: string, authorType: string } | null> } | { __typename: 'ComponentSharedTextBlock', id: string, text: string } | { __typename: 'ComponentSharedTwoColumnsContent', twoColumnsContentTitle?: string | null, twoColumnsContentDescription?: string | null, twoColumnsContentText: string, twoColumnsContentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | { __typename: 'ComponentSharedWorkoutsSection', id: string, expand?: boolean | null, workoutsTitle?: string | null, workoutsAnchor?: string | null, workouts?: { __typename?: 'ComponentSharedWorkouts', ids?: string | null, list: Array<{ __typename?: 'WorkoutDetail', id: string, name: string, duration: number, durationType: WorkoutDurationType, description?: string | null, tss: number, coinsForCompletion: number, difficulty?: string | null, trainingEffects: Array<string>, intensityFactor: number, segments: Array<{ __typename?: 'WorkoutSegment', duration: number, intervalType: WorkoutSegmentIntervalType, type: WorkoutSegmentPrimaryType, valueStart: number, valueEnd: number }>, recommendedRoute?: { __typename?: 'RouteOverview', simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', altitude: number, distance: number } | null> | null } | null }> } | null } | { __typename: 'ComponentSharedYouTubeVideo', id: string, embedCode?: string | null, videoUrl?: string | null, caption: string, youTubeTitle: string, youTubeAnchor?: string | null, cover?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | { __typename: 'Error' } | null> | null, contentLayers?: { __typename?: 'ComponentSharedContentLayers', aim: Enum_Componentsharedcontentlayers_Aim, perspective: Enum_Componentsharedcontentlayers_Perspective, segment: {}, contentType: Enum_Componentsharedcontentlayers_Contenttype } | null, localizations?: { __typename?: 'BlogPostRelationResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', locale?: string | null } | null }> } | null } | null };

export type BlogTagBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type BlogTagBySlugQuery = { __typename?: 'Query', blogTagBySlug?: { __typename?: 'BlogTag', id: string, title: string, slug: string, locale?: string | null, SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, localizations?: { __typename?: 'BlogTagRelationResponseCollection', data: Array<{ __typename?: 'BlogTagEntity', attributes?: { __typename?: 'BlogTag', locale?: string | null } | null }> } | null } | null };

export type BlogTagsQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type BlogTagsQuery = { __typename?: 'Query', blogTags: Array<{ __typename?: 'BlogTag', id: string, title: string, slug: string, SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } }> };

export type BlogTagsSitemapQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type BlogTagsSitemapQuery = { __typename?: 'Query', blogTags: Array<{ __typename?: 'BlogTag', slug: string, updatedAt?: string | null, SEO: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null }, localizations?: { __typename?: 'BlogTagRelationResponseCollection', data: Array<{ __typename?: 'BlogTagEntity', attributes?: { __typename?: 'BlogTag', locale?: string | null, updatedAt?: string | null, SEO: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null } } | null }> } | null }> };

export type DynamicPageQueryVariables = Exact<{
  path: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type DynamicPageQuery = { __typename?: 'Query', dynamicPageByPath?: { __typename?: 'DynamicPage', title: string, structuredDataHeadline?: string | null, publishedAt?: string | null, SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, navbarSettings?: { __typename?: 'ComponentSharedNavbarSettings', transparent?: boolean | null, fixed?: boolean | null, secondaryLogoLink?: string | null, logoLink?: { __typename?: 'ComponentSharedLink', url: string, title: string } | null, navLinks?: Array<{ __typename?: 'ComponentSharedLink', url: string, title: string } | null> | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null, secondaryLogo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, body?: Array<{ __typename: 'ComponentSharedBlogPosts', id: string, expand?: boolean | null, blogPostsTitle?: string | null, blogPostsAnchor?: string | null, blogPosts?: { __typename?: 'BlogPostRelationResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', title: string, perex: string, slug: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null }> } | null } | { __typename: 'ComponentSharedChallenges', id: string, expand?: boolean | null, challengesAnchor?: string | null, challengesTitle?: string | null, challenges?: { __typename?: 'ChallengeRelationResponseCollection', data: Array<{ __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', challengeId: string, experience: number, startDateTime: string, endDateTime: string, title: string, expandTitle?: string | null, registeredCount: number, description?: string | null, logoOriginal?: string | null, coins: number, tasksAndRules?: Array<{ __typename?: 'ComponentSharedTasksRulesWidget', title: string, subtitle?: string | null, routes?: { __typename?: 'ComponentSharedRoutes', id: string } | null, workouts?: { __typename?: 'ComponentSharedWorkouts', id: string } | null } | null> | null } | null }> } | null } | { __typename: 'ComponentSharedChecklist', id: string, vertical?: boolean | null, checklistTitle: string, checklistAnchor?: string | null, checklistItems: string } | { __typename: 'ComponentSharedCompanionAppCta', id: string, companionAppCtaAnchor?: string | null, companionAppCtaTitle: string, companionAppCtaDescription?: string | null, companionAppCtaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | { __typename: 'ComponentSharedContentTeaser', id: string, size: Enum_Componentsharedcontentteaser_Size, teaserTitle: string, teaserDescription?: string | null, teaserAnchor?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logoResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImageResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, cards?: Array<{ __typename?: 'ComponentSharedSimpleCard', title: string, description: string, url?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null } | { __typename: 'ComponentSharedEvents', id: string, category?: string | null, subcategory?: string | null, featured?: boolean | null, inverted?: boolean | null, expand?: boolean | null, eventsAnchor?: string | null, eventsTitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, eventInfos?: { __typename?: 'EventInfoRelationResponseCollection', data: Array<{ __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null }> } | null, featuredEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null>, filterEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null>, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | { __typename: 'ComponentSharedFaq', id: string, faqAnchor?: string | null, faqTitle?: string | null, question?: Array<{ __typename?: 'ComponentSharedQuestion', questionText?: string | null, answer?: string | null } | null> | null, faqButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedFeaturedLogo', id: string, title: string, featuredLogo: { __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } } | { __typename: 'ComponentSharedHeader', id: string, textLogo?: string | null, headline: string, subheading?: string | null, cdnVideoUrl?: string | null, cdnBackgroundImageUrl?: string | null, linkAfterEmailSubmit?: string | null, headerAnchor?: string | null, headerDescription?: string | null, headerCampaignId?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, responsiveImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | { __typename: 'ComponentSharedHeaderAcceptInvite', id: string, acceptInviteHeading: string, acceptInviteHeadingFallback?: string | null, acceptInviteSubheading: string, acceptInviteSubheadingFallback?: string | null, acceptInviteButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null }, acceptInviteButtonFallback?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, acceptInviteBackgroundImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | { __typename: 'ComponentSharedHeaderVideo', headline: string, subheading?: string | null, campaingId?: string | null, headerVideoDescription?: string | null, headerVideoAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null, headerVideo: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, headerVideoResponsive?: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null } | { __typename: 'ComponentSharedHighlights', id: string, Layout?: Enum_Componentsharedhighlights_Layout | null, highlightsAnchor?: string | null, highlightsTitle?: string | null, Highlight?: Array<{ __typename?: 'ComponentSharedCard', contentTitle: string, contentText?: string | null, contentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | null> | null } | { __typename: 'ComponentSharedLinksCarousel', id: string, background?: Enum_Componentsharedlinkscarousel_Background | null, linksCarouselTitle?: string | null, linksCarouselAnchor?: string | null, linksCarouselButtonClickThrough?: boolean | null, items?: Array<{ __typename?: 'ComponentSharedLinksCarouselItem', title: string, description?: string | null, url?: string | null, label?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null } | { __typename: 'ComponentSharedLogoClouds', id: string, logoCloudsTitle: string, logos: Array<{ __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> } | { __typename: 'ComponentSharedNavbar', id: string, navbarAnchor?: string | null, navbarItems?: Array<{ __typename?: 'ComponentSharedNavbarItem', title: string, path: string } | null> | null } | { __typename: 'ComponentSharedNewsletterCta', id: string, description: string, hint: string, campaignId: string, formType?: Enum_Componentsharednewslettercta_Formtype | null, newsletterCtaAnchor?: string | null, ctaTitle: string, newsletterCtaButtonLabel?: string | null, visual?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | { __typename: 'ComponentSharedPageNavigation', id: string, pageNavTitle?: string | null, pageNavDescription?: string | null, pageNavAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | { __typename: 'ComponentSharedPlansSelector', id: string, termsSection?: string | null, plansSelectorTitle: string, plansSelectorSubtitle?: string | null, plansSelectorAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedPricing', id: string, yearlyToMonths?: boolean | null, monthly: boolean, plan: Enum_Componentsharedpricing_Plan, termsSection?: string | null, linkAfterEmailSubmit?: string | null, pricingTitle: string, pricingContent?: string | null, pricingAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedPrizes', id: string, prizesAnchor?: string | null, prizesTitle?: string | null, Prizes?: Array<{ __typename?: 'ComponentWinnablePrize', title?: string | null, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, winner?: { __typename?: 'ComponentWinnableWinner', userName: string, profileImage?: string | null, firstName?: string | null, lastName?: string | null, countryCode: string } | null } | null> | null, Button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedProductsComparison', id: string, productsJson?: {} | null, productsComparisonTitle: string, productsComparisonSubtitle?: string | null, productsComparisonFeaturesTitle?: string | null, productsComparisonAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedRegisterCta', id: string, linkAfterEmailSubmit?: string | null, registerCtaTitle: string, registerCtaDescription?: string | null, registerCtaAnchor?: string | null, registerCtaCampaignId?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | { __typename: 'ComponentSharedRoutesSection', id: string, type?: Enum_Componentsharedroutessection_Type | null, categorySlug?: string | null, offset?: number | null, limit?: number | null, expand?: boolean | null, routesTitle?: string | null, routesAnchor?: string | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null, routeIds?: { __typename?: 'ComponentSharedRoutes', ids?: string | null, list: Array<{ __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> }> } | null, routes?: Array<{ __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> }> | null } | { __typename: 'ComponentSharedSimpleCta', id: string, simpleCtaAnchor?: string | null, simpleCtaTitle: string, simpleCtaDescription?: string | null, simpleCtaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, simpleCtaButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } } | { __typename: 'ComponentSharedSpotlights', id: string, spotlightsAnchorId?: string | null, spotlight?: { __typename?: 'SpotlightEntityResponse', data?: { __typename?: 'SpotlightEntity', attributes?: { __typename?: 'Spotlight', title: string, anchorId?: string | null, subtitle?: string | null, description?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, spotlights?: Array<{ __typename?: 'ComponentSharedSpotlight', id: string, routeId?: number | null, workoutId?: number | null, trainingPlanId?: number | null, route?: { __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> } | null, eventInfo?: { __typename?: 'EventInfoEntityResponse', data?: { __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null } | null } | null, challenge?: { __typename?: 'ChallengeEntityResponse', data?: { __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, logoOriginal?: string | null, startDateTime: string, endDateTime: string, prize?: string | null, state: ChallengeState, branded: boolean, experience: number, registeredCount: number, links: { __typename?: 'Links', detail: string } } | null } | null } | null, workout?: { __typename?: 'WorkoutDetail', id: string, name: string, duration: number, durationType: WorkoutDurationType, description?: string | null, tss: number, coinsForCompletion: number, difficulty?: string | null, trainingEffects: Array<string>, intensityFactor: number, segments: Array<{ __typename?: 'WorkoutSegment', duration: number, intervalType: WorkoutSegmentIntervalType, type: WorkoutSegmentPrimaryType, valueStart: number, valueEnd: number }>, recommendedRoute?: { __typename?: 'RouteOverview', simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', altitude: number, distance: number } | null> | null } | null } | null, trainingPlan?: { __typename?: 'TrainingPlanOverview', id: string, name: string, description: string, backgroundImageUrl: string, totalDurationSeconds: number, expectedDurationDays: number, coinsForCompletion: number, blocksCount: number, trainingUnitsCount: number, trainingPlanTags: Array<{ __typename?: 'TrainingPlanTag', id: string, name: string, color: string }> } | null, card?: { __typename?: 'ComponentSharedSimpleCard', id: string, title: string, description: string, url?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null } | null> | null } | null } | null } | null } | { __typename: 'ComponentSharedSpotlightsList', id: string, spotlightsListTitle?: string | null, spotlightsListAnchor?: string | null, spotlights?: { __typename?: 'SpotlightRelationResponseCollection', data: Array<{ __typename?: 'SpotlightEntity', id?: string | null, attributes?: { __typename?: 'Spotlight', title: string, subtitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null }> } | null } | { __typename: 'ComponentSharedSteps', id: string, alternativeTitle?: string | null, disableNumbering?: boolean | null, stepsAnchor?: string | null, stepsTitle?: string | null, step?: Array<{ __typename?: 'ComponentSharedStepCard', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, alternativeImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | null> | null, stepsButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedStripe', id: string, titleSecondLine?: string | null, textColor?: Enum_Componentsharedstripe_Textcolor | null, backgroundColor?: Enum_Componentsharedstripe_Backgroundcolor | null, upperBackgroundColor?: Enum_Componentsharedstripe_Upperbackgroundcolor | null, lowerBackgroundColor?: Enum_Componentsharedstripe_Lowerbackgroundcolor | null, stripeTitle: string, stripeAnchorId?: string | null } | { __typename: 'ComponentSharedTestimonialsSection', autoscrollInterval: number, testimonialsAnchor?: string | null, testimonials: Array<{ __typename?: 'ComponentSharedTestimonial', testimonial: string, author: string, authorType: string } | null> } | { __typename: 'ComponentSharedTextBlock', id: string, text: string } | { __typename: 'ComponentSharedTwoColumnsContent', twoColumnsContentTitle?: string | null, twoColumnsContentDescription?: string | null, twoColumnsContentText: string, twoColumnsContentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | { __typename: 'ComponentSharedWorkoutsSection', id: string, expand?: boolean | null, workoutsTitle?: string | null, workoutsAnchor?: string | null, workouts?: { __typename?: 'ComponentSharedWorkouts', ids?: string | null, list: Array<{ __typename?: 'WorkoutDetail', id: string, name: string, duration: number, durationType: WorkoutDurationType, description?: string | null, tss: number, coinsForCompletion: number, difficulty?: string | null, trainingEffects: Array<string>, intensityFactor: number, segments: Array<{ __typename?: 'WorkoutSegment', duration: number, intervalType: WorkoutSegmentIntervalType, type: WorkoutSegmentPrimaryType, valueStart: number, valueEnd: number }>, recommendedRoute?: { __typename?: 'RouteOverview', simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', altitude: number, distance: number } | null> | null } | null }> } | null } | { __typename: 'ComponentSharedYouTubeVideo', id: string, embedCode?: string | null, videoUrl?: string | null, caption: string, youTubeTitle: string, youTubeAnchor?: string | null, cover?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | { __typename: 'Error' } | null> | null, contentLayers?: { __typename?: 'ComponentSharedContentLayers', aim: Enum_Componentsharedcontentlayers_Aim, perspective: Enum_Componentsharedcontentlayers_Perspective, segment: {}, contentType: Enum_Componentsharedcontentlayers_Contenttype } | null, localizations?: { __typename?: 'DynamicPageRelationResponseCollection', data: Array<{ __typename?: 'DynamicPageEntity', attributes?: { __typename?: 'DynamicPage', locale?: string | null } | null }> } | null } | null };

export type DynamicPagesSitemapQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type DynamicPagesSitemapQuery = { __typename?: 'Query', dynamicPage: Array<{ __typename?: 'DynamicPage', path: string, locale?: string | null, updatedAt?: string | null, SEO: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null }, localizations?: { __typename?: 'DynamicPageRelationResponseCollection', data: Array<{ __typename?: 'DynamicPageEntity', attributes?: { __typename?: 'DynamicPage', locale?: string | null, updatedAt?: string | null, SEO: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null } } | null }> } | null }> };

export type FooterLinkGroupsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type FooterLinkGroupsQuery = { __typename?: 'Query', footer?: { __typename?: 'Footer', groups: Array<{ __typename?: 'ComponentSharedLinksGroup', title: string, links: Array<{ __typename?: 'ComponentSharedLink', title: string, url: string } | null> } | null>, bottomLinks: Array<{ __typename?: 'ComponentSharedLink', title: string, url: string } | null> } | null };

export type HomepageQueryVariables = Exact<{
  variant: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type HomepageQuery = { __typename?: 'Query', homepage?: { __typename?: 'Homepage', SEO: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, navbarSettings?: { __typename?: 'ComponentSharedNavbarSettings', transparent?: boolean | null, fixed?: boolean | null, secondaryLogoLink?: string | null, logoLink?: { __typename?: 'ComponentSharedLink', url: string, title: string } | null, navLinks?: Array<{ __typename?: 'ComponentSharedLink', url: string, title: string } | null> | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null, secondaryLogo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, body?: Array<{ __typename: 'ComponentSharedBlogPosts', id: string, expand?: boolean | null, blogPostsTitle?: string | null, blogPostsAnchor?: string | null, blogPosts?: { __typename?: 'BlogPostRelationResponseCollection', data: Array<{ __typename?: 'BlogPostEntity', attributes?: { __typename?: 'BlogPost', title: string, perex: string, slug: string, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null }> } | null } | { __typename: 'ComponentSharedChallenges', id: string, expand?: boolean | null, challengesAnchor?: string | null, challengesTitle?: string | null, challenges?: { __typename?: 'ChallengeRelationResponseCollection', data: Array<{ __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', challengeId: string, experience: number, startDateTime: string, endDateTime: string, title: string, expandTitle?: string | null, registeredCount: number, description?: string | null, logoOriginal?: string | null, coins: number, tasksAndRules?: Array<{ __typename?: 'ComponentSharedTasksRulesWidget', title: string, subtitle?: string | null, routes?: { __typename?: 'ComponentSharedRoutes', id: string } | null, workouts?: { __typename?: 'ComponentSharedWorkouts', id: string } | null } | null> | null } | null }> } | null } | { __typename: 'ComponentSharedChecklist', id: string, vertical?: boolean | null, checklistTitle: string, checklistAnchor?: string | null, checklistItems: string } | { __typename: 'ComponentSharedCompanionAppCta', id: string, companionAppCtaAnchor?: string | null, companionAppCtaTitle: string, companionAppCtaDescription?: string | null, companionAppCtaImage: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | { __typename: 'ComponentSharedContentTeaser', id: string, size: Enum_Componentsharedcontentteaser_Size, teaserTitle: string, teaserDescription?: string | null, teaserAnchor?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logoResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImageResponsive?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, cards?: Array<{ __typename?: 'ComponentSharedSimpleCard', title: string, description: string, url?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null } | { __typename: 'ComponentSharedEvents', id: string, category?: string | null, subcategory?: string | null, featured?: boolean | null, inverted?: boolean | null, expand?: boolean | null, eventsAnchor?: string | null, eventsTitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, eventInfos?: { __typename?: 'EventInfoRelationResponseCollection', data: Array<{ __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null }> } | null, featuredEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null>, filterEventInfos: Array<{ __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null>, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | { __typename: 'ComponentSharedFaq', id: string, faqAnchor?: string | null, faqTitle?: string | null, question?: Array<{ __typename?: 'ComponentSharedQuestion', questionText?: string | null, answer?: string | null } | null> | null, faqButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedFeaturedLogo', id: string, title: string, featuredLogo: { __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } } | { __typename: 'ComponentSharedHeader', id: string, textLogo?: string | null, headline: string, subheading?: string | null, cdnVideoUrl?: string | null, cdnBackgroundImageUrl?: string | null, linkAfterEmailSubmit?: string | null, headerAnchor?: string | null, headerDescription?: string | null, headerCampaignId?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, headerImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, responsiveImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null } | { __typename: 'ComponentSharedHeaderVideo', headline: string, subheading?: string | null, campaingId?: string | null, headerVideoDescription?: string | null, headerVideoAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null, headerVideo: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null }, headerVideoResponsive?: { __typename?: 'ComponentSharedVideo', videoUrl?: string | null, autoPlay: boolean, muted: boolean, loop: boolean, showControls: boolean, showVideo: Enum_Componentsharedvideo_Showvideo, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null } | { __typename: 'ComponentSharedHighlights', id: string, Layout?: Enum_Componentsharedhighlights_Layout | null, highlightsAnchor?: string | null, highlightsTitle?: string | null, Highlight?: Array<{ __typename?: 'ComponentSharedCard', contentTitle: string, contentText?: string | null, contentImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, buttonAlt?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | null> | null } | { __typename: 'ComponentSharedLinksCarousel', id: string, background?: Enum_Componentsharedlinkscarousel_Background | null, linksCarouselTitle?: string | null, linksCarouselAnchor?: string | null, linksCarouselButtonClickThrough?: boolean | null, items?: Array<{ __typename?: 'ComponentSharedLinksCarouselItem', title: string, description?: string | null, url?: string | null, label?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> | null } | { __typename: 'ComponentSharedLogoClouds', id: string, logoCloudsTitle: string, logos: Array<{ __typename?: 'ComponentSharedLogo', id: string, title: string, link?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null> } | { __typename: 'ComponentSharedNavbar', id: string, navbarAnchor?: string | null, navbarItems?: Array<{ __typename?: 'ComponentSharedNavbarItem', title: string, path: string } | null> | null } | { __typename: 'ComponentSharedNewsletterCta', id: string, description: string, hint: string, campaignId: string, formType?: Enum_Componentsharednewslettercta_Formtype | null, newsletterCtaAnchor?: string | null, ctaTitle: string, newsletterCtaButtonLabel?: string | null, visual?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | { __typename: 'ComponentSharedPageNavigation', id: string, pageNavTitle?: string | null, pageNavDescription?: string | null, pageNavAnchor?: string | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | { __typename: 'ComponentSharedPlansSelector', id: string, termsSection?: string | null, plansSelectorTitle: string, plansSelectorSubtitle?: string | null, plansSelectorAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedPricing', id: string, yearlyToMonths?: boolean | null, monthly: boolean, plan: Enum_Componentsharedpricing_Plan, termsSection?: string | null, linkAfterEmailSubmit?: string | null, pricingTitle: string, pricingContent?: string | null, pricingAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedPrizes', id: string, prizesAnchor?: string | null, prizesTitle?: string | null, Prizes?: Array<{ __typename?: 'ComponentWinnablePrize', title?: string | null, description: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, winner?: { __typename?: 'ComponentWinnableWinner', userName: string, profileImage?: string | null, firstName?: string | null, lastName?: string | null, countryCode: string } | null } | null> | null, Button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedProductsComparison', id: string, productsJson?: {} | null, productsComparisonTitle: string, productsComparisonSubtitle?: string | null, productsComparisonFeaturesTitle?: string | null, productsComparisonAnchor?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedRegisterCta', id: string, linkAfterEmailSubmit?: string | null, registerCtaTitle: string, registerCtaDescription?: string | null, registerCtaAnchor?: string | null, registerCtaCampaignId?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | { __typename: 'ComponentSharedRoutesSection', id: string, type?: Enum_Componentsharedroutessection_Type | null, categorySlug?: string | null, offset?: number | null, limit?: number | null, expand?: boolean | null, routesTitle?: string | null, routesAnchor?: string | null, logosStrip?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null }> } | null, routeIds?: { __typename?: 'ComponentSharedRoutes', ids?: string | null, list: Array<{ __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> }> } | null, routes?: Array<{ __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> }> | null } | { __typename: 'ComponentSharedSimpleCta', id: string, simpleCtaAnchor?: string | null, simpleCtaTitle: string, simpleCtaDescription?: string | null, simpleCtaImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, simpleCtaButton: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } } | { __typename: 'ComponentSharedSpotlights', id: string, spotlightsAnchorId?: string | null, spotlight?: { __typename?: 'SpotlightEntityResponse', data?: { __typename?: 'SpotlightEntity', attributes?: { __typename?: 'Spotlight', title: string, anchorId?: string | null, subtitle?: string | null, description?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, spotlights?: Array<{ __typename?: 'ComponentSharedSpotlight', id: string, routeId?: number | null, workoutId?: number | null, trainingPlanId?: number | null, route?: { __typename?: 'Route', id: string, name: string, distanceInMeters: number, elevationInMeters: number, stravaLiveSegmentsCount: number, estimatedTime: number, onlineCount?: number | null, countryCode: string, supportsAugmentedReality: boolean, maxVideoQuality: number, rating: number, description?: string | null, coinsForCompletion: number, links: { __typename?: 'Links', detail: string }, videoPreview: { __typename?: 'VideoPreview', url?: string | null, thumbnail?: string | null, thumbnailClear?: string | null, thumbnailHiRes?: string | null }, promoPreview: Array<{ __typename?: 'PromoPreview', type: string, url: string }>, partner?: { __typename?: 'Partner', id: string, title: string, slug?: string | null, web?: string | null, lead?: string | null, logo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, thumbnailImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, geometry: Array<{ __typename?: 'RoutePointGeo', distance: number, altitude: number }> } | null, eventInfo?: { __typename?: 'EventInfoEntityResponse', data?: { __typename?: 'EventInfoEntity', id?: string | null, attributes?: { __typename?: 'EventInfo', eventId: string, id: string, capacity: number, category?: string | null, enteringOffsetSeconds: number, lateStartOffsetSeconds: number, locale?: string | null, longDescription?: string | null, official: boolean, registrationsCount: number, subcategory?: string | null, title: string, expandTitle?: string | null, type: EventInfoType, description?: string | null, isDrafting: boolean, smartTrainersOnly: boolean, laps: number, mainPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, coverPhoto?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, route: { __typename?: 'RouteOverview', id: string, distanceMeters: number, stravaSegmentsCount: number, estimatedTimeSeconds: number, coinsForCompletion: number, ascendedMeters: number, countryCodeISO?: string | null, thumbnails: { __typename?: 'RouteThumbnails', large: string, medium: string, small: string }, simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', latitude: number, longitude: number, distance: number, altitude: number } | null> | null }, sessions: Array<{ __typename?: 'EventSession', id: string, startDateTime: string, status: EventSessionStatus, coinsForCompletion: number }> } | null } | null } | null, challenge?: { __typename?: 'ChallengeEntityResponse', data?: { __typename?: 'ChallengeEntity', id?: string | null, attributes?: { __typename?: 'Challenge', id: string, challengeId: string, title: string, description?: string | null, slug?: string | null, logoOriginal?: string | null, startDateTime: string, endDateTime: string, prize?: string | null, state: ChallengeState, branded: boolean, experience: number, registeredCount: number, links: { __typename?: 'Links', detail: string } } | null } | null } | null, workout?: { __typename?: 'WorkoutDetail', id: string, name: string, duration: number, durationType: WorkoutDurationType, description?: string | null, tss: number, coinsForCompletion: number, difficulty?: string | null, trainingEffects: Array<string>, intensityFactor: number, segments: Array<{ __typename?: 'WorkoutSegment', duration: number, intervalType: WorkoutSegmentIntervalType, type: WorkoutSegmentPrimaryType, valueStart: number, valueEnd: number }>, recommendedRoute?: { __typename?: 'RouteOverview', simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', altitude: number, distance: number } | null> | null } | null } | null, trainingPlan?: { __typename?: 'TrainingPlanOverview', id: string, name: string, description: string, backgroundImageUrl: string, totalDurationSeconds: number, expectedDurationDays: number, coinsForCompletion: number, blocksCount: number, trainingUnitsCount: number, trainingPlanTags: Array<{ __typename?: 'TrainingPlanTag', id: string, name: string, color: string }> } | null, card?: { __typename?: 'ComponentSharedSimpleCard', id: string, title: string, description: string, url?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } } | null } | null> | null } | null } | null } | null } | { __typename: 'ComponentSharedSpotlightsList', id: string, spotlightsListTitle?: string | null, spotlightsListAnchor?: string | null, spotlights?: { __typename?: 'SpotlightRelationResponseCollection', data: Array<{ __typename?: 'SpotlightEntity', id?: string | null, attributes?: { __typename?: 'Spotlight', title: string, subtitle?: string | null, button?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null, backgroundImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null }> } | null } | { __typename: 'ComponentSharedSteps', id: string, alternativeTitle?: string | null, disableNumbering?: boolean | null, stepsAnchor?: string | null, stepsTitle?: string | null, step?: Array<{ __typename?: 'ComponentSharedStepCard', title?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, alternativeImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null } | null> | null, stepsButton?: { __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null } | { __typename: 'ComponentSharedStripe', id: string, titleSecondLine?: string | null, textColor?: Enum_Componentsharedstripe_Textcolor | null, backgroundColor?: Enum_Componentsharedstripe_Backgroundcolor | null, upperBackgroundColor?: Enum_Componentsharedstripe_Upperbackgroundcolor | null, lowerBackgroundColor?: Enum_Componentsharedstripe_Lowerbackgroundcolor | null, stripeTitle: string, stripeAnchorId?: string | null } | { __typename: 'ComponentSharedTestimonialsSection', autoscrollInterval: number, testimonialsAnchor?: string | null, testimonials: Array<{ __typename?: 'ComponentSharedTestimonial', testimonial: string, author: string, authorType: string } | null> } | { __typename: 'ComponentSharedTextBlock', id: string, text: string } | { __typename: 'ComponentSharedWorkoutsSection', id: string, expand?: boolean | null, workoutsTitle?: string | null, workoutsAnchor?: string | null, workouts?: { __typename?: 'ComponentSharedWorkouts', ids?: string | null, list: Array<{ __typename?: 'WorkoutDetail', id: string, name: string, duration: number, durationType: WorkoutDurationType, description?: string | null, tss: number, coinsForCompletion: number, difficulty?: string | null, trainingEffects: Array<string>, intensityFactor: number, segments: Array<{ __typename?: 'WorkoutSegment', duration: number, intervalType: WorkoutSegmentIntervalType, type: WorkoutSegmentPrimaryType, valueStart: number, valueEnd: number }>, recommendedRoute?: { __typename?: 'RouteOverview', simplifiedGeometryPoints?: Array<{ __typename?: 'RouteGeometryPoint', altitude: number, distance: number } | null> | null } | null }> } | null } | { __typename: 'ComponentSharedYouTubeVideo', id: string, embedCode?: string | null, videoUrl?: string | null, caption: string, youTubeTitle: string, youTubeAnchor?: string | null, cover?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | { __typename: 'Error' } | null> | null, localizations?: { __typename?: 'HomepageRelationResponseCollection', data: Array<{ __typename?: 'HomepageEntity', attributes?: { __typename?: 'Homepage', locale?: string | null } | null }> } | null } | null };

export type DefaultNavbarQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type DefaultNavbarQuery = { __typename?: 'Query', navbar?: { __typename?: 'Navbar', navbarSettings: { __typename?: 'ComponentSharedNavbarSettings', transparent?: boolean | null, fixed?: boolean | null, secondaryLogoLink?: string | null, logoLink?: { __typename?: 'ComponentSharedLink', url: string, title: string } | null, navLinks?: Array<{ __typename?: 'ComponentSharedLink', url: string, title: string } | null> | null, buttons?: Array<{ __typename?: 'ComponentSharedButton', text: string, link: string, ctaEvent?: string | null, buttonStyle?: Enum_Componentsharedbutton_Buttonstyle | null, buttonType?: Enum_Componentsharedbutton_Buttontype | null } | null> | null, secondaryLogo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } } | null };

export type PostsQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsQuery = { __typename?: 'Query', posts: Array<{ __typename?: 'Post', id: string, title: string, slug: string, perex: string, publishedAt?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, SEO?: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null }> };

export type PostQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  category: Enum_Post_Category;
  publicationState?: InputMaybe<PublicationState>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type PostQuery = { __typename?: 'Query', postBySlug?: { __typename?: 'Post', title: string, slug: string, perex: string, text: string, publishedAt?: string | null, SEO?: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, paragraphs?: Array<{ __typename?: 'ComponentSharedParagraph', text?: string | null, youtubeLink?: string | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null> | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null }, localizations?: { __typename?: 'PostRelationResponseCollection', data: Array<{ __typename?: 'PostEntity', attributes?: { __typename?: 'Post', locale?: string | null } | null }> } | null } | null };

export type PostsSitemapQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
  publicationState?: InputMaybe<PublicationState>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsSitemapQuery = { __typename?: 'Query', posts: Array<{ __typename?: 'Post', slug: string, updatedAt?: string | null, SEO?: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null } | null, localizations?: { __typename?: 'PostRelationResponseCollection', data: Array<{ __typename?: 'PostEntity', attributes?: { __typename?: 'Post', locale?: string | null, updatedAt?: string | null, SEO?: { __typename?: 'ComponentSharedSeo', noIndex?: boolean | null } | null } | null }> } | null }> };

export type RedirectQueryVariables = Exact<{
  source?: InputMaybe<Scalars['String']['input']>;
  publicationState: PublicationState;
}>;


export type RedirectQuery = { __typename?: 'Query', redirect?: { __typename?: 'Redirect', destination: string, permanent: boolean } | null };

export type StaticPageFragment = { __typename: 'StaticPage', title: string, text?: string | null, SEO?: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, localizations?: { __typename?: 'StaticPageRelationResponseCollection', data: Array<{ __typename?: 'StaticPageEntity', attributes?: { __typename?: 'StaticPage', locale?: string | null } | null }> } | null };

export type StaticPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  publicationState?: InputMaybe<PublicationState>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type StaticPageQuery = { __typename?: 'Query', staticPage?: { __typename: 'StaticPage', title: string, text?: string | null, SEO?: { __typename?: 'ComponentSharedSeo', metaDescription: string, metaTitle: string, ogTitle?: string | null, noFollow?: boolean | null, noIndex?: boolean | null, shareImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, url: string, width?: number | null, height?: number | null, alternativeText?: string | null, mime: string, formats?: {} | null } | null } | null } | null } | null, localizations?: { __typename?: 'StaticPageRelationResponseCollection', data: Array<{ __typename?: 'StaticPageEntity', attributes?: { __typename?: 'StaticPage', locale?: string | null } | null }> } | null } | null };

export type TermsFragment = { __typename?: 'Terms', id?: number | null, majorVersion?: number | null, minorVersion?: number | null, effectiveAt?: string | null, text?: string | null };

export type TermsQueryVariables = Exact<{
  language: Scalars['String']['input'];
}>;


export type TermsQuery = { __typename?: 'Query', terms?: { __typename?: 'Terms', id?: number | null, majorVersion?: number | null, minorVersion?: number | null, effectiveAt?: string | null, text?: string | null } | null };

export const ChallengesListItemFragmentDoc = gql`
    fragment ChallengesListItem on Challenge {
  id
  challengeId
  title
  description
  slug
  logoOriginal
  startDateTime
  endDateTime
  prize
  state
  branded
  experience
  registeredCount
  links {
    detail
  }
}
    `;
export const ChallengeEntityFragmentDoc = gql`
    fragment ChallengeEntity on ChallengeEntity {
  id
  attributes {
    ...ChallengesListItem
  }
}
    ${ChallengesListItemFragmentDoc}`;
export const ChallengeEntityResponseCollectionFragmentDoc = gql`
    fragment ChallengeEntityResponseCollection on ChallengeRelationResponseCollection {
  data {
    ...ChallengeEntity
  }
}
    ${ChallengeEntityFragmentDoc}`;
export const ContentLayersFragmentDoc = gql`
    fragment ContentLayers on ComponentSharedContentLayers {
  aim
  perspective
  segment
  contentType
}
    `;
export const UploadFileFragmentDoc = gql`
    fragment UploadFile on UploadFile {
  name
  url
  width
  height
  alternativeText
  mime
  formats
}
    `;
export const UploadFileEntityFragmentDoc = gql`
    fragment UploadFileEntity on UploadFileEntity {
  id
  attributes {
    ...UploadFile
  }
}
    ${UploadFileFragmentDoc}`;
export const UploadFileEntityResponseFragmentDoc = gql`
    fragment UploadFileEntityResponse on UploadFileEntityResponse {
  data {
    ...UploadFileEntity
  }
}
    ${UploadFileEntityFragmentDoc}`;
export const ButtonFragmentDoc = gql`
    fragment Button on ComponentSharedButton {
  text
  link
  ctaEvent
  buttonStyle
  buttonType
}
    `;
export const UploadFileRelationResponseCollectionFragmentDoc = gql`
    fragment UploadFileRelationResponseCollection on UploadFileRelationResponseCollection {
  data {
    ...UploadFileEntity
  }
}
    ${UploadFileEntityFragmentDoc}`;
export const HeaderFragmentDoc = gql`
    fragment Header on ComponentSharedHeader {
  id
  headerAnchor: anchorId
  logo {
    ...UploadFileEntityResponse
  }
  textLogo
  headline
  subheading
  headerDescription: description
  headerButton: button {
    ...Button
  }
  buttonAlt {
    ...Button
  }
  video {
    ...UploadFileEntityResponse
  }
  cdnVideoUrl
  headerImage: image {
    ...UploadFileEntityResponse
  }
  responsiveImage {
    ...UploadFileEntityResponse
  }
  backgroundImage {
    ...UploadFileEntityResponse
  }
  logosStrip {
    ...UploadFileRelationResponseCollection
  }
  cdnBackgroundImageUrl
  headerCampaignId: campaignId
  linkAfterEmailSubmit
}
    ${UploadFileEntityResponseFragmentDoc}
${ButtonFragmentDoc}
${UploadFileRelationResponseCollectionFragmentDoc}`;
export const QuestionFragmentDoc = gql`
    fragment Question on ComponentSharedQuestion {
  questionText
  answer
}
    `;
export const FaqFragmentDoc = gql`
    fragment Faq on ComponentSharedFaq {
  id
  faqAnchor: anchorId
  faqTitle: title
  question {
    ...Question
  }
  faqButton: button {
    ...Button
  }
}
    ${QuestionFragmentDoc}
${ButtonFragmentDoc}`;
export const EventsWinnerFragmentDoc = gql`
    fragment EventsWinner on ComponentWinnableWinner {
  userName
  profileImage
  firstName
  lastName
  countryCode
}
    `;
export const ChallengePrizeFragmentDoc = gql`
    fragment ChallengePrize on ComponentWinnablePrize {
  title
  description
  image {
    ...UploadFileEntityResponse
  }
  winner {
    ...EventsWinner
  }
}
    ${UploadFileEntityResponseFragmentDoc}
${EventsWinnerFragmentDoc}`;
export const PrizesFragmentDoc = gql`
    fragment Prizes on ComponentSharedPrizes {
  id
  prizesAnchor: anchorId
  prizesTitle: Title
  Prizes {
    ...ChallengePrize
  }
  Button {
    ...Button
  }
}
    ${ChallengePrizeFragmentDoc}
${ButtonFragmentDoc}`;
export const StepFragmentDoc = gql`
    fragment Step on ComponentSharedStepCard {
  image {
    ...UploadFileEntityResponse
  }
  alternativeImage {
    ...UploadFileEntityResponse
  }
  title
  description
  buttons {
    ...Button
  }
}
    ${UploadFileEntityResponseFragmentDoc}
${ButtonFragmentDoc}`;
export const StepsFragmentDoc = gql`
    fragment Steps on ComponentSharedSteps {
  id
  stepsAnchor: anchorId
  stepsTitle: title
  alternativeTitle
  step {
    ...Step
  }
  stepsButton: button {
    ...Button
  }
  disableNumbering
}
    ${StepFragmentDoc}
${ButtonFragmentDoc}`;
export const NewsletterCtaFragmentDoc = gql`
    fragment NewsletterCta on ComponentSharedNewsletterCta {
  id
  newsletterCtaAnchor: anchorId
  ctaTitle: title
  description
  hint
  visual {
    ...UploadFileEntityResponse
  }
  campaignId
  newsletterCtaButtonLabel: buttonLabel
  formType
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const ContentCardFragmentDoc = gql`
    fragment ContentCard on ComponentSharedCard {
  contentTitle
  contentText
  contentImage {
    ...UploadFileEntityResponse
  }
  button {
    ...Button
  }
  buttonAlt {
    ...Button
  }
}
    ${UploadFileEntityResponseFragmentDoc}
${ButtonFragmentDoc}`;
export const HighlightsFragmentDoc = gql`
    fragment Highlights on ComponentSharedHighlights {
  id
  highlightsAnchor: anchorId
  highlightsTitle: Title
  Layout
  Highlight {
    ...ContentCard
  }
}
    ${ContentCardFragmentDoc}`;
export const SimpleCtaFragmentDoc = gql`
    fragment SimpleCta on ComponentSharedSimpleCta {
  id
  simpleCtaAnchor: anchorId
  simpleCtaTitle: title
  simpleCtaDescription: description
  simpleCtaImage: image {
    ...UploadFileEntityResponse
  }
  simpleCtaButton: button {
    ...Button
  }
}
    ${UploadFileEntityResponseFragmentDoc}
${ButtonFragmentDoc}`;
export const RouteOverviewFragmentDoc = gql`
    fragment RouteOverview on RouteOverview {
  id
  thumbnails {
    large
    medium
    small
  }
  distanceMeters
  simplifiedGeometryPoints {
    latitude
    longitude
    distance
    altitude
  }
  stravaSegmentsCount
  estimatedTimeSeconds
  coinsForCompletion
  ascendedMeters
  countryCodeISO
}
    `;
export const EventInfoFragmentDoc = gql`
    fragment EventInfo on EventInfo {
  eventId
  id
  capacity
  category
  enteringOffsetSeconds
  lateStartOffsetSeconds
  locale
  longDescription
  official
  registrationsCount
  subcategory
  title
  expandTitle
  official
  type
  description
  isDrafting
  smartTrainersOnly
  mainPhoto {
    data {
      attributes {
        url
      }
    }
  }
  coverPhoto {
    data {
      attributes {
        url
      }
    }
  }
  route {
    ...RouteOverview
  }
  sessions {
    id
    startDateTime
    status
    coinsForCompletion
  }
  laps
}
    ${RouteOverviewFragmentDoc}`;
export const EventInfoEntityRelationCollectionItemFragmentDoc = gql`
    fragment EventInfoEntityRelationCollectionItem on EventInfoRelationResponseCollection {
  data {
    id
    attributes {
      ...EventInfo
    }
  }
}
    ${EventInfoFragmentDoc}`;
export const EventsFragmentDoc = gql`
    fragment Events on ComponentSharedEvents {
  id
  eventsAnchor: anchorId
  eventsTitle: title
  button {
    ...Button
  }
  eventInfos {
    ...EventInfoEntityRelationCollectionItem
  }
  featuredEventInfos {
    ...EventInfo
  }
  filterEventInfos {
    ...EventInfo
  }
  category
  subcategory
  logosStrip {
    ...UploadFileRelationResponseCollection
  }
  featured
  inverted
  expand
}
    ${ButtonFragmentDoc}
${EventInfoEntityRelationCollectionItemFragmentDoc}
${EventInfoFragmentDoc}
${UploadFileRelationResponseCollectionFragmentDoc}`;
export const CompanionAppCtaFragmentDoc = gql`
    fragment CompanionAppCta on ComponentSharedCompanionAppCta {
  id
  companionAppCtaAnchor: anchorId
  companionAppCtaTitle: title
  companionAppCtaDescription: description
  companionAppCtaImage: image {
    ...UploadFileEntityResponse
  }
  buttons {
    ...Button
  }
}
    ${UploadFileEntityResponseFragmentDoc}
${ButtonFragmentDoc}`;
export const PageNavigationFragmentDoc = gql`
    fragment PageNavigation on ComponentSharedPageNavigation {
  id
  pageNavTitle: title
  pageNavDescription: description
  buttons {
    ...Button
  }
  pageNavAnchor: anchorId
}
    ${ButtonFragmentDoc}`;
export const RegisterCtaFragmentDoc = gql`
    fragment RegisterCta on ComponentSharedRegisterCta {
  id
  registerCtaTitle: title
  registerCtaDescription: description
  image {
    ...UploadFileEntityResponse
  }
  registerCtaAnchor: anchorId
  registerCtaCampaignId: campaignId
  linkAfterEmailSubmit
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const PartnerListItemFragmentDoc = gql`
    fragment PartnerListItem on Partner {
  id
  title
  slug
  web
  lead
  logo {
    ...UploadFileEntityResponse
  }
  thumbnailImage {
    ...UploadFileEntityResponse
  }
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const RoutePointGeoFragmentDoc = gql`
    fragment RoutePointGeo on RoutePointGeo {
  distance
  altitude
}
    `;
export const RoutesPageListItemFragmentDoc = gql`
    fragment RoutesPageListItem on Route {
  id
  links {
    detail
  }
  name
  videoPreview {
    url
    thumbnail
    thumbnailClear
    thumbnailHiRes
  }
  distanceInMeters
  elevationInMeters
  stravaLiveSegmentsCount
  estimatedTime
  onlineCount
  countryCode
  supportsAugmentedReality
  maxVideoQuality
  promoPreview {
    type
    url
  }
  partner {
    ...PartnerListItem
  }
  geometry {
    ...RoutePointGeo
  }
  rating
  description
  coinsForCompletion
}
    ${PartnerListItemFragmentDoc}
${RoutePointGeoFragmentDoc}`;
export const RoutesSectionFragmentDoc = gql`
    fragment RoutesSection on ComponentSharedRoutesSection {
  id
  routesTitle: title
  type
  categorySlug
  offset
  limit
  routesAnchor: anchorId
  logosStrip {
    ...UploadFileRelationResponseCollection
  }
  routeIds {
    ... on ComponentSharedRoutes {
      ids
      list {
        ...RoutesPageListItem
      }
    }
  }
  routes {
    ...RoutesPageListItem
  }
  expand
}
    ${UploadFileRelationResponseCollectionFragmentDoc}
${RoutesPageListItemFragmentDoc}`;
export const NavbarFragmentDoc = gql`
    fragment Navbar on ComponentSharedNavbar {
  id
  navbarItems {
    title
    path
  }
  navbarAnchor: anchorId
}
    `;
export const LinksCarouselFragmentDoc = gql`
    fragment LinksCarousel on ComponentSharedLinksCarousel {
  id
  linksCarouselTitle: title
  items: LinksCarouselItem {
    title
    description
    image {
      ...UploadFileEntityResponse
    }
    url
    label
  }
  linksCarouselAnchor: anchorId
  linksCarouselButtonClickThrough: buttonClickThrough
  background
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const YoutubeVideoFragmentDoc = gql`
    fragment YoutubeVideo on ComponentSharedYouTubeVideo {
  id
  youTubeTitle: title
  youTubeAnchor: anchorId
  embedCode
  videoUrl
  caption
  cover {
    ...UploadFileEntityResponse
  }
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const StripeFragmentDoc = gql`
    fragment Stripe on ComponentSharedStripe {
  id
  stripeTitle: title
  stripeAnchorId: anchorId
  titleSecondLine
  textColor
  backgroundColor
  upperBackgroundColor
  lowerBackgroundColor
}
    `;
export const TextBlockFragmentDoc = gql`
    fragment TextBlock on ComponentSharedTextBlock {
  id
  text
}
    `;
export const EventInfoEntityFragmentDoc = gql`
    fragment EventInfoEntity on EventInfoEntityResponse {
  data {
    id
    attributes {
      ...EventInfo
    }
  }
}
    ${EventInfoFragmentDoc}`;
export const ChallengeEntityResponseFragmentDoc = gql`
    fragment ChallengeEntityResponse on ChallengeEntityResponse {
  data {
    ...ChallengeEntity
  }
}
    ${ChallengeEntityFragmentDoc}`;
export const WorkoutSegmentFragmentDoc = gql`
    fragment WorkoutSegment on WorkoutSegment {
  duration
  intervalType
  type: primaryType
  valueStart: primaryStart
  valueEnd: primaryEnd
}
    `;
export const WorkoutFragmentDoc = gql`
    fragment Workout on WorkoutDetail {
  id
  name
  duration
  durationType
  description
  intensityFactor: if
  tss
  coinsForCompletion
  difficulty
  trainingEffects
  segments {
    ...WorkoutSegment
  }
  coinsForCompletion
  recommendedRoute {
    simplifiedGeometryPoints {
      altitude
      distance
    }
  }
}
    ${WorkoutSegmentFragmentDoc}`;
export const TrainingPlanTagFragmentDoc = gql`
    fragment TrainingPlanTag on TrainingPlanTag {
  id
  name
  color
}
    `;
export const TrainingPlanOverviewFragmentDoc = gql`
    fragment TrainingPlanOverview on TrainingPlanOverview {
  id
  name
  description
  backgroundImageUrl
  totalDurationSeconds
  expectedDurationDays
  coinsForCompletion
  blocksCount
  trainingUnitsCount
  trainingPlanTags: tags {
    ...TrainingPlanTag
  }
}
    ${TrainingPlanTagFragmentDoc}`;
export const SimpleCardFragmentDoc = gql`
    fragment SimpleCard on ComponentSharedSimpleCard {
  id
  title
  description
  url
  cover {
    ...UploadFileEntityResponse
  }
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const SpotlightFragmentDoc = gql`
    fragment Spotlight on ComponentSharedSpotlight {
  id
  routeId
  workoutId
  route {
    ...RoutesPageListItem
  }
  eventInfo {
    ...EventInfoEntity
  }
  challenge {
    ...ChallengeEntityResponse
  }
  workout: workoutDetail {
    ...Workout
  }
  trainingPlanId
  trainingPlan {
    ...TrainingPlanOverview
  }
  card {
    ...SimpleCard
  }
}
    ${RoutesPageListItemFragmentDoc}
${EventInfoEntityFragmentDoc}
${ChallengeEntityResponseFragmentDoc}
${WorkoutFragmentDoc}
${TrainingPlanOverviewFragmentDoc}
${SimpleCardFragmentDoc}`;
export const SpotlightsFragmentDoc = gql`
    fragment Spotlights on ComponentSharedSpotlights {
  id
  spotlightsAnchorId: anchorId
  spotlight {
    data {
      attributes {
        title
        anchorId
        subtitle
        description
        button {
          ...Button
        }
        backgroundImage {
          ...UploadFileEntityResponse
        }
        spotlights {
          ...Spotlight
        }
      }
    }
  }
}
    ${ButtonFragmentDoc}
${UploadFileEntityResponseFragmentDoc}
${SpotlightFragmentDoc}`;
export const ChallengeFragmentDoc = gql`
    fragment Challenge on Challenge {
  challengeId
  experience
  startDateTime
  endDateTime
  title
  expandTitle
  registeredCount
  description
  logoOriginal
  coins
  tasksAndRules {
    title
    subtitle
    routes {
      id
    }
    workouts {
      id
    }
  }
}
    `;
export const ChallengesFragmentDoc = gql`
    fragment Challenges on ComponentSharedChallenges {
  id
  challengesAnchor: anchorId
  challengesTitle: title
  challenges {
    data {
      id
      attributes {
        ...Challenge
      }
    }
  }
  expand
}
    ${ChallengeFragmentDoc}`;
export const BlogPostListItemFragmentDoc = gql`
    fragment BlogPostListItem on BlogPost {
  title
  perex
  slug
  cover {
    ...UploadFileEntityResponse
  }
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const BlogPostsFragmentDoc = gql`
    fragment BlogPosts on ComponentSharedBlogPosts {
  id
  blogPostsTitle: title
  blogPostsAnchor: anchorId
  blogPosts {
    data {
      attributes {
        ...BlogPostListItem
      }
    }
  }
  expand
}
    ${BlogPostListItemFragmentDoc}`;
export const SpotlightsListItemFragmentDoc = gql`
    fragment SpotlightsListItem on Spotlight {
  title
  subtitle
  button {
    ...Button
  }
  backgroundImage {
    ...UploadFileEntityResponse
  }
}
    ${ButtonFragmentDoc}
${UploadFileEntityResponseFragmentDoc}`;
export const SpotlightRelationResponseCollectionFragmentDoc = gql`
    fragment SpotlightRelationResponseCollection on SpotlightRelationResponseCollection {
  data {
    id
    attributes {
      ...SpotlightsListItem
    }
  }
}
    ${SpotlightsListItemFragmentDoc}`;
export const SpotlightsListFragmentDoc = gql`
    fragment SpotlightsList on ComponentSharedSpotlightsList {
  id
  spotlightsListTitle: title
  spotlightsListAnchor: anchorId
  spotlights {
    ...SpotlightRelationResponseCollection
  }
}
    ${SpotlightRelationResponseCollectionFragmentDoc}`;
export const VideoFragmentDoc = gql`
    fragment Video on ComponentSharedVideo {
  video {
    ...UploadFileEntityResponse
  }
  videoUrl
  thumbnail {
    ...UploadFileEntityResponse
  }
  autoPlay
  muted
  loop
  showControls
  showVideo
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const HeaderVideoFragmentDoc = gql`
    fragment HeaderVideo on ComponentSharedHeaderVideo {
  headline
  subheading
  headerVideoDescription: description
  buttons {
    ...Button
  }
  campaingId
  headerVideoAnchor: anchorId
  headerVideo: video {
    ...Video
  }
  headerVideoResponsive: videoResponsive {
    ...Video
  }
}
    ${ButtonFragmentDoc}
${VideoFragmentDoc}`;
export const WorkoutsSectionFragmentDoc = gql`
    fragment WorkoutsSection on ComponentSharedWorkoutsSection {
  id
  workoutsTitle: title
  expand
  workoutsAnchor: anchorId
  workouts {
    ids
    list: workoutDetails {
      ...Workout
    }
  }
}
    ${WorkoutFragmentDoc}`;
export const PricingFragmentDoc = gql`
    fragment Pricing on ComponentSharedPricing {
  id
  pricingTitle: title
  pricingContent: content
  pricingAnchor: anchorId
  button {
    ...Button
  }
  yearlyToMonths
  monthly
  plan
  termsSection
  linkAfterEmailSubmit
}
    ${ButtonFragmentDoc}`;
export const ContentTeaserFragmentDoc = gql`
    fragment ContentTeaser on ComponentSharedContentTeaser {
  id
  teaserTitle: title
  teaserDescription: description
  teaserAnchor: anchorId
  size
  logo {
    ...UploadFileEntityResponse
  }
  logoResponsive {
    ...UploadFileEntityResponse
  }
  backgroundImage {
    ...UploadFileEntityResponse
  }
  backgroundImageResponsive {
    ...UploadFileEntityResponse
  }
  cards {
    cover {
      ...UploadFileEntityResponse
    }
    title
    description
    url
  }
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const ProductsComparisonFragmentDoc = gql`
    fragment ProductsComparison on ComponentSharedProductsComparison {
  id
  productsComparisonTitle: title
  productsComparisonSubtitle: subtitle
  productsComparisonFeaturesTitle: featuresTitle
  productsComparisonAnchor: anchorId
  button {
    ...Button
  }
  productsJson
}
    ${ButtonFragmentDoc}`;
export const ChecklistFragmentDoc = gql`
    fragment Checklist on ComponentSharedChecklist {
  id
  checklistTitle: title
  checklistAnchor: anchorId
  checklistItems: items
  vertical
}
    `;
export const PlansSelectorFragmentDoc = gql`
    fragment PlansSelector on ComponentSharedPlansSelector {
  id
  plansSelectorTitle: title
  plansSelectorSubtitle: subtitle
  plansSelectorAnchor: anchorId
  button {
    ...Button
  }
  termsSection
}
    ${ButtonFragmentDoc}`;
export const TestimonialFragmentDoc = gql`
    fragment Testimonial on ComponentSharedTestimonial {
  testimonial
  author
  authorType
}
    `;
export const TestimonialsSectionFragmentDoc = gql`
    fragment TestimonialsSection on ComponentSharedTestimonialsSection {
  testimonials {
    ...Testimonial
  }
  testimonialsAnchor: anchorId
  autoscrollInterval
}
    ${TestimonialFragmentDoc}`;
export const LogoFragmentDoc = gql`
    fragment Logo on ComponentSharedLogo {
  id
  title
  image {
    ...UploadFileEntityResponse
  }
  link
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const LogoCloudsFragmentDoc = gql`
    fragment LogoClouds on ComponentSharedLogoClouds {
  id
  logoCloudsTitle: title
  logos {
    ...Logo
  }
}
    ${LogoFragmentDoc}`;
export const FeaturedLogoFragmentDoc = gql`
    fragment FeaturedLogo on ComponentSharedFeaturedLogo {
  id
  title
  featuredLogo: logo {
    ...Logo
  }
}
    ${LogoFragmentDoc}`;
export const HomepageBodyFragmentDoc = gql`
    fragment HomepageBody on HomepageBodyDynamicZone {
  __typename
  ...Header
  ...Faq
  ...Prizes
  ...Steps
  ...NewsletterCta
  ...Highlights
  ...SimpleCta
  ...Events
  ...CompanionAppCta
  ...PageNavigation
  ...RegisterCta
  ...RoutesSection
  ...Navbar
  ...LinksCarousel
  ...YoutubeVideo
  ...Stripe
  ...TextBlock
  ...Spotlights
  ...Challenges
  ...BlogPosts
  ...SpotlightsList
  ...HeaderVideo
  ...WorkoutsSection
  ...Pricing
  ...ContentTeaser
  ...ProductsComparison
  ...Checklist
  ...PlansSelector
  ...TestimonialsSection
  ...LogoClouds
  ...FeaturedLogo
}
    ${HeaderFragmentDoc}
${FaqFragmentDoc}
${PrizesFragmentDoc}
${StepsFragmentDoc}
${NewsletterCtaFragmentDoc}
${HighlightsFragmentDoc}
${SimpleCtaFragmentDoc}
${EventsFragmentDoc}
${CompanionAppCtaFragmentDoc}
${PageNavigationFragmentDoc}
${RegisterCtaFragmentDoc}
${RoutesSectionFragmentDoc}
${NavbarFragmentDoc}
${LinksCarouselFragmentDoc}
${YoutubeVideoFragmentDoc}
${StripeFragmentDoc}
${TextBlockFragmentDoc}
${SpotlightsFragmentDoc}
${ChallengesFragmentDoc}
${BlogPostsFragmentDoc}
${SpotlightsListFragmentDoc}
${HeaderVideoFragmentDoc}
${WorkoutsSectionFragmentDoc}
${PricingFragmentDoc}
${ContentTeaserFragmentDoc}
${ProductsComparisonFragmentDoc}
${ChecklistFragmentDoc}
${PlansSelectorFragmentDoc}
${TestimonialsSectionFragmentDoc}
${LogoCloudsFragmentDoc}
${FeaturedLogoFragmentDoc}`;
export const HeaderAcceptInviteFragmentDoc = gql`
    fragment HeaderAcceptInvite on ComponentSharedHeaderAcceptInvite {
  id
  acceptInviteHeading: heading
  acceptInviteHeadingFallback: headingFallback
  acceptInviteSubheading: subheading
  acceptInviteSubheadingFallback: subheadingFallback
  acceptInviteButton: button {
    ...Button
  }
  acceptInviteButtonFallback: buttonFallback {
    ...Button
  }
  acceptInviteBackgroundImage: backgroundImage {
    ...UploadFileEntityResponse
  }
}
    ${ButtonFragmentDoc}
${UploadFileEntityResponseFragmentDoc}`;
export const TwoColumnsContentFragmentDoc = gql`
    fragment TwoColumnsContent on ComponentSharedTwoColumnsContent {
  twoColumnsContentTitle: title
  twoColumnsContentDescription: description
  twoColumnsContentText: text
  twoColumnsContentImage: image {
    data {
      attributes {
        url
      }
    }
  }
}
    `;
export const DynamicPageBodyFragmentDoc = gql`
    fragment DynamicPageBody on DynamicPageBodyDynamicZone {
  __typename
  ...Header
  ...HeaderAcceptInvite
  ...Faq
  ...Prizes
  ...Steps
  ...NewsletterCta
  ...Highlights
  ...SimpleCta
  ...Events
  ...CompanionAppCta
  ...PageNavigation
  ...RegisterCta
  ...RoutesSection
  ...Navbar
  ...LinksCarousel
  ...YoutubeVideo
  ...Stripe
  ...TextBlock
  ...Spotlights
  ...Challenges
  ...BlogPosts
  ...SpotlightsList
  ...HeaderVideo
  ...WorkoutsSection
  ...Pricing
  ...ContentTeaser
  ...ProductsComparison
  ...Checklist
  ...PlansSelector
  ...TestimonialsSection
  ...TwoColumnsContent
  ...LogoClouds
  ...FeaturedLogo
}
    ${HeaderFragmentDoc}
${HeaderAcceptInviteFragmentDoc}
${FaqFragmentDoc}
${PrizesFragmentDoc}
${StepsFragmentDoc}
${NewsletterCtaFragmentDoc}
${HighlightsFragmentDoc}
${SimpleCtaFragmentDoc}
${EventsFragmentDoc}
${CompanionAppCtaFragmentDoc}
${PageNavigationFragmentDoc}
${RegisterCtaFragmentDoc}
${RoutesSectionFragmentDoc}
${NavbarFragmentDoc}
${LinksCarouselFragmentDoc}
${YoutubeVideoFragmentDoc}
${StripeFragmentDoc}
${TextBlockFragmentDoc}
${SpotlightsFragmentDoc}
${ChallengesFragmentDoc}
${BlogPostsFragmentDoc}
${SpotlightsListFragmentDoc}
${HeaderVideoFragmentDoc}
${WorkoutsSectionFragmentDoc}
${PricingFragmentDoc}
${ContentTeaserFragmentDoc}
${ProductsComparisonFragmentDoc}
${ChecklistFragmentDoc}
${PlansSelectorFragmentDoc}
${TestimonialsSectionFragmentDoc}
${TwoColumnsContentFragmentDoc}
${LogoCloudsFragmentDoc}
${FeaturedLogoFragmentDoc}`;
export const BlogDynamicBodyFragmentDoc = gql`
    fragment BlogDynamicBody on BlogPostDynamicBodyDynamicZone {
  __typename
  ...Faq
  ...Prizes
  ...Steps
  ...NewsletterCta
  ...Highlights
  ...SimpleCta
  ...Events
  ...CompanionAppCta
  ...PageNavigation
  ...RegisterCta
  ...RoutesSection
  ...Navbar
  ...LinksCarousel
  ...YoutubeVideo
  ...Stripe
  ...TextBlock
  ...Spotlights
  ...Challenges
  ...BlogPosts
  ...SpotlightsList
  ...WorkoutsSection
  ...Pricing
  ...ProductsComparison
  ...Checklist
  ...PlansSelector
  ...TestimonialsSection
  ...TwoColumnsContent
  ...LogoClouds
  ...FeaturedLogo
}
    ${FaqFragmentDoc}
${PrizesFragmentDoc}
${StepsFragmentDoc}
${NewsletterCtaFragmentDoc}
${HighlightsFragmentDoc}
${SimpleCtaFragmentDoc}
${EventsFragmentDoc}
${CompanionAppCtaFragmentDoc}
${PageNavigationFragmentDoc}
${RegisterCtaFragmentDoc}
${RoutesSectionFragmentDoc}
${NavbarFragmentDoc}
${LinksCarouselFragmentDoc}
${YoutubeVideoFragmentDoc}
${StripeFragmentDoc}
${TextBlockFragmentDoc}
${SpotlightsFragmentDoc}
${ChallengesFragmentDoc}
${BlogPostsFragmentDoc}
${SpotlightsListFragmentDoc}
${WorkoutsSectionFragmentDoc}
${PricingFragmentDoc}
${ProductsComparisonFragmentDoc}
${ChecklistFragmentDoc}
${PlansSelectorFragmentDoc}
${TestimonialsSectionFragmentDoc}
${TwoColumnsContentFragmentDoc}
${LogoCloudsFragmentDoc}
${FeaturedLogoFragmentDoc}`;
export const NavbarSettingsFragmentDoc = gql`
    fragment NavbarSettings on ComponentSharedNavbarSettings {
  logoLink {
    url
    title
  }
  navLinks {
    url
    title
  }
  buttons {
    ...Button
  }
  transparent
  fixed
  secondaryLogo {
    ...UploadFileEntityResponse
  }
  secondaryLogoLink
}
    ${ButtonFragmentDoc}
${UploadFileEntityResponseFragmentDoc}`;
export const SeoFragmentDoc = gql`
    fragment SEO on ComponentSharedSeo {
  metaDescription
  metaTitle
  ogTitle
  noFollow
  noIndex
  shareImage {
    ...UploadFileEntityResponse
  }
}
    ${UploadFileEntityResponseFragmentDoc}`;
export const AuthorFragmentDoc = gql`
    fragment Author on Author {
  id
  name
  slug
  perex
  locale
  updatedAt
  jobTitle
  socialPlatform {
    type
    link
  }
  SEO {
    ...SEO
  }
  profilePhoto {
    data {
      attributes {
        name
        url
        width
        height
        alternativeText
        mime
        formats
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const BlogPostsListItemFragmentDoc = gql`
    fragment BlogPostsListItem on BlogPost {
  id
  title
  slug
  perex
  publishDate
  cover {
    ...UploadFileEntityResponse
  }
  SEO {
    ...SEO
  }
  author {
    data {
      attributes {
        name
        slug
        profilePhoto {
          ...UploadFileRelationResponseCollection
        }
      }
    }
  }
  blog_tags {
    data {
      id
      attributes {
        title
        slug
      }
    }
  }
  blog_category {
    data {
      attributes {
        title
        slug
      }
    }
  }
}
    ${UploadFileEntityResponseFragmentDoc}
${SeoFragmentDoc}
${UploadFileRelationResponseCollectionFragmentDoc}`;
export const StaticPageFragmentDoc = gql`
    fragment StaticPage on StaticPage {
  __typename
  title
  text
  SEO {
    ...SEO
  }
  localizations {
    data {
      attributes {
        locale
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const TermsFragmentDoc = gql`
    fragment Terms on Terms {
  id
  majorVersion
  minorVersion
  effectiveAt
  text
}
    `;
export const AuthorBySlugDocument = gql`
    query AuthorBySlug($slug: String!) {
  authorBySlug(slug: $slug) {
    ...Author
    localizations {
      data {
        attributes {
          locale
        }
      }
    }
  }
}
    ${AuthorFragmentDoc}`;
export const AuthorsDocument = gql`
    query Authors($sort: String, $limit: Int, $start: Int, $where: JSON) {
  authors(sort: $sort, limit: $limit, start: $start, where: $where) {
    ...Author
  }
}
    ${AuthorFragmentDoc}`;
export const AuthorsSitemapDocument = gql`
    query AuthorsSitemap($sort: String, $limit: Int, $start: Int, $where: JSON) {
  authors(sort: $sort, limit: $limit, start: $start, where: $where) {
    slug
    locale
    SEO {
      noIndex
    }
    updatedAt
    localizations {
      data {
        attributes {
          locale
          updatedAt
          SEO {
            noIndex
          }
        }
      }
    }
  }
}
    `;
export const BlogCategoriesDocument = gql`
    query BlogCategories($locale: String, $publicationState: PublicationState) {
  blogCategories(locale: $locale, publicationState: $publicationState) {
    id
    title
    slug
    SEO {
      ...SEO
    }
    locale
    localizations {
      data {
        attributes {
          locale
        }
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const BlogCategoriesSitemapDocument = gql`
    query BlogCategoriesSitemap($locale: String, $publicationState: PublicationState) {
  blogCategories(locale: $locale, publicationState: $publicationState) {
    slug
    updatedAt
    SEO {
      noIndex
    }
    localizations {
      data {
        attributes {
          SEO {
            noIndex
          }
          updatedAt
          locale
        }
      }
    }
  }
}
    `;
export const BlogPostsDocument = gql`
    query BlogPosts($sort: String, $limit: Int, $start: Int, $where: JSON, $locale: String, $publicationState: PublicationState) {
  blogPosts(
    sort: $sort
    limit: $limit
    start: $start
    where: $where
    locale: $locale
    publicationState: $publicationState
  ) {
    ...BlogPostsListItem
  }
}
    ${BlogPostsListItemFragmentDoc}`;
export const BlogPostsSitemapDocument = gql`
    query BlogPostsSitemap($sort: String, $limit: Int, $start: Int, $where: JSON, $locale: String, $publicationState: PublicationState) {
  blogPosts(
    sort: $sort
    limit: $limit
    start: $start
    where: $where
    locale: $locale
    publicationState: $publicationState
  ) {
    slug
    locale
    updatedAt
    SEO {
      noIndex
    }
    localizations {
      data {
        attributes {
          locale
          updatedAt
          SEO {
            noIndex
          }
        }
      }
    }
  }
}
    `;
export const BlogPostsSearchDocument = gql`
    query BlogPostsSearch($sort: String, $limit: Int, $start: Int, $where: JSON, $locale: String, $searchTerm: String, $publicationState: PublicationState) {
  blogPostsSearch(
    sort: $sort
    limit: $limit
    start: $start
    where: $where
    locale: $locale
    searchTerm: $searchTerm
    publicationState: $publicationState
  ) {
    ...BlogPostsListItem
  }
}
    ${BlogPostsListItemFragmentDoc}`;
export const BlogPostsBySlugDocument = gql`
    query BlogPostsBySlug($slug: String!, $locale: I18NLocaleCode, $publicationState: PublicationState) {
  blogPostBySlug(
    slug: $slug
    locale: $locale
    publicationState: $publicationState
  ) {
    id
    title
    slug
    perex
    body
    publishDate
    structuredDataHeadline
    cover {
      ...UploadFileEntityResponse
    }
    SEO {
      ...SEO
    }
    author {
      data {
        id
        attributes {
          name
          slug
          perex
          locale
          updatedAt
          profilePhoto {
            ...UploadFileRelationResponseCollection
          }
        }
      }
    }
    blog_tags {
      data {
        id
        attributes {
          title
          slug
        }
      }
    }
    blog_category {
      data {
        id
        attributes {
          title
          slug
          locale
          updatedAt
          SEO {
            ...SEO
          }
        }
      }
    }
    dynamicBody {
      ...BlogDynamicBody
    }
    contentLayers {
      ...ContentLayers
    }
    localizations {
      data {
        attributes {
          locale
        }
      }
    }
  }
}
    ${UploadFileEntityResponseFragmentDoc}
${SeoFragmentDoc}
${UploadFileRelationResponseCollectionFragmentDoc}
${BlogDynamicBodyFragmentDoc}
${ContentLayersFragmentDoc}`;
export const BlogTagBySlugDocument = gql`
    query BlogTagBySlug($slug: String!) {
  blogTagBySlug(slug: $slug) {
    id
    title
    slug
    SEO {
      ...SEO
    }
    locale
    localizations {
      data {
        attributes {
          locale
        }
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const BlogTagsDocument = gql`
    query BlogTags($sort: String, $limit: Int, $start: Int, $where: JSON) {
  blogTags(sort: $sort, limit: $limit, start: $start, where: $where) {
    id
    title
    slug
    SEO {
      ...SEO
    }
  }
}
    ${SeoFragmentDoc}`;
export const BlogTagsSitemapDocument = gql`
    query BlogTagsSitemap($sort: String, $limit: Int, $start: Int, $where: JSON) {
  blogTags(sort: $sort, limit: $limit, start: $start, where: $where) {
    slug
    SEO {
      noIndex
    }
    updatedAt
    localizations {
      data {
        attributes {
          locale
          updatedAt
          SEO {
            noIndex
          }
        }
      }
    }
  }
}
    `;
export const DynamicPageDocument = gql`
    query DynamicPage($path: String!, $locale: I18NLocaleCode, $publicationState: PublicationState) {
  dynamicPageByPath(
    path: $path
    locale: $locale
    publicationState: $publicationState
  ) {
    title
    structuredDataHeadline
    publishedAt
    SEO {
      ...SEO
    }
    navbarSettings {
      ...NavbarSettings
    }
    body {
      ...DynamicPageBody
    }
    contentLayers {
      ...ContentLayers
    }
    localizations {
      data {
        attributes {
          locale
        }
      }
    }
  }
}
    ${SeoFragmentDoc}
${NavbarSettingsFragmentDoc}
${DynamicPageBodyFragmentDoc}
${ContentLayersFragmentDoc}`;
export const DynamicPagesSitemapDocument = gql`
    query DynamicPagesSitemap($locale: String, $publicationState: PublicationState) {
  dynamicPage(locale: $locale, publicationState: $publicationState) {
    path
    locale
    SEO {
      noIndex
    }
    updatedAt
    localizations {
      data {
        attributes {
          locale
          updatedAt
          SEO {
            noIndex
          }
        }
      }
    }
  }
}
    `;
export const FooterLinkGroupsDocument = gql`
    query FooterLinkGroups($locale: I18NLocaleCode, $publicationState: PublicationState) {
  footer(locale: $locale, publicationState: $publicationState) {
    groups {
      title
      links {
        title
        url
      }
    }
    bottomLinks {
      title
      url
    }
  }
}
    `;
export const HomepageDocument = gql`
    query Homepage($variant: String!, $locale: I18NLocaleCode, $publicationState: PublicationState) {
  homepage(
    variant: $variant
    locale: $locale
    publicationState: $publicationState
  ) {
    SEO {
      ...SEO
    }
    navbarSettings {
      ...NavbarSettings
    }
    body {
      ...HomepageBody
    }
    localizations {
      data {
        attributes {
          locale
        }
      }
    }
  }
}
    ${SeoFragmentDoc}
${NavbarSettingsFragmentDoc}
${HomepageBodyFragmentDoc}`;
export const DefaultNavbarDocument = gql`
    query DefaultNavbar($locale: I18NLocaleCode, $publicationState: PublicationState) {
  navbar(locale: $locale, publicationState: $publicationState) {
    navbarSettings {
      ...NavbarSettings
    }
  }
}
    ${NavbarSettingsFragmentDoc}`;
export const PostsDocument = gql`
    query Posts($sort: String, $limit: Int, $start: Int, $where: JSON, $publicationState: PublicationState, $locale: String) {
  posts(
    sort: $sort
    limit: $limit
    start: $start
    where: $where
    publicationState: $publicationState
    locale: $locale
  ) {
    id
    title
    slug
    perex
    publishedAt
    cover {
      data {
        ...UploadFileEntity
      }
    }
    SEO {
      ...SEO
    }
  }
}
    ${UploadFileEntityFragmentDoc}
${SeoFragmentDoc}`;
export const PostDocument = gql`
    query Post($slug: String!, $category: ENUM_POST_CATEGORY!, $publicationState: PublicationState, $locale: I18NLocaleCode) {
  postBySlug(
    slug: $slug
    publicationState: $publicationState
    category: $category
    locale: $locale
  ) {
    title
    slug
    perex
    text
    publishedAt
    SEO {
      ...SEO
    }
    paragraphs {
      text
      youtubeLink
      asset {
        data {
          ...UploadFileEntity
        }
      }
    }
    cover {
      data {
        ...UploadFileEntity
      }
    }
    localizations {
      data {
        attributes {
          locale
        }
      }
    }
  }
}
    ${SeoFragmentDoc}
${UploadFileEntityFragmentDoc}`;
export const PostsSitemapDocument = gql`
    query PostsSitemap($sort: String, $limit: Int, $start: Int, $where: JSON, $publicationState: PublicationState, $locale: String) {
  posts(
    sort: $sort
    limit: $limit
    start: $start
    where: $where
    publicationState: $publicationState
    locale: $locale
  ) {
    slug
    updatedAt
    SEO {
      noIndex
    }
    localizations {
      data {
        attributes {
          SEO {
            noIndex
          }
          locale
          updatedAt
        }
      }
    }
  }
}
    `;
export const RedirectDocument = gql`
    query Redirect($source: String, $publicationState: PublicationState!) {
  redirect(publicationState: $publicationState, source: $source) {
    destination
    permanent
  }
}
    `;
export const StaticPageDocument = gql`
    query StaticPage($slug: String!, $publicationState: PublicationState, $locale: I18NLocaleCode) {
  staticPage(slug: $slug, publicationState: $publicationState, locale: $locale) {
    ...StaticPage
  }
}
    ${StaticPageFragmentDoc}`;
export const TermsDocument = gql`
    query Terms($language: String!) {
  terms(language: $language) {
    ...Terms
  }
}
    ${TermsFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    AuthorBySlug(variables: AuthorBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AuthorBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorBySlugQuery>(AuthorBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AuthorBySlug', 'query', variables);
    },
    Authors(variables?: AuthorsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AuthorsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorsQuery>(AuthorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Authors', 'query', variables);
    },
    AuthorsSitemap(variables?: AuthorsSitemapQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AuthorsSitemapQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthorsSitemapQuery>(AuthorsSitemapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AuthorsSitemap', 'query', variables);
    },
    BlogCategories(variables?: BlogCategoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogCategoriesQuery>(BlogCategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogCategories', 'query', variables);
    },
    BlogCategoriesSitemap(variables?: BlogCategoriesSitemapQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogCategoriesSitemapQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogCategoriesSitemapQuery>(BlogCategoriesSitemapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogCategoriesSitemap', 'query', variables);
    },
    BlogPosts(variables?: BlogPostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogPostsQuery>(BlogPostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogPosts', 'query', variables);
    },
    BlogPostsSitemap(variables?: BlogPostsSitemapQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogPostsSitemapQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogPostsSitemapQuery>(BlogPostsSitemapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogPostsSitemap', 'query', variables);
    },
    BlogPostsSearch(variables?: BlogPostsSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogPostsSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogPostsSearchQuery>(BlogPostsSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogPostsSearch', 'query', variables);
    },
    BlogPostsBySlug(variables: BlogPostsBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogPostsBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogPostsBySlugQuery>(BlogPostsBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogPostsBySlug', 'query', variables);
    },
    BlogTagBySlug(variables: BlogTagBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogTagBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogTagBySlugQuery>(BlogTagBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogTagBySlug', 'query', variables);
    },
    BlogTags(variables?: BlogTagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogTagsQuery>(BlogTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogTags', 'query', variables);
    },
    BlogTagsSitemap(variables?: BlogTagsSitemapQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlogTagsSitemapQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlogTagsSitemapQuery>(BlogTagsSitemapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlogTagsSitemap', 'query', variables);
    },
    DynamicPage(variables: DynamicPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DynamicPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DynamicPageQuery>(DynamicPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DynamicPage', 'query', variables);
    },
    DynamicPagesSitemap(variables?: DynamicPagesSitemapQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DynamicPagesSitemapQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DynamicPagesSitemapQuery>(DynamicPagesSitemapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DynamicPagesSitemap', 'query', variables);
    },
    FooterLinkGroups(variables?: FooterLinkGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FooterLinkGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FooterLinkGroupsQuery>(FooterLinkGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FooterLinkGroups', 'query', variables);
    },
    Homepage(variables: HomepageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<HomepageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<HomepageQuery>(HomepageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Homepage', 'query', variables);
    },
    DefaultNavbar(variables?: DefaultNavbarQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DefaultNavbarQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DefaultNavbarQuery>(DefaultNavbarDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DefaultNavbar', 'query', variables);
    },
    Posts(variables?: PostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PostsQuery>(PostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Posts', 'query', variables);
    },
    Post(variables: PostQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PostQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PostQuery>(PostDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Post', 'query', variables);
    },
    PostsSitemap(variables?: PostsSitemapQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PostsSitemapQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PostsSitemapQuery>(PostsSitemapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PostsSitemap', 'query', variables);
    },
    Redirect(variables: RedirectQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RedirectQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RedirectQuery>(RedirectDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Redirect', 'query', variables);
    },
    StaticPage(variables: StaticPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StaticPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StaticPageQuery>(StaticPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'StaticPage', 'query', variables);
    },
    Terms(variables: TermsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TermsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TermsQuery>(TermsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Terms', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;